























































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { mixins } from 'vue-class-component'
import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import Apis from '@/Apis/_'
import ReservaDeSangueStore from '@/components/SolicitacaoCirurgia/store/ReservaDeSangueStore'
import SolicitacaoCirurgiaStore from '@/components/SolicitacaoCirurgia/store/SolicitacaoCirurgiaStore'
import SolicitacaoStore from '@/components/SolicitacaoCirurgia/store/SolicitacaoStore'
import { solicitacaoStoreMiddleware } from '@/components/SolicitacaoCirurgia/store/solicitacao-store-middleware'
import { SolicitacaoCirurgia,
  RequestMessage,
  HonorarioMedicoEnum,
  Hemocomponente,
  PrecaucoesEnum,
  Procedimento,
  Equipamento,
  MedicoSolicitanteEnum,
  GrupoOpme,
  TipoPacienteEnum,
  GrupoOpmes,
  OpmeMaterial,
  Fornecedor,
  Convenio,
  LocalAtendimento,
  AnestesistaHospital,
  TipoLesaoQuantidade } from '@/types/_'
import { IProtocoloKitOpme, IProtocoloMateriaisPorGrupoV2Solicitacao, IProtocoloMaterialDoKitV2, SolicitacaoOpme } from '@/types/interfaces/protocolo/protocolo.interface'
import { getUfs, timeout, replaceRange, hideEmail, allowOnlyNumbersThatDoNotStartWithZero, onlyNumber, validateTelefoneForm, validateTelefone, validateEmail, validateCPF, validateEmailForm, timeoutDefault, displayLateralidade, bytesToMegabytes, validateCPFCNPJ, onlyFloat, minutesToHours, onlyAlphaNumeric, maskPhoneNumber, acCamargoNetwork, ApiRequestWithRetry, getSnackbarMessage, formatAnonymizedPhoneNumber, idadeGestacionalMax, limitarIdadeGestacionalCommon } from '@/utils/common'
import { adicionarDiasUteisComFeriados } from '@/utils/calcularData'
import moment from 'moment'
import { buildSurgerySchedulingLimitParams, getInvalidSchedulingDates, isInvalidSchedulingDate, SurgerySchedulingLimitParams } from '@/services/surgery-scheduling-limit.service'
import _ from 'lodash'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import EventBus from '@/plugins/EventBus'
import HonorarioAnestesistaEnum from '@/types/enum/HonorarioAnestesistaEnum'
import TipoDocumentoBuscaPacienteEnum from '@/types/enum/TipoDocumentoBuscaPacienteEnum'
import ReservaSalaStore from '@/components/ReservaSala/Store/ReservaSalaStore'
import processPdfFile from '@/utils/processPdfFile'
import processImageFile from '@/utils/processImage'
import { ModalManagerMixin } from '@/mixins/modal'
import { kitOpmeStore, OrigemKitMateriais } from '@/components/SolicitacaoCirurgia/store/KitOpmeStore'
import BackofficeComorbidadesStore from '@/components/Backoffice/Store/BackofficeComorbidadeStore'
import { useMedicos, useHospitais } from '@/composables'
import SuporteSalasRoboticasStore from '@/components/Suporte/Store/SuporteSalasRoboticasStore'
import RecursosHospitalaresStore from '../components/RecursosHospitalares/Store/RecursosHospitalaresStore'

interface VDatePicker extends Vue {
  save(date: any): any
}

@Component
export default class ViewSolicitacaoCirurgia extends mixins(ModalManagerMixin) {
  finishedLoad = false
  lastValidationCodTuss: string | null = null

  readonly idadeGestacionalMax = idadeGestacionalMax

  ViewModal = {
    KIT_OPME: 'modal-kit-opme',
    OLD_KIT_OPME: 'modal-opme',
  }

  get kitsMateriais() {
    return kitOpmeStore.kits
  }

  get modalKitOpmeTitle() {
    const titles : Record<OrigemKitMateriais, string> = {
      [OrigemKitMateriais.Protocolo]: 'Kit de materiais - Protocolo',
      [OrigemKitMateriais.Medico]: 'Meus kits de materiais',
    }

    return (kitOpmeStore.origem && titles[kitOpmeStore.origem]) || ''
  }

  get modalKitOpmePermissions() {
    if (kitOpmeStore.protocolo) return {}

    return {
      criar: this.getSolicitacaoCirurgiaStore.canShowCriarOpmeBtn,
      editar: this.getSolicitacaoCirurgiaStore.canShowEditKitOpmeBtn,
      clonar: this.getSolicitacaoCirurgiaStore.canShowCloneKitOpmeBtn,
      excluir: this.getSolicitacaoCirurgiaStore.canShowDeleteKitOpmeBtn,
    }
  }

  notifyError(message: string) {
    EventBus.$emit('setSnackbar', getSnackbarMessage(message, 'error'))
  }

  notifySuccess(message: string) {
    EventBus.$emit('setSnackbar', getSnackbarMessage(message, 'success'))
  }

  async onVisualizarKitsPorProtocolo(protocoloId) {
    EventBus.$emit('setLoadingRequest', { status: true, text: 'Carregando kits do protocolo' })

    const protocolo = await this.getSolicitacaoCirurgiaStore.obterProtocolo(protocoloId)
    if (!protocolo) {
      this.notifyError('Não foi possível obter o protocolo.')
      return
    }

    kitOpmeStore.processarKitsProtocolo(protocolo)

    EventBus.$emit('clearLoadingRequest')
    this.openModal(this.ViewModal.KIT_OPME, { trigger: 'protocolo' })
  }

  async onVisualizarKits() {
    if (!this.temProcedimentoPrincipal) {
      this.notifyError('Procedimento principal não foi selecionado.')
      return
    }

    this.loadingModalOPME = true

    if (this.getSolicitacaoCirurgiaStore.canLoadKitDeMaterialDoMedico) {
      const kits = await this.getSolicitacaoCirurgiaStore.obterKitMateriaisPersonalizados()
      kitOpmeStore.processarKitsPersonalizados(kits)
    } else {
      kitOpmeStore.processarKitsProtocolo(this.getSolicitacaoCirurgiaStore.selectedProtocolo)
    }

    this.loadingModalOPME = false
    this.openModal(this.ViewModal.KIT_OPME, { trigger: 'materiais' })
  }

  async upsertKit(kit) {
    if (kitOpmeStore.versao === 'v1') {
      this.getSolicitacaoCirurgiaStore.upsertGrupoDeOpme(kit)
    }

    if (kitOpmeStore.versao === 'v2') {
      this.getSolicitacaoCirurgiaStore.upsertGrupoDeOpmeV2(kit)
    }
  }

  async onUtilizarKit({ id }) {
    const metadata = this.getModalMetadata(this.ViewModal.KIT_OPME)
    if (!metadata) return

    const kit = kitOpmeStore.obterKitPorId(id)
    if (!kit) {
      this.notifyError('Kit não encontrado.')
      return
    }

    const { trigger } = metadata
    if (trigger === 'protocolo') {
      const protocoloId = kitOpmeStore.protocolo && kitOpmeStore.protocolo.id
      await this.getSolicitacaoCirurgiaStore.acceptSugestaoDeProtocolo(protocoloId)
      await this.upsertKit(kit)
      this.getSolicitacaoCirurgiaStore.setShowModalSugestaoDeProtocolo(false)
      this.getSolicitacaoStore.setShowModalProcedimentoPrincipal(false)
      this.notifySuccess('Kit de materiais e protocolo adicionados com sucesso.')
    }

    if (trigger === 'materiais') {
      await this.upsertKit(kit)
    }

    this.closeModal(this.ViewModal.KIT_OPME)
  }

  async onCriarKit() {
    const modal = this.$refs[this.ViewModal.OLD_KIT_OPME]
    if (!modal) return

    modal.criarKit()
  }

  async onEditarKit({ id }) {
    const kit = kitOpmeStore.obterKitPorId(id) as IProtocoloKitOpme
    const modal = this.$refs[this.ViewModal.OLD_KIT_OPME]
    if (!kit || !modal) return

    modal.editKit({
      id: kit.id,
      descricao: kit.nome,
      opmes: kit.opmes,
    })
  }

  async onClonarKit({ id }) {
    const modal = this.$refs[this.ViewModal.OLD_KIT_OPME]
    const kit = kitOpmeStore.obterKitPorId(id) as IProtocoloKitOpme
    if (!modal || !kit) return

    modal.cloneKit({
      id: kit.id,
      descricao: kit.nome,
      opmes: kit.opmes,
    })
  }

  async onExcluirKit({ id }) {
    const modal = this.$refs[this.ViewModal.OLD_KIT_OPME]
    if (!modal) return

    modal.setKitDeMateriaisToDelete(id)
  }

  onUpdateKits(kits) {
    kitOpmeStore.processarKitsPersonalizados(kits)
  }

  $refs!: {
    firstStepAuthorizationTabForm: any
    secondStepAuthorizationTabForm: any
    firstStepperForm: any
    secondStepperForm: any
    thirdStepperForm: any
    opmeForm: any
    protocoloForm: any
    documentosObrigatoriosForm: any
    rne: any
    cpfResponsavel: any
    livro: any
    folha: any
    termo: any
    dtPicker1: any
    picker: VDatePicker
    picker2: VDatePicker
    menu: VDatePicker
    menu2: VDatePicker
    birthDateFieldAuthorizationTabMenu: VDatePicker

    computedDate: any
    modalReservaDeSangue: any
    modalDataCirurgia: any
    tempoDeDoencaAnos: any
    tempoDeDoencaMeses: any
    tempoDeDoencaDias: any
    reservaUTI: any
    tempoCirurgia: any
    horasDeAntecedenciaDeInternacao: any
    concentradoHemaciasQtde: any,
    concentradoPlaquetasQtde: any,
    crioprecipitadoQtde: any,
    plasmaFrescoCongeladoQtde: any,
    tipagemSanguineaABORHPAIQtde: any,
  }

  loadingSearchPatient: boolean = false
  loadCPF: boolean = false
  loadClosePage: boolean = false
  loadModalOPME: boolean = false
  loadSaveOrUpdate: boolean = false
  loadSaveOrUpdateSecondStep: boolean = false
  loadSaveOrUpdateThirdStep: boolean = false
  loadContinueLater: boolean = false
  loadDelete: boolean = false
  loadConfirmDelete: boolean = false
  loadCid: boolean = false
  loadProcedimentoPrincipal: boolean = false
  loadProcedimentoAssociado: boolean = false
  loadTipoLesao: boolean = false
  loadEquipamento: boolean = false
  ldInstrumental: boolean = false
  loadReservaDeSangue: boolean = false
  loadAnexoDelete: string = ''
  loadDocDelete: string = ''
  loadDocDiversosDelete: string = ''
  loadTermoDeConsentimentoDelete: string = ''
  loadConvenio: boolean = false
  loadCategoria: boolean = false
  loadDeleteOpme: string = ''
  loadGradeMedica: boolean = false
  loadBuscarPaciente: boolean = false
  loadAddCaixaCirurgica: boolean = false
  loadDeleteCaixaCirurgica: string = ''
  loadAddAnestesista: boolean = false
  menu: boolean = false
  menu2: boolean = false
  birthDateFieldAuthorizationTabMenu: boolean = false
  up: string[] = []
  upDoc: string[] = []
  upDocDiversos: string[] = []
  upTermoDeConsentimento: string[] = []
  files: any[] = []
  docs: any[] = []
  docsDiversos: any[] = []
  docsTermos: any[] = []
  laudos: any[] = []
  docPaciente: any[] = []
  place: string = ''
  instList: boolean = false
  confirmarExclusao: boolean = false
  tipoDocumentoBuscaPaciente: TipoDocumentoBuscaPacienteEnum = TipoDocumentoBuscaPacienteEnum.CPF
  dialogRghNaoEncontrado: boolean = false
  dialogMsgRghNaoEncontrado: string = ''
  rghNaoAlterado: string | null
  outrosTipoAnestesia: string
  ufs: any[] = [...getUfs()]
  convenioParticular: boolean = false
  usarRecursoApa : boolean = false
  invalidSchedulingDates: { data: string }[] = []

  errorMessage: any = {
    errorCids: '',
    errorProcedimento: '',
    errorDocumentacaoPaciente: '',
    errorDocumentosDiversos: '',
    errorTermoDeConsentimento: '',
    errorAnexo: '',
    errorAnestesistaLista: '',
    errorTipoLesao: '',
  }

  firstStepperRules: any = {
    valid: true,
    nome: [],
    convenio: [],
    plano: [],
    categoria: [],
    tipoAcomodacao: [],
    cpf: [],
    rgh: [],
    cpfResponsavel: [],
    altura: [],
    peso: [],
    passaporte: [],
    nacionalidade: [],
    numeroDoAtendimentoAoPacienteNoHospital: [],
    horasDeAntecedenciaDeInternacao: [],
  }

  secondStepperRules: any = {
    valid: true,
    anatomiaPatologica: [],
    anatomiaPatologicaHospitalOuParticular: [],
    anatomiaPatologicaParticularLocal: [],
    biopsia: [],
    biopsiaHospitalOuParticular: [],
    biopsiaParticularLocal: [],
    concentradoHemacias: [],
    concentradoPlaquetas: [],
    crioprecipitado: [],
    plasmaFrescoCongelado: [],
    tipagemSanguineaABORHPAI: [],
    ultrassonografiaIntraoperatoria: [],
    outros: [],
    especificarPrecaucoes: [],
    medicamentosEspeciaisEspecificar: [],
    medicacaoContinuaEspecificar: [],
    instrumentadorExternoEspecificar: [],
    equipeMedicaEspecificar: [],
    opmeDoConsultorioEspecificar: [],
    internacaoDeVesperaEspecificar: [],
    previsaoUsoQuimioterapicoEspecificar: [],
    codigoPrestador: [],
    honorarioMedicoDocumento: [],
    honorarioAnestesistaDocumento: [],
    medicoConvidadoNome: [],
    medicoConvidadoCrm: [],
    nomeAnestesista: [],
    anestesistaCrm: [],
    anestesistaLista: [],
    opcaoDataPrevisto1: [],
    tempoDeDoenca: [],
    idadeGestacional: [],
    gemelar: [],
    diaria: [],
    diariaUti: [],
    justificativa: [],
    necessidadesEspeciais: [],
    restricaoReligiosa: [],
    necessidadesPsicologicas: [],
    necessidadesMedicasEspeciais: [],
    necessidadesEconomicas: [],
    necessidadesSociais: [],
    exameFisicoEResultadoDeExames: [],
    justificativaDePrazo: [],
    regiaoDaCirurgia: [],
    tecnicaDoProcedimento: [],
    tipoAnestesia: [],
    comorbidade: [],
    complexidade: [],
    classificacaoPacienteOncologico: [],
    pacienteEstaInternado: [],
  }

  hasSurgeryTeam: 1 | 0 | '1' | '0'

  thirdStepperRules: any = {
    valid: true,
    plano: [],
    categoria: [],
    tipoAcomodacao: [],
    carteirinha: [],
  }

  lateralidades: any[] = [
    { key: 'Esquerdo', display: 'Esquerdo' },
    { key: 'Direito', display: 'Direito' },
    { key: 'Bilateral', display: 'Bilateral' },
    { key: 'NaoAplica', display: 'Não se aplica' },
  ]

  guiaMedicaFields: string[] = ['laudosGuiaAutorizacao', 'cpfGuiaAutorizacao']

  fileUploadLimitInMegaBytes = 25
  isUploadRecommendationModalOpen = false
  isFileTypeWarningModalOpen = false
  isSurgeryGridModalOpen: boolean = false
  isRoomSchedulingModalOpen: boolean = false
  isIgnoreReservationModalOpen: boolean = false
  suggestedSurgeryDateWithOPME: string | null = null
  suggestedSurgeryDateWithoutOPME: string | null = null
  firstStepAuthorizationTabFormRules = {
    carteirinha: [(v: any) => !!v || 'Campo obrigatório'],
    // cpf: [(v: any) => this.validateCpfAuthorizationTab(v)],
    cpf: [] as Array<(v: any) => true | string>,
    nomePaciente: [(v: any) => !!v || 'Campo obrigatório'],
    dataNascimento: [(v: any) => !!v || 'Campo obrigatório'],
    sexo: [(v: any) => !!v || 'Campo obrigatório'],
    celular: [] as Array<(v: any) => true | string>,
    email: [] as Array<(v: any) => true | string>,
    telefone: [] as Array<(v: any) => true | string>,
  }

  debouncedFetchSurgerySolicitationEligibilityInfo = _.debounce(async () => {
    await this.fetchSurgerySolicitationEligibilityInfo()
  }, 2000)

  get solicitacaoTemOpme() {
    return this.solicitacaoCirurgia.grupoDeOpme
      && this.solicitacaoCirurgia.grupoDeOpme.opmes
      && this.solicitacaoCirurgia.grupoDeOpme.opmes.length > 0
  }

  secondStepAuthorizationTabFormRules = {
    carater: [(v: any) => !!v || 'Campo obrigatório'],
    diagnosticoJustificativa: [(v: any) => !!v || 'Campo obrigatório'],
    lateralidade: [(v: any) => !!v || 'Campo obrigatório'],
    tipoProcedimento: [(v: any) => !!v || 'Campo obrigatório'],
    diaria: [(v: any) => !!v || 'Campo obrigatório'],
    tecnicaDoProcedimento: [(v: any) => !!v || 'Campo obrigatório'],
    justificativaTecnica: [(v: any) => this.validateJustificativaTecnica(v)],
    resultadosDeExames: [v => (v && v.length <= 2000) || 'O texto não pode exceder 2000 caracteres.',
    ],
  }

  validateJustificativaTecnica(value: any) {
    if (
      this.solicitacaoTemOpme
      && this.getTemplate.justificativaTecnica.habilitado
      && this.getTemplate.justificativaTecnica.obrigatorio
      && !value
    ) {
      return 'Campo obrigatório'
    }
    return false
  }

  disabledPatientContactInformationFields: boolean = false
  disabledPatientCpfField: boolean = false
  disabledPatientCarteirinhaField: boolean = false

  nomeCirurgiaRule = [(v: any) => !!v || 'Campo obrigatório']
  foreignerDocumentFieldRule = [(v: any) => !!v || 'Campo obrigatório']
  editModelMode = false
  budgetMode = false
  anestesistasOptions: AnestesistaHospital[] = []

  get outroAnestesista() { return this.getSolicitacaoCirurgiaStore.outroAnestesista }
  set outroAnestesista(value: string) { this.getSolicitacaoCirurgiaStore.setOutroAnestesista(value) }

  get doctors() {
    return useMedicos.medicosByCurrentUser
  }

  get hospitalUtilizaRegraDeMedicoExecutante() {
    return useMedicos.hospitalUtilizaRegraDeMedicoExecutante
  }

  get medicoPrescritorEhConfiguradoParaExecutarCirurgias() {
    return useMedicos.medicoPrescritorEhConfiguradoParaExecutarCirurgias
  }

  get hospitalNaoPossuiMedicosExecutantesConfigurados() {
    return useMedicos.hospitalNaoPossuiMedicosExecutantesConfigurados
  }

  // Nova regra: campo obrigatório quando template não obrigatório E médico prescritor não pode executar
  get medicoExecutanteObrigatorioPorRegra() {
    // Se hospital não utiliza regra, retorna false
    if (!this.hospitalUtilizaRegraDeMedicoExecutante) {
      return false
    }

    // Verifica se template está como não obrigatório
    const templateNaoObrigatorio = !this.campoObrigatorio('medicoExecutante')

    // Verifica se médico prescritor não pode executar cirurgias
    const medicoPrescritorNaoPodeExecutar = !this.medicoPrescritorEhConfiguradoParaExecutarCirurgias

    // Campo obrigatório quando: template não obrigatório E médico prescritor não pode executar
    return templateNaoObrigatorio && medicoPrescritorNaoPodeExecutar
  }

  get medicoExecutanteRules() {
    // Se hospital utiliza regra, sempre obrigatório OU se aplica nova regra
    if (this.hospitalUtilizaRegraDeMedicoExecutante || this.medicoExecutanteObrigatorioPorRegra) {
      return [v => !!v || 'Campo obrigatório']
    }
    return this.secondStepperRules.medicoExecutante || []
  }

  get medicoExecutanteLabel() {
    const baseLabel = 'Médico Executante'
    // Se hospital utiliza regra OU se aplica nova regra, adiciona asterisco
    if (this.hospitalUtilizaRegraDeMedicoExecutante || this.medicoExecutanteObrigatorioPorRegra) {
      return `${baseLabel} *`
    }
    return this.campoObrigatorioLabel(baseLabel, 'medicoExecutante')
  }

  async fetchMedicosExecutantes() {
    await useMedicos.loadMedicosExecutantesHospitais({
      params: {
        medicoPrescritorId: this.solicitacaoCirurgia.medicoSolicitanteId,
        hospitalId: this.getSolicitacaoCirurgiaStore.hospitalId,
      },
    })
  }

  opmeV2UpdateValidationTimeout: any = null

  get currentCountry() {
    if (this.solicitacaoCirurgia.paciente.paisId) {
      return this.getSolicitacaoCirurgiaStore.paises.find(c => c.id === this.solicitacaoCirurgia.paciente.paisId)
    }
    return this.getSolicitacaoCirurgiaStore.paisesJson.find(c => c.isoCode === 'br')
  }

  validateFornecedorOpme(value: any, field: string) {
    if (this.getSolicitacaoCirurgiaStore.segueOProtocolo) {
      if (field === 'fornecedor1Id') {
        return !!value || 'Campo obrigatório.'
      }
      return true
    }

    // Id do fornecedor 'Não Informado'
    const NAO_INFORMADO = '50a949cc-7c46-4f86-a160-90b95371b542'
    const { obrigatorio, permiteNaoInformado } = this.getTemplate.opmes[field]
    if (value === NAO_INFORMADO && !permiteNaoInformado) return 'Por favor, informe um fornecedor válido.'
    return obrigatorio
      ? (!!value || 'Campo obrigatório.')
      : true
  }

  opmeRules = {
    id: [v => !!v || 'Campo obrigatório'],
    particular: [v => !!v || 'Campo obrigatório'],
    quantidade: [v => !!Number(v) || 'Campo obrigatório'],
    fornecedor1: [(v: any) => this.validateFornecedorOpme(v, 'fornecedor1Id')],
    fornecedor2: [(v: any) => this.validateFornecedorOpme(v, 'fornecedor2Id')],
    fornecedor3: [(v: any) => this.validateFornecedorOpme(v, 'fornecedor3Id')],
    especificidade: [v => !!v || 'Campo obrigatório'],
    medidaTamanho: [(v: any) => this.getOPMEMeasureFieldRules(v)],
  }

  anestesistaHospitalRule = {
    outroAnestesista: [(v: any) => this.validateOutroAnestesista(v)],
  }

  tipoAnestesiaRule = {
    outrosTipoAnestesia: [(v: any) => this.validateOutrosTipoAnestesia(v)],
  }

  validateTipoAnestesia(value: any) {
    return this.getSolicitacaoCirurgiaStore.tipoAnestesiaCheckbox.length === 0
  }

  validateOutroAnestesista(value: any) {
    if (this.solicitacaoCirurgia.anestesista === 'Outros' && !this.outroAnestesista) {
      return 'Por favor, informe outro anestesista.'
    }
    return true
  }

  validateOutrosTipoAnestesia(value: any) {
    if (this.getSolicitacaoCirurgiaStore.tipoAnestesiaCheckbox.includes('Outros') && !this.getSolicitacaoCirurgiaStore.outrosTipoAnestesia) {
      return 'Por favor, informe o outro tipo de anestesia.'
    }
    return true
  }

  comorbidadesDoPacienteRules = {
    comorbidade: [(v: any) => this.validateComorbidadesDoPacienteObrigatorio()],
  }

  get campoPesoHabilitado() {
    const { formulario } = this.getSolicitacaoCirurgiaStore.currentTemplate

    if (this.campoHabilitado('peso')) {
      if (formulario.peso && formulario.peso.visivelSomentePacienteAte15Anos) {
        const habilitado = this.getIdade && this.getIdade <= 15

        if (!habilitado) this.getSolicitacaoCirurgiaStore.setPesoDoPaciente(null)
        return habilitado
      }
      return true
    }
    return false
  }

  get campoAlturaHabilitado() {
    const { formulario } = this.getSolicitacaoCirurgiaStore.currentTemplate

    if (this.campoHabilitado('altura')) {
      if (formulario.altura && formulario.altura.visivelSomentePacienteAte15Anos) {
        const habilitado = this.getIdade && this.getIdade <= 15
        if (!habilitado) this.getSolicitacaoCirurgiaStore.setAlturaDoPaciente(null)
        return habilitado
      }
      return true
    }
    return false
  }

  atualizaPreferenciaRecursoApa(usarRecurso: boolean) {
    this.usarRecursoApa = usarRecurso
  }

  getSolicitacaoCirurgia() {
    return this.solicitacaoCirurgia
  }

  async canShowResourceApa() {
    const { hospitalId, medicoSolicitanteId: medicoId, procedimento: principal, procedimentosAssociados: associados, apa } = this.solicitacaoCirurgia
    if ((apa && !apa.notificacaoEnviada) || !apa) {
      const cods: any[] = []
      if (principal && principal.id !== '' && !!associados) {
        if (associados.length > 0) {
          associados.forEach((e: Procedimento) => cods.push(e.codigo))
        }
        cods.unshift(principal.codigo)
      }
      const resourceName = this.getRecursosHospitalaresStore.getResourceValue('ViewSolicitacaoCirurgia', 'Apa')
      if (hospitalId && medicoId && resourceName) {
        await this.getRecursosHospitalaresStore.getValidaAcessoRecurso({ hospitalId, medicoId, resourceName, cods })
      }
    }
  }

  validatePesoObrigatorio(value: any) {
    const num: any = parseInt(value, 10)
    const { formulario } = this.getSolicitacaoCirurgiaStore.currentTemplate
    return (Number.isNaN(num) || num < 1) && formulario.peso && formulario.peso.habilitado && formulario.peso.obrigatorio
      ? 'Campo obrigatório'
      : false
  }

  validateAlturaObrigatorio(value: any) {
    const num: any = parseInt(value, 10)
    const { formulario } = this.getSolicitacaoCirurgiaStore.currentTemplate
    return (Number.isNaN(num) || num < 1) && formulario.altura && formulario.altura.habilitado && formulario.altura.obrigatorio
      ? 'Campo obrigatório'
      : false
  }

  async fetchComorbidades() {
    this.getComorbidadeStore.setHospitalId(this.solicitacaoCirurgia.hospitalId)
    await this.getComorbidadeStore.getComorbidadesByHospitalId(this.solicitacaoCirurgia.hospitalId)
  }

  comorbidadesDoPacienteHabilitado() {
    const { formulario } = this.getSolicitacaoCirurgiaStore.currentTemplate

    if (this.campoHabilitado('comorbidadesDoPaciente')) {
      if (formulario.comorbidadesDoPaciente && formulario.comorbidadesDoPaciente.visivelSomentePaciente70Anos) {
        const habilitado = this.getIdade && this.getIdade >= 70
        return habilitado
      }
      return true
    }

    return false
  }

  get comorbidadesObrigatorio() {
    if (this.campoHabilitado('comorbidadesDoPaciente')) {
      const { formulario } = this.getSolicitacaoCirurgiaStore.currentTemplate
      if (formulario.comorbidadesDoPaciente && formulario.comorbidadesDoPaciente.obrigatorio) {
        return true
      }
      if (this.getIdade && this.getIdade >= 70) {
        return true
      }
    }
    return false
  }

  validateComorbidadesDoPacienteObrigatorio() {
    const { formulario } = this.getSolicitacaoCirurgiaStore.currentTemplate
    const hasValue = this.getSolicitacaoCirurgiaStore.comorbidadesDoPacienteCheckbox && this.getSolicitacaoCirurgiaStore.comorbidadesDoPacienteCheckbox.length > 0
    if (this.getIdade && this.getIdade >= 70 && !hasValue) {
      return 'Campo obrigatório'
    }
    if (!hasValue && formulario.comorbidadesDoPaciente && formulario.comorbidadesDoPaciente.habilitado && formulario.comorbidadesDoPaciente.obrigatorio) {
      return 'Campo obrigatório'
    }

    return null
  }

  protocoloRules = {
    protocoloDeCirurgiaId: [v => !!v || 'Campo obrigatório'],
    tecnicaDeCirurgiaId: [v => this.validateProtocoloTecnicaDeCirurgiaId(v)],
  }

  tipoDocumentoBuscaPacienteChange() {
    if (!this.solicitacaoCirurgia.paciente.id) {
      if (this.tipoDocumentoBuscaPaciente === TipoDocumentoBuscaPacienteEnum.CPF) {
        this.solicitacaoCirurgia.paciente.rgh = null
      }
    }
  }

  async setTipoDocumentoBuscaPacienteByTemplate() {
    if (this.campoHabilitado('cpf') && this.campoHabilitado('rgh')) {
      this.tipoDocumentoBuscaPaciente = this.getTemplate.cpf && this.getTemplate.cpf.principal ? TipoDocumentoBuscaPacienteEnum.CPF : TipoDocumentoBuscaPacienteEnum.RGH
    } else if (this.getTemplate.cpf && this.getTemplate.cpf.habilitado) {
      this.tipoDocumentoBuscaPaciente = TipoDocumentoBuscaPacienteEnum.CPF
    } else if (this.getTemplate.rgh && this.getTemplate.rgh.habilitado) {
      this.tipoDocumentoBuscaPaciente = TipoDocumentoBuscaPacienteEnum.RGH
    }
  }

  validateProtocoloTecnicaDeCirurgiaId(value: string) {
    if (this.getSolicitacaoCirurgiaStore.isRequiredChooseTecnicaDeCirurgia) {
      return (!!value || 'Campo obrigatório')
    }
    return true
  }

  documentosObrigatoriosRules = {
    medicoConfirmaQueAnexouOsDocumentos: [v => !!v || 'Campo obrigatório'],
  }

  // #region Suggested equipments

  suggestedEquipments: Equipamento[] = []
  selectedSuggestedEquipments: Equipamento[] = []

  get patientConctactInformationFields() {
    let email
    let phone
    let cellphone

    if (this.enableAuthorizationTab) {
      email = {
        label: this.firstStepAuthorizationTabFormLabel.email,
        rules: this.firstStepAuthorizationTabFormRules.email,
        disabled: this.step0Disabled || this.disabledPatientContactInformationFields,
      }

      phone = {
        label: this.firstStepAuthorizationTabFormLabel.phone,
        rules: this.firstStepAuthorizationTabFormRules.telefone,
        disabled: this.step0Disabled || this.disabledPatientContactInformationFields,
      }

      cellphone = {
        label: this.firstStepAuthorizationTabFormLabel.cellphone,
        rules: this.firstStepAuthorizationTabFormRules.celular,
        disabled: this.step0Disabled || this.disabledPatientContactInformationFields,
      }
    } else {
      email = {
        label: this.campoObrigatorioLabel('Email', 'email'),
        rules: this.thirdStepperRules.email,
        disabled: this.step1Disabled || this.pacienteInfoDisabled('email'),
      }

      phone = {
        label: this.campoObrigatorioLabel('Telefone', 'telefone'),
        rules: this.thirdStepperRules.telefone,
        disabled: this.step1Disabled || this.pacienteInfoDisabled('telefone'),
      }

      cellphone = {
        label: this.campoObrigatorioLabel('Celular', 'celular'),
        rules: this.thirdStepperRules.celular,
        disabled: this.step1Disabled || this.pacienteInfoDisabled('celular'),
      }
    }

    return { email, phone, cellphone }
  }

  get firstStepAuthorizationTabFormLabel() {
    return {
      email: this.disabledPatientContactInformationFields ? 'Email' : 'Email *',
      phone: this.disabledPatientContactInformationFields ? 'Telefone' : 'Telefone *',
      cellphone: this.disabledPatientContactInformationFields ? 'Celular' : 'Celular *',
    }
  }

  async addSelectedSuggestedEquipments() {
    // To do: Add suggested equipments in equipments list and set in back-end
    EventBus.$emit('setLoadingRequest', { status: this.getSolicitacaoStore.requestMessage.status, text: this.getSolicitacaoStore.requestMessage.post })

    const promises: Promise<any>[] = []
    this.selectedSuggestedEquipments.forEach((selectedEquipment) => {
      this.getSolicitacaoStore.removeEquipamentoApi(selectedEquipment) // Remove from modal add list
      promises.push(this.getSolicitacaoStore.postEquipamento(selectedEquipment))
    })

    await Promise.all(promises)

    // Remove the equipments from suggested list when finalize the add
    this.selectedSuggestedEquipments.forEach((selectedEquipment) => {
      const equipmentIndex = this.suggestedEquipments.findIndex(suggestedEquipment => suggestedEquipment.id === selectedEquipment.id)
      if (equipmentIndex !== -1) {
        this.suggestedEquipments.splice(equipmentIndex, 1)
      }
    })

    this.selectedSuggestedEquipments = []

    EventBus.$emit('clearLoadingRequest')
  }

  canUserDeleteOpme(OpmeType: 'OpmeOpcionalDoProtocolo' | 'OpmeDoKitDoProtocolo'): boolean {
    return this.getSolicitacaoCirurgiaStore.canDeleteOpmeDaListaDaCirurgia
            || ((OpmeType === 'OpmeOpcionalDoProtocolo') && this.getSolicitacaoCirurgiaStore.segueOProtocolo)
  }

  suppliers(opmeInfo: SolicitacaoOpme) {
    // Se não segue o protocolo deve retornar os fornecedores padrões
    // e quem faz essa regra é o this.getSolicitacaoCirurgiaStore.fornecedorOptions
    if (!this.getSolicitacaoCirurgiaStore.segueOProtocolo) {
      return this.getSolicitacaoCirurgiaStore.fornecedorOptions
    }

    const opmeSuppliers = opmeInfo.fornecedores
    const protocolSuppliers = this.getSolicitacaoCirurgiaStore.fornecedorOptions

    if (opmeSuppliers && opmeSuppliers.length > 0) {
      return opmeSuppliers.map<Fornecedor>(supplier => ({
        fornecedorId: supplier.fornecedorId,
        nome: supplier.fornecedorFabricante || supplier.fornecedorNome,
      } as Fornecedor))
    }

    return protocolSuppliers
  }

  materialCodificadoOptions(opmeInfo: IProtocoloMaterialDoKitV2) {
    return opmeInfo.materiaisCodificados
      .filter(elem => elem.fornecedor.fornecedorId === opmeInfo.selectedFornecedorId)
      .map((material) => {
        let nome = ''
        const nomeDetails = [material.especificidade || material.descricao, material.tamanho, material.modelo, material.codigoReferencia]
        nomeDetails.forEach((elem) => {
          if (elem) {
            nome += nome !== '' ? ` - ${elem}` : elem
          }
        })

        return {
          nome: nome || material.descricao,
          material,
        }
      })
  }

  getOPMEMeasureFieldRules(value) {
    if (this.OPMEMeasureFieldTemplateDetails.required) {
      return !!value || 'Campo obrigatório.'
    }
    return true
  }

  get OPMEMeasureFieldTemplateDetails() {
    const opmeTemplateInfo = this.getTemplateFieldDetails('opmes')
    return {
      enabled: opmeTemplateInfo && opmeTemplateInfo.medidaTamanho && opmeTemplateInfo.medidaTamanho.habilitado,
      required: opmeTemplateInfo && opmeTemplateInfo.medidaTamanho && opmeTemplateInfo.medidaTamanho.habilitado && opmeTemplateInfo.medidaTamanho.obrigatorio,
    }
  }

  opmeQuantityFieldRuleValidation(opmeInfo: SolicitacaoOpme, grupoMaterialProtocolo?: IProtocoloMateriaisPorGrupoV2Solicitacao) {
    const procedureLaterality = this.procedimentoPrincipal!.lateralidade
    const opmeMininumQuantity = opmeInfo.quantidadeMinima
    const opmeMaximumQuantity = opmeInfo.quantidadeMaxima

    let opmeRulesDefaultQuantityValidation
    if (opmeMininumQuantity === 0) {
      // eslint-disable-next-line eqeqeq
      opmeRulesDefaultQuantityValidation = [v => v != undefined || 'Campo obrigatório']
    } else {
      opmeRulesDefaultQuantityValidation = this.opmeRules.quantidade
    }

    const opmeBilateralProcedureMaximumQuantity = (
      opmeInfo.procedimentoBilateral && typeof opmeInfo.procedimentoBilateral.quantidadeMaxima === 'number'
    ) ? opmeInfo.procedimentoBilateral.quantidadeMaxima : null
    let opmeRuleMaximumQuantity

    if (
      opmeInfo.medicoPodeAlterarAQuantidade
      && this.getSolicitacaoCirurgiaStore.canShowProtocoloDeCirurgiaFields
      && (typeof opmeMininumQuantity === 'number' && opmeMininumQuantity >= 0)
      && (typeof opmeMaximumQuantity === 'number' && opmeMaximumQuantity >= 0)
    ) {
      const opmeRulesMinimumAndMaximumQuantityValidation = [
        // eslint-disable-next-line eqeqeq
        value => (value != undefined && value >= opmeMininumQuantity) || `Quantidade mínima: ${opmeInfo.quantidadeMinima}`,
      ]

      if (opmeBilateralProcedureMaximumQuantity && procedureLaterality === 'Bilateral') {
        opmeRuleMaximumQuantity = opmeBilateralProcedureMaximumQuantity
      } else {
        opmeRuleMaximumQuantity = opmeMaximumQuantity
      }

      opmeRulesMinimumAndMaximumQuantityValidation.push(
        // eslint-disable-next-line eqeqeq
        value => (value != undefined && value <= opmeRuleMaximumQuantity) || `Quantidade máxima: ${opmeRuleMaximumQuantity}`,
      )

      // Cria as regras para validar quantidade mínima e máxima do grupo de materiais
      if (
        grupoMaterialProtocolo
        && grupoMaterialProtocolo.quantidadeMinima! >= 0
        && grupoMaterialProtocolo.quantidadeMaxima! > 0
      ) {
        const groupRuleFn = (value) => {
          const currentUsedQuantityOfGroup = grupoMaterialProtocolo.materiais
            .map(elem => elem.quantidade)
            .reduce((a, b) => Number(a) + Number(b), 0)

          if (currentUsedQuantityOfGroup > grupoMaterialProtocolo.quantidadeMaxima!) {
            return `Quantidade máxima do grupo: ${grupoMaterialProtocolo.quantidadeMaxima}`
          }

          if (currentUsedQuantityOfGroup < grupoMaterialProtocolo.quantidadeMinima!) {
            return `Quantidade mínima do grupo: ${grupoMaterialProtocolo.quantidadeMinima}`
          }

          return true
        }

        opmeRulesMinimumAndMaximumQuantityValidation.push(groupRuleFn)
      }

      return [
        ...opmeRulesDefaultQuantityValidation,
        ...opmeRulesMinimumAndMaximumQuantityValidation,
      ]
    }

    return opmeRulesDefaultQuantityValidation
  }

  changeAllSuggestedEquipmentsCheckbox() {
    this.selectedSuggestedEquipments = this.suggestedEquipments.slice()
    this.addSelectedSuggestedEquipments()
  }

  changeSuggestedEquipmentCheckbox() {
    this.addSelectedSuggestedEquipments()
  }

  get queryParams() {
    return this.$route.query
  }

  get procedimentoButton() {
    if (this.procedimentoPrincipal!.id) {
      return { title: 'Editar', icon: 'edit' }
    }
    return { title: 'Adicionar', icon: 'add_circle' }
  }

  get canSelectSuggestedEquipments() {
    return this.suggestedEquipments.length > 0
  }

  get canEnableAddSuggestedEquipmentsButton() {
    return this.selectedSuggestedEquipments.length > 0
  }

  get canIndeterminateSuggestedEquipments() {
    if (
      !this.isAllSuggestedEquipmentsSelected
      && this.selectedSuggestedEquipments.length > 0
    ) {
      return true
    }

    return false
  }

  get isAllSuggestedEquipmentsSelected() {
    if (
      this.suggestedEquipments.length > 0
      && this.selectedSuggestedEquipments.length > 0
      && this.suggestedEquipments.length === this.selectedSuggestedEquipments.length
    ) {
      return true
    }

    return false
  }

  async resetSuggestedEquipments() {
    await this.getSolicitacaoStore.loadEquipamentos()
    this.suggestedEquipments = this.getSolicitacaoStore.equipamentosSugeridos
    this.selectedSuggestedEquipments = []
  }

  // #endregion Suggested equipments

  get canShowDefaultSaveButtons() {
    return !this.editModelMode && !this.budgetMode
  }

  get canShowStepperHeader() {
    return !this.editModelMode && !this.budgetMode
  }

  loadPreviaCirurgica: boolean = false

  get loadingPreviaCirurgica() {
    return this.loadPreviaCirurgica
  }

  set loadingPreviaCirurgica(value: boolean) {
    this.loadPreviaCirurgica = value
  }

  get loadingBuscarPaciente() {
    return this.loadBuscarPaciente
  }

  set loadingBuscarPaciente(value: boolean) {
    this.loadBuscarPaciente = value
  }

  get loadingAddCaixaCirurgica() {
    return this.loadAddCaixaCirurgica
  }

  set loadingAddCaixaCirurgica(value: boolean) {
    this.loadAddCaixaCirurgica = value
  }

  get loadingDeleteCaixaCirurgica() {
    return this.loadDeleteCaixaCirurgica
  }

  set loadingDeleteCaixaCirurgica(value: string) {
    this.loadDeleteCaixaCirurgica = value
  }

  get loadingAddAnestesista() {
    return this.loadAddAnestesista
  }

  set loadingAddAnestesista(value: boolean) {
    this.loadAddAnestesista = value
  }

  get loadingDeleteOpme() {
    return this.loadDeleteOpme
  }

  set loadingDeleteOpme(value: string) {
    this.loadDeleteOpme = value
  }

  get loadingInstrumental() {
    return this.ldInstrumental
  }

  set loadingInstrumental(value: boolean) {
    this.ldInstrumental = value
  }

  get instrumentalList() {
    return this.instList
  }

  set instrumentalList(value: boolean) {
    this.instList = value
  }

  get getInstrumental() {
    return this.getSolicitacaoCirurgiaStore.instrumentos
  }

  get getInstrumentalHeader() {
    return [
      { text: 'Item', class: 'table-headers', align: 'left', value: 'item' },
      { text: 'Quantidade', class: 'table-headers', align: 'center', value: 'quantidade' },
    ]
  }

  get surgeryTeamTypes() {
    return [
      { description: 'CRM', value: 'CRM' },
      { description: 'CRO', value: 'CRO' },
    ]
  }

  get loadingGradeMedica() {
    return this.loadGradeMedica
  }

  set loadingGradeMedica(value: boolean) {
    this.loadGradeMedica = value
  }

  get loadingConvenio() {
    return this.loadConvenio
  }

  set loadingConvenio(value: boolean) {
    this.loadConvenio = value
  }

  get loadingCategoria() {
    return this.loadCategoria
  }

  set loadingCategoria(value: boolean) {
    this.loadCategoria = value
  }

  get loadingCid() {
    return this.loadCid
  }

  set loadingCid(value: boolean) {
    this.loadCid = value
  }

  get loadingTipoLesao() {
    return this.loadTipoLesao
  }

  set loadingTipoLesao(value: boolean) {
    this.loadTipoLesao = value
  }

  get loadingAdicionaPaciente() {
    return this.loadCid
  }

  set loadingAdicionaPaciente(value: boolean) {
    this.loadCid = value
  }

  get loadingProcedimentoPrincipal() {
    return this.loadProcedimentoPrincipal
  }

  set loadingProcedimentoPrincipal(value: boolean) {
    this.loadProcedimentoPrincipal = value
  }

  get loadingProcedimentoAssociado() {
    return this.loadProcedimentoAssociado
  }

  set loadingProcedimentoAssociado(value: boolean) {
    this.loadProcedimentoAssociado = value
  }

  get loadingEquipamento() {
    return this.loadEquipamento
  }

  set loadingEquipamento(value: boolean) {
    this.loadEquipamento = value
  }

  get loadingReservaDeSangue() {
    return this.loadReservaDeSangue
  }

  set loadingReservaDeSangue(value: boolean) {
    this.loadReservaDeSangue = value
  }

  get loadingAnexoDelete() {
    return this.loadAnexoDelete
  }

  set loadingAnexoDelete(value: string) {
    this.loadAnexoDelete = value
  }

  get loadingDocDelete() {
    return this.loadDocDelete
  }

  set loadingDocDelete(value: string) {
    this.loadDocDelete = value
  }

  get loadingDocDiversosDelete() {
    return this.loadDocDiversosDelete
  }

  set loadingDocDiversosDelete(value: string) {
    this.loadDocDiversosDelete = value
  }

  get loadingTermoDeConsentimentoDelete() {
    return this.loadTermoDeConsentimentoDelete
  }

  set loadingTermoDeConsentimentoDelete(value: string) {
    this.loadTermoDeConsentimentoDelete = value
  }

  get getErrorMessage() {
    return this.errorMessage
  }

  set getErrorMessage(value: any) {
    this.errorMessage = value
  }

  get loadingSaveOrUpdate() {
    return this.loadSaveOrUpdate
  }

  set loadingSaveOrUpdate(value: boolean) {
    this.loadSaveOrUpdate = value
  }

  get loadingSaveOrUpdateSecondStep() {
    return this.loadSaveOrUpdateSecondStep
  }

  set loadingSaveOrUpdateSecondStep(value: boolean) {
    this.loadSaveOrUpdateSecondStep = value
  }

  get loadingSaveOrUpdateThirdStep() {
    return this.loadSaveOrUpdateThirdStep
  }

  set loadingSaveOrUpdateThirdStep(value: boolean) {
    this.loadSaveOrUpdateThirdStep = value
  }

  get loadingContinueLater() {
    return this.loadContinueLater
  }

  set loadingContinueLater(value: boolean) {
    this.loadContinueLater = value
  }

  get loadingDelete() {
    return this.loadDelete
  }

  set loadingDelete(value: boolean) {
    this.loadDelete = value
  }

  get loadingConfirmDelete() {
    return this.loadConfirmDelete
  }

  set loadingConfirmDelete(value: boolean) {
    this.loadConfirmDelete = value
  }

  get step1Disabled() {
    const e = this.$route.path.includes('/solicitacao-cirurgia-details')
    if (e) return true
    // @ts-ignore
    const secretariaSemPermissao = this.$user.profile.roles.includes('naoEditaSolicitacaoAmbulatorio')
    return secretariaSemPermissao
  }

  get step0Disabled() {
    const readOnlyPage = this.$route.path.includes('/solicitacao-cirurgia-details')
    const secretariaSemPermissao = this.$user.profile.roles.includes('naoEditaSolicitacaoAmbulatorio')

    if (readOnlyPage || secretariaSemPermissao) {
      return true
    }

    if (!this.enableAuthorizationFields) {
      return true
    }

    return false
  }

  get isSurgeryDateDisabled() {
    return this.step1Disabled
      || !!this.surgeryDateLimiterBlockReason
      || this.naoEditarInformacoesAdicionais
      || this.solicitacaoCirurgia.statusSituacao === 'PreReserva'
      || !this.enableAuthorizationFields
  }

  get surgeryDateLimiterBlockReason(): '' | 'complexidade' | 'centroCirurgico' {
    if (this.surgerySolicitationActions.checkSurgeryLimiter) {
      if (!this.solicitacaoCirurgia.complexidade) {
        return 'complexidade'
      }

      if (
        this.campoHabilitado('centroCirurgico')
        && this.campoObrigatorio('centroCirurgico')
        && !this.solicitacaoCirurgia.centroCirurgicoId
      ) {
        return 'centroCirurgico'
      }
    }

    return ''
  }

  get surgeryDateLimiterHint() {
    switch (this.surgeryDateLimiterBlockReason) {
      case 'complexidade':
        return 'Selecione a complexidade para habilitar o preenchimento da data prevista da cirurgia.'
      case 'centroCirurgico':
        return 'Selecione o centro cirúrgico para habilitar o preenchimento da data prevista da cirurgia.'
      default:
        return ''
    }
  }

  get patientSearchFieldsDisabled() {
    return this.step0Disabled || !this.enableAuthorizationFields || !!this.patientData.id
  }

  get isCpfAnonymized() {
    const cpf = this.solicitacaoCirurgia && this.solicitacaoCirurgia.paciente && this.solicitacaoCirurgia.paciente.cpf
    return !!(cpf && cpf.includes('#'))
  }

  get patientCpfDisabled() {
    return this.step0Disabled || !this.enableAuthorizationFields || this.disabledPatientCpfField || this.$route.params.solicitacaoId !== 'new'
  }

  get patientCarteirinhaDisabled() {
    return this.step0Disabled || !this.enableAuthorizationFields || this.disabledPatientCarteirinhaField || this.$route.params.solicitacaoId !== 'new'
  }

  get enableAuthorizationFields() {
    if (!this.enableAuthorizationTab || (this.enableAuthorizationTab && (this.$route.params.solicitacaoId === 'new'
    || (this.surgerySolicitationActions && this.surgerySolicitationActions.userCanEditAuthorizationTabFields)))) {
      return true
    }

    return false
  }

  disableSignAndSendSurgerySolicitationButton: boolean = false

  get surgerySolicitationActions() {
    let canSignAndSendSurgerySolicitation = this.solicitacaoCirurgia.acoes && this.solicitacaoCirurgia.acoes.podeFinalizarSolicitacao

    if (this.hasAuthorizationFlowEnabled) {
      canSignAndSendSurgerySolicitation = !this.disableSignAndSendSurgerySolicitationButton
    }

    return {
      canSuggestProtocolOnSurgeryInitialization: this.solicitacaoCirurgia.acoes && this.solicitacaoCirurgia.acoes.permiteSugerirProtocoloAoCarregarSolicitacao,
      userCanEditAuthorizationTabFields: this.solicitacaoCirurgia.acoes && this.solicitacaoCirurgia.acoes.podeEditarFormularioDaAutorizacao,
      canSignAndSendSurgerySolicitation,
      canSendSurgerySolicitationToAuthorizer: this.solicitacaoCirurgia.acoes && this.solicitacaoCirurgia.acoes.medicoPodeEnviarParaOAutorizador,
      doctorCanEditHospitalizedPatientData: this.solicitacaoCirurgia.acoes && this.solicitacaoCirurgia.acoes.permiteOMedicoEditarPacienteInternado,
      checkSurgeryLimiter: this.solicitacaoCirurgia.acoes && this.solicitacaoCirurgia.acoes.verificaLimitadorDeCirurgia,
    }
  }

  get sendSurgerySolicitationAuthorizationInfoDisabled() {
    return !this.surgerySolicitationActions.canSendSurgerySolicitationToAuthorizer
  }

  get enableSendSurgerySolicitationAuthorizationButton() {
    return this.$route.params.solicitacaoId !== 'new' && this.enableAuthorizationTab
  }

  get localAtendimentoId() {
    const localId = this.solicitacaoCirurgia.localAtendimentoId
    const local = this.locaisAtendimento.find((e: any) => e.id === localId)
    if (local && !local.ativo) this.placeHolder = local.nome
    return this.solicitacaoCirurgia.localAtendimentoId
  }

  set localAtendimentoId(value: string | null) {
    this.getSolicitacaoCirurgiaStore.setLocalAtendimentoId(value)
  }

  get locaisAtendimento() {
    return this.getSolicitacaoCirurgiaStore.locaisAtendimento
  }

  get naoEditarInformacoesAdicionais() {
    const localAtendimento = this.locaisAtendimento.find((e: LocalAtendimento) => e.id === this.localAtendimentoId)
    return localAtendimento && Boolean(localAtendimento.naoEditarInformacoesAdicionais)
  }

  get placeHolder() {
    return this.place
  }

  set placeHolder(value: string) {
    this.place = value
  }

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get getSolicitacaoCirurgiaStore() {
    return getModule(SolicitacaoCirurgiaStore, this.$store)
  }

  get getReservaDeSangueStore() {
    return getModule(ReservaDeSangueStore, this.$store)
  }

  get getSolicitacaoStore() {
    return getModule(SolicitacaoStore, this.$store)
  }

  get getSuporteSalasRoboticasStore() {
    return getModule(SuporteSalasRoboticasStore, this.$store)
  }

  get getComorbidadeStore() {
    return getModule(BackofficeComorbidadesStore, this.$store)
  }

  get comorbidadesList() {
    return this.getComorbidadeStore.comorbidades.filter(item => item.status === 'Ativo').map(item => ({ id: item.id || '', descricao: item.descricao }))
  }

  get getRecursosHospitalaresStore() {
    return getModule(RecursosHospitalaresStore, this.$store)
  }

  get solicitacaoCirurgia() {
    return this.getSolicitacaoCirurgiaStore.solicitacaoCirurgia
  }

  set solicitacaoCirurgia(value: SolicitacaoCirurgia) {
    this.getSolicitacaoCirurgiaStore.setSolicitacaoCirurgia(value)
  }

  get convenios() {
    return this.getSolicitacaoCirurgiaStore.convenios
  }

  get conveniosAssociados() {
    return this.getSolicitacaoCirurgiaStore.conveniosAssociados
  }

  get modelosCirurgia() {
    return this.getSolicitacaoCirurgiaStore.modelosCirurgia
  }

  get loadingCPF() {
    return this.loadCPF
  }

  set loadingCPF(value: boolean) {
    this.loadCPF = value
  }

  get loadingModalOPME() {
    return this.loadModalOPME
  }

  set loadingModalOPME(value: boolean) {
    this.loadModalOPME = value
  }

  get loadingClosePage() {
    return this.loadClosePage
  }

  set loadingClosePage(value: boolean) {
    this.loadClosePage = value
  }

  get step() {
    return this.getSolicitacaoCirurgiaStore.step
  }

  set step(value: number) {
    this.getSolicitacaoCirurgiaStore.setStep(value)
  }

  get computedDate() {
    return this.getSolicitacaoCirurgiaStore.solicitacaoCirurgia.paciente.dataNascimento
      ? moment(this.getSolicitacaoCirurgiaStore.solicitacaoCirurgia.paciente.dataNascimento).format('DD-MM-YYYY')
      : ''
  }

  get firstOptionSurgeryDate() {
    return this.solicitacaoCirurgia.opcaoDataPrevisto1 && moment(this.solicitacaoCirurgia.opcaoDataPrevisto1).format('DD-MM-yyyy HH:mm')
  }

  get minimumDate() {
    if (this.documentacaoObrigatoriaDoPaciente) {
      const { tipoPaciente } = this.solicitacaoCirurgia.paciente
      if (tipoPaciente === TipoPacienteEnum.MenorDe12) return `${moment().subtract(12, 'year').add(1, 'day').format('YYYY-MM-DD')}`
      if (tipoPaciente === TipoPacienteEnum.RecemNascido) return `${moment().subtract(28, 'days').format('YYYY-MM-DD')}`
      return `${moment().subtract(120, 'years').format('YYYY-MM-DD')}`
    }
    return `${moment().subtract(120, 'years').format('YYYY-MM-DD')}`
  }

  get getCids() {
    return this.getSolicitacaoStore.cids
  }

  get procedimentoPrincipal() {
    return this.getSolicitacaoStore.solicitacao.procedimento
  }

  get getProcedimentoAssociados() {
    return this.getSolicitacaoStore.solicitacao.procedimentosAssociados
  }

  get getTipoLesao() {
    return this.solicitacaoCirurgia.lesoes || []
  }

  get grupoDeOpme() {
    return this.getSolicitacaoCirurgiaStore.solicitacaoCirurgia.grupoDeOpme
  }

  get getExamesIntraOperatorios() {
    return this.getSolicitacaoCirurgiaStore.examesIntraOperatoriosCheckbox
  }

  set getExamesIntraOperatorios(value: any[]) {
    this.getSolicitacaoCirurgiaStore.setExamesIntraOperatoriosCheckbox(value)
  }

  get getHemocomponentes() {
    return this.getSolicitacaoCirurgiaStore.hemocomponentesCheckbox
  }

  set getHemocomponentes(value: string[]) {
    this.getSolicitacaoCirurgiaStore.setHemocomponentesCheckbox(value)
  }

  getComorbidadesDoPacienteInformacao(comorbidadeDescricao: string) {
    const comorbidade = this.getSolicitacaoCirurgiaStore.solicitacaoCirurgia.comorbidadesDoPaciente.find(item => item.descricao === comorbidadeDescricao)
    return comorbidade ? comorbidade.informacao : ''
  }

  get getComorbidadesDoPaciente() {
    return this.getSolicitacaoCirurgiaStore.comorbidadesDoPacienteCheckbox
  }

  set getComorbidadesDoPaciente(value: string[]) {
    this.getSolicitacaoCirurgiaStore.setComorbidadesDoPacienteCheckbox(value)
  }

  get getTipoAnestesia() {
    return this.getSolicitacaoCirurgiaStore.tipoAnestesiaCheckbox
  }

  set getTipoAnestesia(value: string[]) {
    this.getSolicitacaoCirurgiaStore.setTipoAnestesiaCheckbox(value)
  }

  get getEquipamentos() {
    return this.getSolicitacaoStore.equipamentos
  }

  get surgerySolicitationHasPrivateProcedure() {
    const mainProcedure = this.solicitacaoCirurgia.procedimento
    const secondaryProcedures = this.solicitacaoCirurgia.procedimentosAssociados || []

    const allProcedures = [mainProcedure].concat(secondaryProcedures)

    return allProcedures.some(procedure => procedure!.particular)
  }

  get showPrivateOPMEField() {
    return this.opcaoHabilitado('opmes', 'opcaoParticular') // && this.surgerySolicitationHasPrivateProcedure
  }

  get convenioDaSolicitacao() {
    let conv = this.getSolicitacaoCirurgiaStore.convenios.find((convenio: Convenio) => convenio.id === this.solicitacaoCirurgia.paciente.convenioId)
    if (!conv) {
      conv = {
        id: '',
        nome: '',
        particular: false,
        status: '',
        convenioUtilizaFluxoDePreviaCirurgica: false,
        prazoEmDiasParaTriagem: 0,
        prazoMaximoEmDiasParaAgendamento: 0,
      }
    }
    return conv
  }

  get configuracoesDePreviaCirurgica() {
    if (this.convenioDaSolicitacao.convenioUtilizaFluxoDePreviaCirurgica) {
      return {
        prazoEmDiasParaTriagem: this.convenioDaSolicitacao.prazoEmDiasParaTriagem,
        prazoMaximoEmDiasParaAgendamento: this.convenioDaSolicitacao.prazoMaximoEmDiasParaAgendamento,
      }
    }
    return { prazoEmDiasParaTriagem: 0, prazoMaximoEmDiasParaAgendamento: 0 }
  }

  get getCaixasCirurgicas() {
    return this.getSolicitacaoCirurgiaStore.solicitacaoCirurgia.caixasCirurgicas || []
  }

  diferencaDeDatas(dataSelecionada: Date | string, prazo: number) {
    return Math.floor(moment.duration(moment().add(prazo, 'days').diff(moment(dataSelecionada))).asDays()) >= 0
  }

  verificaPrazoParaTriagem() {
    const datas = []
    const datasValidas: any = {
      opcaoDeData1: this.solicitacaoCirurgia.opcaoDataPrevisto1,
      opcaoDeData2: this.solicitacaoCirurgia.opcaoDataPrevisto2,
      opcaoDeData3: this.solicitacaoCirurgia.opcaoDataPrevisto3,
    }

    Object.entries(datasValidas).forEach(([key, value]) => {
      // @ts-ignore
      if (['', null, undefined].includes(value)) {
        delete datasValidas[key]
      }
    })

    Object.entries(datasValidas).forEach(([key]) => {
      // @ts-ignore
      datas.push(this.diferencaDeDatas(datasValidas[key], this.convenioDaSolicitacao.prazoEmDiasParaTriagem))
    })

    return datas.some((e: boolean) => e)
  }

  get prazoParaTriagem() {
    return this.convenioDaSolicitacao && this.convenioDaSolicitacao.prazoMaximoEmDiasParaAgendamento && this.convenioDaSolicitacao.prazoMaximoEmDiasParaAgendamento > 0
      ? moment().add(this.convenioDaSolicitacao.prazoMaximoEmDiasParaAgendamento, 'days').format('YYYY-MM-DD')
      : moment().add(10, 'years').format('YYYY-MM-DD')
  }

  get surgeryHasOPME() {
    return this.solicitacaoCirurgia.grupoDeOpme && this.solicitacaoCirurgia.grupoDeOpme.opmes.length > 0
  }

  get surgeryDateSuggestion() {
    let suggestedDate = ''
    const sundayIndexWeekDay = 0

    if (this.surgeryHasOPME && !!this.suggestedSurgeryDateWithOPME) {
      suggestedDate = this.suggestedSurgeryDateWithOPME
    } else if (!this.surgeryHasOPME && !!this.suggestedSurgeryDateWithoutOPME) {
      suggestedDate = this.suggestedSurgeryDateWithoutOPME
    }

    if (suggestedDate) {
      let suggestedDateObject = moment(suggestedDate, 'DD/MM/YYYY')

      if (suggestedDateObject.day() === sundayIndexWeekDay) {
        suggestedDateObject = suggestedDateObject.add(1, 'days')
      }

      const formattedSuggestedDate = suggestedDateObject.format('YYYY-MM-DD')

      return [formattedSuggestedDate]
    }

    return []
  }

  get suggestedDateMessage() {
    let suggestedDate = ''
    const sundayIndexWeekDay = 0

    if (this.surgeryHasOPME && !!this.suggestedSurgeryDateWithOPME) {
      suggestedDate = this.suggestedSurgeryDateWithOPME
    } else if (!this.surgeryHasOPME && !!this.suggestedSurgeryDateWithoutOPME) {
      suggestedDate = this.suggestedSurgeryDateWithoutOPME
    }

    let formattedSuggestedDate = suggestedDate

    if (suggestedDate) {
      let suggestedDateObject = moment(suggestedDate, 'DD/MM/YYYY')

      if (suggestedDateObject.day() === sundayIndexWeekDay) {
        suggestedDateObject = suggestedDateObject.add(1, 'days')
      }

      formattedSuggestedDate = suggestedDateObject.format('DD/MM/YYYY')
    }

    return `<b>* Considerando o tipo de procedimento que você está solicitando e o tempo de autorização da operadora, recomendamos a marcação a partir de </b><code>${formattedSuggestedDate}</code>`
  }

  get enableSuggestedDateMessage() {
    const naoExibeMensagemTempoAutorizacaoPorTipoCentroCirurgico = this.campoHabilitado('naoExibeMensagemTempoAutorizacaoPorTipoCentroCirurgico') && this.solicitacaoCirurgia.tipoCentroCirurgico && this.opcaoHabilitado('naoExibeMensagemTempoAutorizacaoPorTipoCentroCirurgico', this.solicitacaoCirurgia.tipoCentroCirurgico)
    if (naoExibeMensagemTempoAutorizacaoPorTipoCentroCirurgico) {
      return false
    }
    if ((this.surgeryHasOPME && this.suggestedSurgeryDateWithOPME) || (!this.surgeryHasOPME && this.suggestedSurgeryDateWithoutOPME)) {
      return true
    }
    return false
  }

  get textFieldProps1() {
    let hint = ''
    const date1 = this.solicitacaoCirurgia.opcaoDataPrevisto1
    const date2 = this.solicitacaoCirurgia.opcaoDataPrevisto2
    const date3 = this.solicitacaoCirurgia.opcaoDataPrevisto3
    const rules: any[] = []
    rules.push(v => (!this.validateDate(date1, date2) && !this.validateDate(date1, date3)) || 'Datas e horários iguais não são permitidos')
    rules.push(v => (!this.validateHours(date1, date2) && !this.validateHours(date1, date3)) || 'É necessário uma diferência de no mínimo 1 hora entre os horários')

    if ((this.enableAuthorizationTab && this.step === 0)
      || (this.getTemplate && this.getTemplate.opcaoDataPrevisto1 && this.getTemplate.opcaoDataPrevisto1.obrigatorio)) {
      rules.push(v => !!v || 'Campo obrigatório.')
    }

    hint = this.surgeryDateLimiterHint

    return {
      appendIcon: 'event',
      rules,
      hint,
      persistentHint: true,
    }
  }

  get textFieldProps2() {
    let hint = ''
    const date1 = this.solicitacaoCirurgia.opcaoDataPrevisto1
    const date2 = this.solicitacaoCirurgia.opcaoDataPrevisto2
    const date3 = this.solicitacaoCirurgia.opcaoDataPrevisto3
    const rules: any[] = []
    rules.push(v => (!this.validateDate(date1, date2) && !this.validateDate(date2, date3)) || 'Datas e horários iguais não são permitidos')
    rules.push(v => (!this.validateHours(date1, date2) && !this.validateHours(date2, date3)) || 'É necessário uma diferência de no mínimo 1 hora entre os horários')

    if (this.getTemplate.opcaoDataPrevisto2.obrigatorio) {
      rules.push(v => !!v || 'Campo obrigatório.')
    }

    hint = this.surgeryDateLimiterHint

    return { appendIcon: 'event', rules, hint, persistentHint: true }
  }

  get textFieldProps3() {
    let hint = ''
    const date1 = this.solicitacaoCirurgia.opcaoDataPrevisto1
    const date2 = this.solicitacaoCirurgia.opcaoDataPrevisto2
    const date3 = this.solicitacaoCirurgia.opcaoDataPrevisto3
    const rules: any[] = []
    rules.push(v => (!this.validateDate(date1, date3) && !this.validateDate(date2, date3)) || 'Datas e horários iguais não são permitidos')
    rules.push(v => (!this.validateHours(date1, date3) && !this.validateHours(date2, date3)) || 'É necessário uma diferência de no mínimo 1 hora entre os horários')

    if (this.getTemplate.opcaoDataPrevisto3.obrigatorio) {
      rules.push(v => !!v || 'Campo obrigatório.')
    }

    hint = this.surgeryDateLimiterHint

    return { appendIcon: 'event', rules, hint, persistentHint: true }
  }

  get datePickerProps1() {
    const variation = ['Urgencia', 'EletivoSemAutorizacao', 'Emergencia'].includes(this.solicitacaoCirurgia.carater) ? 86400000 : 0

    const invalidSchedulingDates = this.invalidSchedulingDates.reduce((dateMap, item) => {
      dateMap[item.data] = true
      return dateMap
    }, {})

    return {
      locale: this.$vuetify.lang.current,
      color: 'rgb(38, 82, 163)',
      min: new Date(Date.now() - variation).toISOString(),
      max: this.prazoParaTriagem,
      'data-cy': 'opcaoDataPrevisto1-date',
      events: this.enableSuggestedDateMessage && this.surgeryDateSuggestion && !!this.surgeryDateSuggestion.length ? this.surgeryDateSuggestion : [],
      showCurrent: this.enableSuggestedDateMessage && this.surgeryDateSuggestion && !!this.surgeryDateSuggestion.length ? this.surgeryDateSuggestion[0] : '',
      allowedDates: date => !invalidSchedulingDates[date],
    }
  }

  get timePickerProps1() {
    return {
      format: '24hr',
      color: 'rgb(38, 82, 163)',
      min: '00:00',
      'data-cy': 'opcaoDataPrevisto1-time',
      allowedMinutes: m => m % (Number(this.getTemplate.opcaoDataPrevisto1.intervaloPadrao) || 15) === 0,
    }
  }

  get datePickerProps2() {
    const invalidSchedulingDates = this.invalidSchedulingDates.reduce((dateMap, item) => {
      dateMap[item.data] = true
      return dateMap
    }, {})

    return {
      locale: this.$vuetify.lang.current,
      color: 'rgb(38, 82, 163)',
      min: new Date(Date.now()).toISOString(),
      max: this.prazoParaTriagem,
      'data-cy': 'opcaoDataPrevisto2-date',
      events: this.enableSuggestedDateMessage && this.surgeryDateSuggestion && !!this.surgeryDateSuggestion.length ? this.surgeryDateSuggestion : [],
      showCurrent: this.enableSuggestedDateMessage && this.surgeryDateSuggestion && !!this.surgeryDateSuggestion.length ? this.surgeryDateSuggestion[0] : '',
      allowedDates: date => !invalidSchedulingDates[date],
    }
  }

  get timePickerProps2() {
    return {
      format: '24hr',
      color: 'rgb(38, 82, 163)',
      min: '00:00',
      'data-cy': 'opcaoDataPrevisto2-time',
      allowedMinutes: m => m % (Number(this.getTemplate.opcaoDataPrevisto2.intervaloPadrao) || 15) === 0,
    }
  }

  get datePickerProps3() {
    const invalidSchedulingDates = this.invalidSchedulingDates.reduce((dateMap, item) => {
      dateMap[item.data] = true
      return dateMap
    }, {})

    return {
      locale: this.$vuetify.lang.current,
      color: 'rgb(38, 82, 163)',
      min: new Date(Date.now()).toISOString(),
      max: this.prazoParaTriagem,
      'data-cy': 'opcaoDataPrevisto3-date',
      events: this.enableSuggestedDateMessage && this.surgeryDateSuggestion && !!this.surgeryDateSuggestion.length ? this.surgeryDateSuggestion : [],
      showCurrent: this.enableSuggestedDateMessage && this.surgeryDateSuggestion && !!this.surgeryDateSuggestion.length ? this.surgeryDateSuggestion[0] : '',
      allowedDates: date => !invalidSchedulingDates[date],
    }
  }

  get timePickerProps3() {
    return {
      format: '24hr',
      color: 'rgb(38, 82, 163)',
      min: '00:00',
      'data-cy': 'opcaoDataPrevisto3-time',
      allowedMinutes: m => m % (Number(this.getTemplate.opcaoDataPrevisto3.intervaloPadrao) || 15) === 0,
    }
  }

  get getPlanos() {
    return this.getSolicitacaoCirurgiaStore.planos
  }

  get getPlanosAssociados() {
    return this.getSolicitacaoCirurgiaStore.planosAssociados
  }

  get getCentroCirurgico() {
    return this.getSolicitacaoCirurgiaStore.centroCirurgico
  }

  get getLaudos() {
    return this.getSolicitacaoCirurgiaStore.laudos
  }

  set getLaudos(value) {
    this.laudos = value
  }

  anexosPaciente: any[] = []

  get documentacaoPaciente() {
    return this.getSolicitacaoCirurgiaStore.laudosPaciente
  }

  set documentacaoPaciente(value: any[]) {
    this.getSolicitacaoCirurgiaStore.laudosPaciente = value
  }

  get documentosDiversos() {
    return this.getSolicitacaoCirurgiaStore.laudosDiversos
  }

  set documentosDiversos(value: any[]) {
    this.getSolicitacaoCirurgiaStore.laudosDiversos = value
  }

  get termoDeConsentimento() {
    return this.getSolicitacaoCirurgiaStore.laudosTermoDeConsentimento
  }

  set termoDeConsentimento(value: any[]) {
    this.getSolicitacaoCirurgiaStore.laudosTermoDeConsentimento = value
  }

  get orcamentoDeCirurgiaParticularAprovado() {
    return this.getSolicitacaoCirurgiaStore.laudosOrcamentoDeCirurgiaParticularAprovado
  }

  get uploading() {
    return this.up
  }

  set uploading(value: string[]) {
    this.up = value
  }

  get uploadingDoc() {
    return this.upDoc
  }

  set uploadingDoc(value: string[]) {
    this.upDoc = value
  }

  get uploadingDocDiversos() {
    return this.upDocDiversos
  }

  set uploadingDocDiversos(value: string[]) {
    this.upDocDiversos = value
  }

  get uploadingTermoDeConsentimento() {
    return this.upTermoDeConsentimento
  }

  set uploadingTermoDeConsentimento(value: string[]) {
    this.upTermoDeConsentimento = value
  }

  get getRequestMessage() {
    return new RequestMessage()
  }

  get getTemplate() {
    return this.getSolicitacaoCirurgiaStore.currentTemplate.formulario
  }

  get documentacaoObrigatoriaDoPaciente() {
    return !!(this.getTemplate.documentacaoObrigatoriaDoPaciente && this.getTemplate.documentacaoObrigatoriaDoPaciente.habilitado)
  }

  get fornecedorLabel() {
    return this.getTemplate && this.getTemplate.opmes && this.getTemplate.opmes.fornecedorLabel
      ? this.getTemplate.opmes.fornecedorLabel
      : 'fabricante/marca'
  }

  titulo(field: string, defaultValue: string) {
    if (this.getTemplate && this.getTemplate[field]) {
      const campo = this.getTemplate[field]
      return (campo && campo.titulo) || defaultValue
    }

    return defaultValue
  }

  instrucao(field: string, defaultValue: string) {
    if (this.getTemplate && this.getTemplate[field]) {
      const campo = this.getTemplate[field]
      return (campo && campo.instrucao) || defaultValue
    }

    return defaultValue
  }

  get categorias() {
    return this.getSolicitacaoCirurgiaStore.categorias
  }

  get categoriasAssociadas() {
    return this.getSolicitacaoCirurgiaStore.categoriasAssociadas
  }

  get hemocomponentesLabelUHG() {
    const hospitaisUHG: string[] = ['HOSPITAL ALVORADA MOEMA']
    return hospitaisUHG.includes(this.getSolicitacaoCirurgiaStore.hospitalNome.toUpperCase())
      ? 'Quantidade de bolsas *'
      : 'Quantidade *'
  }

  reservaUTIWarning: string = ''
  reservaUTIDisabled: boolean = false

  validarDiariaUti(e: any) {
    const { diariaUti } = this.getTemplate
    if (diariaUti && diariaUti.obrigatorio) {
      this.secondStepperRules.diariaUti = ['SemReserva', 'ReservaUtiNao'].includes(e)
        ? []
        : [(v: any) => this.isGreaterThanZero(v)]
    }
    if (['SemReserva', 'ReservaUtiNao'].includes(e)) this.getSolicitacaoCirurgiaStore.clearDiariaUti()
  }

  validarDiariaHospital(e: string | null) {
    const { diaria } = this.getTemplate
    this.getSolicitacaoCirurgiaStore.clearDiaria()

    if (diaria && diaria.obrigatorio) {
      this.secondStepperRules.diaria = e === 'Internacao'
        ? [(v: any) => this.isGreaterThanZero(v)]
        : []
      if (e === 'Ambulatorial') this.getSolicitacaoCirurgiaStore.clearDiaria()
      if (e === 'HospitalDia') this.getSolicitacaoCirurgiaStore.clearDiaria()
    } else if (e === 'HospitalDia') {
      this.getSolicitacaoCirurgiaStore.clearDiaria()
    }

    if (diaria && !diaria.obrigatorio && e === 'Ambulatorial') {
      this.secondStepperRules.diaria = []
      this.getSolicitacaoCirurgiaStore.clearDiaria()
    }

    if (!diaria && e === 'Ambulatorial') {
      this.secondStepperRules.diaria = []
      this.getSolicitacaoCirurgiaStore.clearDiaria()
    }

    if (this.opcaoHabilitado('formularioMedico', 'limparReservaUtiNoTipoDeInternacaoAmbulatorial')) {
      if (e === 'Ambulatorial' && this.opcaoHabilitado('reservaUti', 'semReservaUti')) {
        this.getSolicitacaoCirurgiaStore.setSolicitacaoCirurgiaFields({ field: 'reservaUTI', value: 'SemReserva' })
        this.reservaUTIWarning = 'Quando o tipo de procedimento é ambulatorial, a reserva de UTI fica suspensa.'
        this.reservaUTIDisabled = true
        if (this.campoHabilitado('diariUti')) this.getSolicitacaoCirurgiaStore.setSolicitacaoCirurgiaFields({ field: 'diariaUti', value: null })
      } else {
        this.reservaUTIWarning = ''
        this.reservaUTIDisabled = false
        this.getSolicitacaoCirurgiaStore.setSolicitacaoCirurgiaFields({ field: 'reservaUTI', value: null })
        this.$refs.reservaUTI.resetValidation()
      }
    }

    this.handleSurgerySolicitationEligibilityInfoFetch()
  }

  get disabledTipoAcomodacaoBudgetMode() {
    if (this.getTemplate.tipoAcomodacao.habilitado && this.budgetMode) {
      return true
    }
    return false
  }

  get tipoAcomodacaoObrigatorio() {
    const { formulario } = this.getSolicitacaoCirurgiaStore.currentTemplate
    return !this.budgetMode && formulario.tipoAcomodacao.habilitado
      && (formulario.tipoAcomodacao.obrigatorioParaTodosOsConvenios
        || (formulario.tipoAcomodacao.obrigatorioParaConvenioParticular && this.isConvenioParticular))
  }

  get isConvenioParticular() {
    return this.convenioParticular
  }

  set isConvenioParticular(value: boolean) {
    this.convenioParticular = value
  }

  pacienteInfoDisabled(field: string) {
    if (this.solicitacaoCirurgia.criadaComoPreReserva || this.enableAuthorizationTab) {
      const { configuracoes } = this.solicitacaoCirurgia
      // Verifica se a propriedade e campo[field] existem
      if (!configuracoes || !configuracoes.paciente || configuracoes.paciente[field] === undefined) return false
      // Quando a propriedade for true, então habilita o campo, caso contrário desabilita
      return configuracoes && configuracoes.paciente ? !configuracoes.paciente[field] : false
    }

    return this.solicitacaoCirurgia.criadaComoPreReserva
  }

  async showGradeMedica() {
    this.loadingGradeMedica = true

    if (this.campoHabilitado('gradeDisponibilidade')) {
      this.openRoomSchedulingModal()
    } else if (this.campoHabilitado('gradeCirurgica')) {
      this.openSurgeryGridModal()
    } else {
      await this.getSolicitacaoCirurgiaStore.getMedicoGradeDeHorario()
      const { calendar } = this.$refs.modalDataCirurgia.$refs
      calendar.options.events = this.getSolicitacaoCirurgiaStore.gradeMedicaEventos
      calendar.getApi().render()
      calendar.getApi().gotoDate(this.getStartWeekOpcaoDataPrevisto1())

      this.getSolicitacaoCirurgiaStore.setShowModalDataCirurgia(true)
    }

    this.loadingGradeMedica = false
  }

  getStartWeekOpcaoDataPrevisto1() {
    const { opcaoDataPrevisto1 } = this.getSolicitacaoCirurgiaStore.solicitacaoCirurgia
    return opcaoDataPrevisto1 === '' || opcaoDataPrevisto1 === null
      ? moment().format('YYYY-MM-DD')
      : moment(opcaoDataPrevisto1).format('YYYY-MM-DD')
  }

  displayLateralidadeLabel(display) {
    return ![undefined, '', null].includes(display.key) ? displayLateralidade(display.key) : displayLateralidade(display)
  }

  anestesistaSelecionado() {
    if (this.solicitacaoCirurgia.anestesista !== null) {
      this.getErrorMessage.errorAnestesistaLista = ''
    }
  }

  get listaDeAnestesistasHabilitado() {
    return this.opcaoHabilitado('anestesiaHospital', 'anestesistaLista')
      && (this.solicitacaoCirurgia.anestesiaDoHospital === 'Nao' || (this.solicitacaoCirurgia.anestesiaDoHospital === 'Sim' && (this.opcaoHabilitado('anestesiaHospital', 'sempreSelecionarAnestesistaNaLista') || this.opcaoHabilitado('anestesiaHospital', 'selecaoOpcionalCasoSim'))))
  }

  validatePlanoCategoriaTipoAcomodacao() {
    if (this.firstStepperRules.convenio.length > 1) {
      this.firstStepperRules.convenio = [(v: any) => !!v || 'Campo obrigatório']
    }

    const { planos, categorias } = this.getSolicitacaoCirurgiaStore
    const { formulario } = this.getSolicitacaoCirurgiaStore.currentTemplate

    this.firstStepperRules.plano = planos.length === 0 && formulario.plano.obrigatorio
      ? []
      : [(v: any) => !!v || 'Campo obrigatório.']

    this.thirdStepperRules.plano = planos.length === 0 && formulario.plano.obrigatorio
      ? []
      : [(v: any) => !!v || 'Campo obrigatório.']

    if (!formulario.plano.obrigatorio) {
      this.firstStepperRules.plano = []
      this.thirdStepperRules.plano = []
    }

    this.firstStepperRules.categoria = categorias.length === 0 && formulario.categoria.obrigatorio
      ? []
      : [(v: any) => !!v || 'Campo obrigatório.']

    this.thirdStepperRules.categoria = categorias.length === 0 && formulario.categoria.obrigatorio
      ? []
      : [(v: any) => !!v || 'Campo obrigatório.']

    if (!formulario.categoria.obrigatorio) {
      this.firstStepperRules.categoria = []
      this.thirdStepperRules.categoria = []
    }

    this.firstStepperRules.tipoAcomodacao = this.tipoAcomodacaoObrigatorio
      ? [(v: any) => !!v || 'Campo obrigatório.']
      : []

    this.thirdStepperRules.tipoAcomodacao = this.tipoAcomodacaoObrigatorio
      ? [(v: any) => !!v || 'Campo obrigatório.']
      : []

    this.thirdStepperRules.carteirinha = !this.isConvenioParticular && formulario.carteirinha.habilitado && formulario.carteirinha.obrigatorio
      ? [(v: any) => !!v || 'Campo obrigatório.']
      : []
  }

  async saveOrUpdateFirstStep() {
    if (this.tipoDocumentoBuscaPaciente === TipoDocumentoBuscaPacienteEnum.RGH && !this.solicitacaoCirurgia.paciente.id && !this.solicitacaoCirurgia.paciente.pacienteNaoPossuiCpf && this.solicitacaoCirurgia.paciente.cpf!.length < 11) {
      if (!this.solicitacaoCirurgia.paciente.rgh) {
        this.dialogMsgRghNaoEncontrado = 'RGH não informado. Favor informar um CPF válido, ou realizar a busca do paciente informando o RGH, CPF ou nome / data de nascimento.'
      } else {
        this.dialogMsgRghNaoEncontrado = 'RGH informado não encontrado. Favor informar um CPF válido, ou realizar a busca do paciente informando CPF ou nome / data de nascimento.'
      }
      this.dialogRghNaoEncontrado = true
      return
    }

    this.loadingSaveOrUpdate = true
    this.validatePlanoCategoriaTipoAcomodacao()

    if (this.possuiFornecedoresDuplicados()) {
      this.loadingSaveOrUpdate = false
      return
    }

    this.$refs.firstStepperForm.validate()
    const errorsFirstStep = await this.$refs.firstStepperForm.errorBag

    const counterValid = Object.values(errorsFirstStep).filter(e => e === true).length

    if (this.getSolicitacaoCirurgiaStore.firstStep && counterValid < 1) {
      const response = await this.getSolicitacaoCirurgiaStore.post()
      if (response.success) {
        const param: any = {
          params: {
            solicitacaoId: response.data,
          },
        }

        this.$router.replace(param)
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Ocorreu um erro ao salvar a solicitação.', icon: 'warning', color: '#C62828' })
      }
    } else {
      const errors = await this.$refs.firstStepperForm.errorBag
      const counter = Object.values(errors).filter(e => e === true).length
      EventBus.$emit('setSnackbar', { show: true, text: `Foram encontrados ${counter} erro(s) no formulário.`, icon: 'warning', color: '#C62828' })
    }

    this.loadingSaveOrUpdate = false
  }

  authorizationTab: boolean = false

  get enableAuthorizationTab() {
    return this.authorizationTab && !!this.patientHealthInsuranceData && this.patientHealthInsuranceData.autorizadorTipo === 'Totvs'
  }

  set enableAuthorizationTab(value: boolean) {
    this.authorizationTab = this.authorizationTab
  }

  get patientHealthInsuranceData() {
    return this.getSolicitacaoCirurgiaStore.convenios.find(healthInsurance => healthInsurance.id === this.patientData.convenioId)
  }

  async secondStepValidation() {
    this.validatePlanoCategoriaTipoAcomodacao()

    if (this.solicitacaoCirurgia.tipoProcedimento === 'Ambulatorial' || this.solicitacaoCirurgia.tipoProcedimento === 'HospitalDia') this.secondStepperRules.diaria = []
    if (this.solicitacaoCirurgia.reservaUTI === 'SemReserva') this.secondStepperRules.diariaUti = []
    await timeout(100)

    const first = this.$refs.firstStepperForm.validate()
    const second = this.$refs.secondStepperForm.validate()
    let procedimentoValid: boolean = true
    let procedimentoAssociadoValid: boolean = true
    let cidValid: boolean = true
    let tipoLesaoValid: boolean = true
    let reservaDeSangueValid: boolean = true
    let anestesistaValid: boolean = true

    if (
      this.getSolicitacaoCirurgiaStore.currentTemplate.formulario.procedimentoPrincipal.obrigatorio
      && !this.getSolicitacaoStore.solicitacao.procedimento!.id
    ) {
      this.getErrorMessage.errorProcedimento = 'Campo obrigatório.'
      procedimentoValid = false
    } else {
      this.getErrorMessage.errorProcedimento = ''
    }

    if (this.getSolicitacaoCirurgiaStore.currentTemplate.formulario.cids.obrigatorio && this.getSolicitacaoStore.cids.length <= 0) {
      this.getErrorMessage.errorCids = 'Campo obrigatório.'
      cidValid = false
    } else {
      this.getErrorMessage.errorCids = ''
    }

    if (this.campoHabilitado('tipoLesao') && this.getSolicitacaoCirurgiaStore.currentTemplate.formulario.tipoLesao.obrigatorio && this.solicitacaoCirurgia.lesoes!.length <= 0) {
      this.getErrorMessage.errorTipoLesao = 'Campo obrigatório.'
      tipoLesaoValid = false
    } else {
      this.getErrorMessage.errorTipoLesao = ''
    }

    if (
      this.getSolicitacaoCirurgiaStore.currentTemplate.formulario.procedimentosAssociados.obrigatorio
      && this.getSolicitacaoStore.solicitacao.procedimentosAssociados!.length <= 0
    ) {
      this.getErrorMessage.errorProcedimentoAssociado = 'Campo obrigatório.'
      procedimentoAssociadoValid = false
    } else {
      this.getErrorMessage.errorProcedimentoAssociado = ''
    }

    if (
      this.getSolicitacaoCirurgiaStore.currentTemplate.formulario.reservaDeSangue.obrigatorio
      && this.solicitacaoCirurgia.temSolicitacaoReservaDeSangue
      && !this.$refs.modalReservaDeSangue.$refs.formReservaDeSangue.validate()
    ) {
      this.getErrorMessage.errorReservaDeSangue = 'Campo obrigatório.'
      reservaDeSangueValid = false
    } else {
      this.getErrorMessage.errorReservaDeSangue = ''
    }

    if (
      this.getSolicitacaoCirurgiaStore.currentTemplate.formulario.anestesiaHospital.obrigatorio
      && this.listaDeAnestesistasHabilitado
      && this.solicitacaoCirurgia.anestesista === null
    ) {
      if (this.opcaoHabilitado('anestesiaHospital', 'selecaoOpcionalCasoSim') && this.solicitacaoCirurgia.anestesiaDoHospital === 'Sim') {
        this.getErrorMessage.errorAnestesista = ''
        anestesistaValid = true
      } else if (this.opcaoHabilitado('anestesiaHospital', 'selecaoOpcionalCasoNao') && this.solicitacaoCirurgia.anestesiaDoHospital === 'Nao') {
        this.getErrorMessage.errorAnestesista = ''
        anestesistaValid = true
      } else {
        this.getErrorMessage.errorAnestesistaLista = 'Campo obrigatório.'
        anestesistaValid = false
      }
    } else {
      this.getErrorMessage.errorAnestesistaLista = ''
    }
    if (this.getSolicitacaoCirurgiaStore.currentTemplate.formulario.anestesiaHospital && this.getSolicitacaoCirurgiaStore.currentTemplate.formulario.anestesiaHospital.obrigatorio && this.getSolicitacaoCirurgiaStore.currentTemplate.formulario.anestesiaHospital.campos.hospitalUtilizaClinicasDeAnestesia && !this.solicitacaoCirurgia.anestesista) {
      this.getErrorMessage.errorAnestesista = 'Campo obrigatório.'
      anestesistaValid = false
    }

    return (first && second && procedimentoValid && cidValid && procedimentoAssociadoValid && reservaDeSangueValid && anestesistaValid && tipoLesaoValid)
  }

  validateSecondStepAuthorizationTabForm() {
    if (this.solicitacaoCirurgia.tipoProcedimento === 'Ambulatorial') {
      this.secondStepAuthorizationTabFormRules.diaria = []
    }

    const secondStepFormGeneralValidation = this.$refs.secondStepAuthorizationTabForm ? this.$refs.secondStepAuthorizationTabForm.validate() : true

    let procedimentoValid: boolean = true
    let cidValid: boolean = true
    let anexoValid: boolean = true

    if (!this.getSolicitacaoStore.solicitacao.procedimento!.id) {
      this.getErrorMessage.errorProcedimento = 'Campo obrigatório.'
      procedimentoValid = false
    } else {
      this.getErrorMessage.errorProcedimento = ''
    }

    if (this.getSolicitacaoStore.cids.length <= 0) {
      this.getErrorMessage.errorCids = 'Campo obrigatório.'
      cidValid = false
    } else {
      this.getErrorMessage.errorCids = ''
    }

    if (this.getLaudos.length <= 0 && this.campoObrigatorioGuiaCirurgia('laudosGuiaAutorizacao')) {
      this.getErrorMessage.errorAnexo = 'Campo obrigatório.'
      anexoValid = false
    }

    return (secondStepFormGeneralValidation && procedimentoValid && cidValid && anexoValid)
  }

  loadingCreateSurgerySolicitationStep0: boolean = false
  loadingUpdateSurgerySolicitationStep0: boolean = false
  loadingSendSurgerySolicitationAuthorizationInfo: boolean = false

  async createSurgerySolicitationStep0() {
    this.loadingCreateSurgerySolicitationStep0 = true

    if (this.possuiFornecedoresDuplicados()) {
      this.loadingCreateSurgerySolicitationStep0 = false
      return
    }

    this.$refs.firstStepAuthorizationTabForm.validate()
    const errorsFirstStep = await this.$refs.firstStepAuthorizationTabForm.errorBag

    const counterValid = Object.values(errorsFirstStep).filter(e => e === true).length

    if (this.getSolicitacaoCirurgiaStore.firstStep && counterValid < 1) {
      const response = await this.getSolicitacaoCirurgiaStore.post()
      if (response.success) {
        const param: any = {
          params: {
            solicitacaoId: response.data,
          },
        }

        this.$router.replace(param)
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Ocorreu um erro ao salvar a solicitação.', icon: 'warning', color: '#C62828' })
      }
    } else {
      const errors = await this.$refs.firstStepAuthorizationTabForm.errorBag
      const counter = Object.values(errors).filter(e => e === true).length
      EventBus.$emit('setSnackbar', { show: true, text: `Foram encontrados ${counter} erro(s) no formulário.`, icon: 'warning', color: '#C62828' })
    }

    this.step = 0
    this.loadingCreateSurgerySolicitationStep0 = false
  }

  async updateSurgerySolicitationStep0(sendSurgerySolicitationAuthorizationInfo: boolean = false) {
    let updatedSurgerySolicitationSuccessfully = false
    this.loadingUpdateSurgerySolicitationStep0 = true
    let counter = 0

    if (this.possuiFornecedoresDuplicados()) {
      this.loadingUpdateSurgerySolicitationStep0 = false
      return
    }

    const secondStepValid: boolean = this.validateSecondStepAuthorizationTabForm()
    const opmeFormValid: boolean = this.$refs.opmeForm ? this.$refs.opmeForm.validate() : true
    const protocoloFormValid: boolean = this.$refs.protocoloForm ? this.$refs.protocoloForm.validate() : true

    if (!this.validateOpmeDeveSerPreenchido()) {
      this.loadingUpdateSurgerySolicitationStep0 = false
      return
    }

    if (secondStepValid && opmeFormValid && protocoloFormValid) {
      const updateSurgerySolicitationAPIResponse = await this.updateSolicitation()

      if (updateSurgerySolicitationAPIResponse.success) {
        updatedSurgerySolicitationSuccessfully = true
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: updateSurgerySolicitationAPIResponse.message || 'Não foi posível atualizar a solicitação', icon: 'warning', color: '#C62828' })
      }
    } else {
      if (this.$refs.firstStepAuthorizationTabForm) {
        const errors1 = await this.$refs.firstStepAuthorizationTabForm.errorBag
        counter = Object.values(errors1).filter(e => e === true).length
      }

      if (this.$refs.secondStepAuthorizationTabForm) {
        const errors2 = await this.$refs.secondStepAuthorizationTabForm.errorBag
        counter += Object.values(errors2).filter(e => e === true).length
      }

      if (this.$refs.opmeForm) {
        const opmeFormErrors = await this.$refs.opmeForm.errorBag
        counter += Object.values(opmeFormErrors).filter(e => e === true).length
      }

      if (this.$refs.protocoloForm) {
        const protocoloFormErrors = await this.$refs.protocoloForm.errorBag
        counter += Object.values(protocoloFormErrors).filter(e => e === true).length
      }

      // eslint-disable-next-line
      counter += ~~!!this.getErrorMessage.errorProcedimento
      // eslint-disable-next-line
      counter += ~~!!this.getErrorMessage.errorCids

      EventBus.$emit('setSnackbar', { show: true, text: 'Foram encontrados erro(s) no formulário.', icon: 'warning', color: '#C62828' }) // ${counter}
    }

    this.loadingUpdateSurgerySolicitationStep0 = false

    if (sendSurgerySolicitationAuthorizationInfo && counter === 0 && updatedSurgerySolicitationSuccessfully) {
      const sendAuthorizationAPIResponse = await this.getSolicitacaoCirurgiaStore.sendSurgerySolicitationAuthorizationInfo(this.solicitacaoCirurgia.id)

      if (sendAuthorizationAPIResponse.success) {
        this.step = 1
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: sendAuthorizationAPIResponse.message || 'Não foi posível enviar informações da guia de autorização da solicitação', icon: 'warning', color: '#C62828' })
      }
    } else if (!sendSurgerySolicitationAuthorizationInfo && counter === 0 && updatedSurgerySolicitationSuccessfully) {
      this.step = 1
    }

    await this.getSolicitacaoCirurgiaStore.getSolicitacaoById(this.solicitacaoCirurgia.id)
  }

  async sendSurgerySolicitationAuthorizationInfo() {
    try {
      this.loadingSendSurgerySolicitationAuthorizationInfo = true

      await this.updateSurgerySolicitationStep0(true)
    } catch (error) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Error ao enviar autorização', icon: 'warning', color: '#C62828' })
    } finally {
      this.loadingSendSurgerySolicitationAuthorizationInfo = false
    }
  }

  async saveOrUpdateSecondStep() {
    if (this.tipoDocumentoBuscaPaciente === TipoDocumentoBuscaPacienteEnum.RGH && !this.solicitacaoCirurgia.paciente.id && !this.solicitacaoCirurgia.paciente.pacienteNaoPossuiCpf && this.solicitacaoCirurgia.paciente.cpf!.length < 11) {
      if (!this.solicitacaoCirurgia.paciente.rgh) {
        this.dialogMsgRghNaoEncontrado = 'RGH não informado. Favor informar um CPF válido, ou realizar a busca do paciente informando o RGH, CPF ou nome / data de nascimento.'
      } else {
        this.dialogMsgRghNaoEncontrado = 'RGH informado não encontrado. Favor informar um CPF válido, ou realizar a busca do paciente informando CPF ou nome / data de nascimento.'
      }
      this.dialogRghNaoEncontrado = true
      return
    }

    this.loadingSaveOrUpdateSecondStep = true

    if (this.possuiFornecedoresDuplicados()) {
      this.loadingSaveOrUpdateSecondStep = false
      return
    }

    const secondStepValid: boolean = await this.secondStepValidation()
    const opmeFormValid: boolean = this.$refs.opmeForm ? this.$refs.opmeForm.validate() : true
    const protocoloFormValid: boolean = this.$refs.protocoloForm ? this.$refs.protocoloForm.validate() : true

    if (!this.validateOpmeDeveSerPreenchido()) {
      this.loadingSaveOrUpdateSecondStep = false
      return
    }

    if (this.solicitacaoCirurgia.hospital.usaProcedimentosApenasHospitalDia && this.opcaoHabilitado('tipoProcedimento', 'hospitalDia')) {
      await this.getSolicitacaoCirurgiaStore.getProcedimentosHospitalDiaByHospital()
      if (this.getSolicitacaoCirurgiaStore.todosProcedimentosHospitalDia) {
        const hospitalDiaExpected: boolean = this.solicitacaoCirurgia.tipoProcedimento === 'HospitalDia'
        const diariaExpected: boolean = this.campoHabilitado('diaria') && this.solicitacaoCirurgia.diaria === 1
        const reservaUtiExpected: boolean = (this.opcaoHabilitado('reservaUti', 'reservaUtiNao') || this.opcaoHabilitado('reservaUti', 'semReservaUti')) && ['SemReserva', 'ReservaUtiNao'].includes(this.solicitacaoCirurgia.reservaUTI)

        if (!hospitalDiaExpected || !diariaExpected || !reservaUtiExpected) {
          this.getSolicitacaoCirurgiaStore.setModal({ name: 'procedimentosApenasHospitalDiaWarning', value: true })
          this.loadingSaveOrUpdateSecondStep = false
          return
        }
      }
    }

    if (secondStepValid && opmeFormValid && protocoloFormValid) {
      const response = await this.updateSolicitation()
      if (response.success) {
        this.$refs.thirdStepperForm.resetValidation()
        this.step = 2
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: response.message, icon: 'warning', color: '#C62828' })
      }
    } else {
      const errors1 = await this.$refs.firstStepperForm.errorBag
      let counter = Object.values(errors1).filter(e => e === true).length

      const errors2 = await this.$refs.secondStepperForm.errorBag
      counter += Object.values(errors2).filter(e => e === true).length

      if (this.$refs.opmeForm) {
        const opmeFormErrors = await this.$refs.opmeForm.errorBag
        counter += Object.values(opmeFormErrors).filter(e => e === true).length
      }

      if (this.$refs.protocoloForm) {
        const protocoloFormErrors = await this.$refs.protocoloForm.errorBag
        counter += Object.values(protocoloFormErrors).filter(e => e === true).length
      }

      // eslint-disable-next-line
      counter += ~~!!this.getErrorMessage.errorProcedimento
      // eslint-disable-next-line
      counter += ~~!!this.getErrorMessage.errorCids
      // eslint-disable-next-line
      counter += ~~!!this.getErrorMessage.errorTipoLesao
      // eslint-disable-next-line
      counter += ~~!!this.getErrorMessage.errorProcedimentoAssociado
      // eslint-disable-next-line
      counter += ~~!!this.getErrorMessage.errorReservaDeSangue
      // eslint-disable-next-line
      counter += ~~!!this.getErrorMessage.errorAnestesistaLista

      EventBus.$emit('setSnackbar', { show: true, text: `Foram encontrados ${counter} erro(s) no formulário.`, icon: 'warning', color: '#C62828' })
    }
    this.loadingSaveOrUpdateSecondStep = false
  }

  thirdStepValidation() {
    const third = this.$refs.thirdStepperForm.validate()
    let anexoValid: boolean = true
    let documentacaoPacienteValid: boolean = true
    let documentosDiversosValid: boolean = true
    let termoDeConsentimentoValid: boolean = true

    if (this.documentacaoPacienteNaoObrigatoriaNaUrgencia()) {
      return true
    }

    if (this.documentacaoPacienteObrigatoria('documentosDiversos') && this.documentosDiversos.length <= 0) {
      this.getErrorMessage.errorDocumentosDiversos = 'Campo obrigatório.'
      documentosDiversosValid = false
    } else {
      this.getErrorMessage.errorDocumentosDiversos = ''
    }

    if (this.documentacaoPacienteObrigatoria('termoDeConsentimento') && this.termoDeConsentimento.length <= 0) {
      this.getErrorMessage.errorTermoDeConsentimento = 'Campo obrigatório.'
      termoDeConsentimentoValid = false
    } else {
      this.getErrorMessage.errorTermoDeConsentimento = ''
    }

    if (this.documentacaoPacienteObrigatoria('documentacaoPaciente') && this.documentacaoPaciente.length <= 0) {
      this.getErrorMessage.errorDocumentacaoPaciente = 'Campo obrigatório.'
      documentacaoPacienteValid = false
    } else {
      this.getErrorMessage.errorDocumentacaoPaciente = ''
    }

    if (this.getSolicitacaoCirurgiaStore.canShowDocumentosObrigatorios) {
      if (this.getSolicitacaoCirurgiaStore.canShowDocumentosObrigatorios && this.getLaudos.length <= 0) {
        this.getErrorMessage.errorAnexo = 'Insira ao menos um laudo para documentação obrigatória.'
        anexoValid = false
      } else {
        this.getErrorMessage.errorAnexo = ''
      }
    } else if (this.documentacaoPacienteObrigatoria('anexos') && this.getLaudos.length <= 0) {
      this.getErrorMessage.errorAnexo = 'Campo obrigatório.'
      anexoValid = false
    } else {
      this.getErrorMessage.errorAnexo = ''
    }

    return third && documentacaoPacienteValid && anexoValid && documentosDiversosValid && termoDeConsentimentoValid
  }

  documentacaoPacienteNaoObrigatoriaNaUrgencia() {
    if (this.getSolicitacaoCirurgiaStore.solicitacaoCirurgia.carater === 'Urgencia' && !this.getSolicitacaoCirurgiaStore.solicitacaoCirurgia.hospital.hospitalExigeDocumentacaoDoPacienteQuandoCaraterUrgencia) {
      return true
    }

    return false
  }

  documentacaoPacienteObrigatoria(campo: string) {
    if (this.documentacaoPacienteNaoObrigatoriaNaUrgencia()) {
      return false
    }

    return this.campoObrigatorio(campo)
  }

  documentacaoPacienteObrigatoriaLabel(label: string, campo: string) {
    if (this.documentacaoPacienteObrigatoria(campo)) {
      return `${label} *`
    }

    return label
  }

  ignoreReservation() {
    this.isIgnoreReservationModalOpen = false
    this.saveOrUpdateThirdStep({ ignoraReservaDeRascunho: true })
  }

  editReservation() {
    this.isIgnoreReservationModalOpen = false
    this.$refs.secondStepperForm.resetValidation()
    this.step = 1
    this.openRoomSchedulingModal()
  }

  async finalizarSolicitacao(params?: any) {
    if (this.convenioDaSolicitacao.prazoEmDiasParaTriagem > 0) this.loadingPreviaCirurgica = true

    if (this.getRecursosHospitalaresStore.ResourceAccess && this.usarRecursoApa
      && (!this.solicitacaoCirurgia.apa || !this.solicitacaoCirurgia.apa.notificacaoEnviada)) {
      this.solicitacaoCirurgia.apa = this.getSolicitacaoStore.solicitacao.apa
      if (this.solicitacaoCirurgia.apa) {
        this.solicitacaoCirurgia.apa.preferenciaApa = this.usarRecursoApa
      }
    }
    const response = await this.updateSolicitation()
    if (response.success) {
      const responseFinalizar = await this.getSolicitacaoCirurgiaStore.finalizar(params)
      if (responseFinalizar.success) {
        if (responseFinalizar.data
        && responseFinalizar.data.mostrarModalParaIgnorarReserva
        && this.campoHabilitado('gradeDisponibilidade')
        ) {
          this.isIgnoreReservationModalOpen = true
          return
        }
        EventBus.$emit('setSnackbar', { show: true, text: 'Cadastro realizado com sucesso!', icon: 'done', color: '#2E7D32' })
        if (this.convenioDaSolicitacao.prazoEmDiasParaTriagem > 0) {
          this.getSolicitacaoCirurgiaStore.setModal({ name: 'previaCirurgica', value: false })
        }
        this.getHemocomponentes = []
        this.getSolicitacaoCirurgiaStore.clearReservaHemocomponentes()

        this.getSolicitacaoCirurgiaStore.clearSolicitacaoCirurgia()
        this.getSolicitacaoStore.clearSolicitacao()
        this.getReservaDeSangueStore.clearReservaDeSangue()
        this.getSolicitacaoCirurgiaStore.setHospitalNome('')
        this.$router.push('/agendamento-medico')
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: responseFinalizar.message, icon: 'warning', color: '#C62828' })
      }
    } else {
      if (!response.success && response.message) {
        EventBus.$emit('setSnackbar', { show: true, text: response.message, icon: 'warning', color: '#C62828' })
        this.loadingPreviaCirurgica = false
        return
      }

      const errors1 = await this.$refs.firstStepperForm.errorBag
      let counter = Object.values(errors1).filter(e => e === true).length

      const errors2 = await this.$refs.secondStepperForm.errorBag
      counter += Object.values(errors2).filter(e => e === true).length

      const errors3 = await this.$refs.secondStepperForm.errorBag
      counter += Object.values(errors3).filter(e => e === true).length
      // eslint-disable-next-line
      counter += ~~!!this.getErrorMessage.errorProcedimento
      // eslint-disable-next-line
      counter += ~~!!this.getErrorMessage.errorCids
      // eslint-disable-next-line
      counter += ~~!!this.getErrorMessage.errorTipoLesao
      // eslint-disable-next-line
      counter += ~~!!this.getErrorMessage.errorProcedimentoAssociado
      // eslint-disable-next-line
      counter += ~~!!this.getErrorMessage.errorReservaDeSangue

      EventBus.$emit('setSnackbar', { show: true, text: `Foram encontrados ${counter} erro(s) no formulário.`, icon: 'warning', color: '#C62828' })
    }

    if (this.convenioDaSolicitacao.prazoEmDiasParaTriagem > 0) this.loadingPreviaCirurgica = false
  }

  async saveOrUpdateThirdStep(params?: any) {
    this.loadingSaveOrUpdateThirdStep = true
    await this.getSolicitacaoCirurgiaStore.getAllPlanos()
    this.validatePlanoCategoriaTipoAcomodacao()

    if (this.possuiFornecedoresDuplicados()) {
      this.loadingSaveOrUpdateThirdStep = false
      return
    }

    const secondStepValid: boolean = await this.secondStepValidation()
    const thirdStepValid: boolean = this.thirdStepValidation()
    const opmeFormValid: boolean = this.$refs.opmeForm ? this.$refs.opmeForm.validate() : true
    const protocoloFormValid: boolean = this.$refs.protocoloForm ? this.$refs.protocoloForm.validate() : true
    const documentosObrigatoriosFormValid = this.$refs.documentosObrigatoriosForm ? this.$refs.documentosObrigatoriosForm.validate() : true

    if (!this.validateOpmeDeveSerPreenchido()) {
      this.loadingSaveOrUpdateThirdStep = false
      return
    }

    if (secondStepValid && thirdStepValid && opmeFormValid && protocoloFormValid && documentosObrigatoriosFormValid) {
      const flagDataVirtual = this.solicitacaoCirurgia.medicoSolicitouDataVirtual || this.solicitacaoCirurgia.dataAgendamentoVirtual
      if (!flagDataVirtual) {
        if (this.convenioDaSolicitacao.prazoEmDiasParaTriagem > 0 && !this.verificaPrazoParaTriagem()) {
          this.getSolicitacaoCirurgiaStore.setModal({ name: 'previaCirurgica', value: true })
          this.loadingSaveOrUpdateThirdStep = false
          return
        }
      }

      await this.finalizarSolicitacao(params)
    } else {
      const errors1 = await this.$refs.firstStepperForm.errorBag
      const errors2 = await this.$refs.secondStepperForm.errorBag
      const errors3 = await this.$refs.thirdStepperForm.errorBag

      let counter = Object.values(errors1).filter(e => e === true).length
      counter += Object.values(errors2).filter(e => e === true).length
      counter += Object.values(errors3).filter(e => e === true).length

      if (this.$refs.opmeForm) {
        const opmeFormErrors = await this.$refs.opmeForm.errorBag
        counter += Object.values(opmeFormErrors).filter(e => e === true).length
      }

      if (this.$refs.protocoloForm) {
        const errors = await this.$refs.protocoloForm.errorBag
        counter += Object.values(errors).filter(e => e === true).length
      }

      if (this.$refs.documentosObrigatoriosForm) {
        const errors = await this.$refs.documentosObrigatoriosForm.errorBag
        counter += Object.values(errors).filter(e => e === true).length
      }

      // eslint-disable-next-line
      const docPaciente = ~~!!this.getErrorMessage.errorDocumentacaoPaciente
      // eslint-disable-next-line
      const docDiversos = ~~!!this.getErrorMessage.errorDocumentosDiversos
      // eslint-disable-next-line
      const termoDeConsentimento = ~~!!this.getErrorMessage.errorTermoDeConsentimento
      // eslint-disable-next-line
      const anexos = ~~!!this.getErrorMessage.errorAnexo
      counter += docPaciente + anexos + termoDeConsentimento + docDiversos || 0
      EventBus.$emit('setSnackbar', { show: true, text: `Foram encontrados ${counter} erro(s) no formulário.`, icon: 'warning', color: '#C62828' })
    }
    this.loadingSaveOrUpdateThirdStep = false
  }

  validateOpmeDeveSerPreenchido() {
    // Para o protocolo sempre é obrigatório algum material
    if (this.getSolicitacaoCirurgiaStore.segueOProtocolo && this.grupoDeOpme!.opmes.length === 0) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Selecione algum material antes de prosseguir', icon: 'warning', color: '#C62828' })
      return false
    }

    // Se tiver desabilitado não valida nada
    if (!this.campoHabilitado('opmes')) {
      return true
    }

    // Se não for obrigatório não valida nada
    if (!this.campoObrigatorio('opmes')) {
      return true
    }

    // Verifica se foi selecionado algum material, porque nesse ponto é obrigatório e está habilitado
    if (this.grupoDeOpme!.opmes.length === 0) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Selecione algum material antes de prosseguir', icon: 'warning', color: '#C62828' })
      return false
    }

    return true
  }

  get showJustificationDeadlineField() {
    return (((this.surgeryHasOPME && this.suggestedSurgeryDateWithOPME) || (!this.surgeryHasOPME && this.suggestedSurgeryDateWithoutOPME))
              && ((this.surgeryHasOPME && this.firstOptionDateBeforeSuggestedDateWithOPME)
              || (!this.surgeryHasOPME && this.firstOptionDateBeforeSuggestedDateWithoutOPME)))
  }

  get firstOptionDateBeforeSuggestedDateWithOPME() {
    return this.isDateBefore(this.solicitacaoCirurgia.opcaoDataPrevisto1, this.suggestedSurgeryDateWithOPME)
  }

  get firstOptionDateBeforeSuggestedDateWithoutOPME() {
    return this.isDateBefore(this.solicitacaoCirurgia.opcaoDataPrevisto1, this.suggestedSurgeryDateWithoutOPME)
  }

  isDateBefore(firstDate, secondDate) {
    const firstDateObject = moment(firstDate, 'DD/MM/YYYY')
    const secondDateObject = moment(secondDate, 'DD/MM/YYYY')

    if (firstDateObject < secondDateObject) {
      return true
    }

    return false
  }

  loadingSaveAndContinueLaterStep0: boolean = false

  async saveAndContinueLaterStep0() {
    if (this.$refs.opmeForm && !this.$refs.opmeForm.validate()) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Verifique as informações dos materiais', icon: 'warning', color: '#C62828' })
      return
    }

    if (this.possuiFornecedoresDuplicados()) {
      return
    }

    this.loadingSaveAndContinueLaterStep0 = true
    const request = await this.updateSolicitation()

    if (!request.success) {
      this.loadingSaveAndContinueLaterStep0 = false
      EventBus.$emit('setSnackbar', { show: true, text: request.message, icon: 'warning', color: '#C62828' })
      this.loadingSaveAndContinueLaterStep0 = false
      return
    }

    this.getHemocomponentes = []
    this.getSolicitacaoCirurgiaStore.clearReservaHemocomponentes()

    this.getSolicitacaoCirurgiaStore.clearSolicitacaoCirurgia()
    this.getSolicitacaoStore.clearSolicitacao()
    this.getReservaDeSangueStore.clearReservaDeSangue()
    this.getSolicitacaoCirurgiaStore.setHospitalNome('')
    this.$router.push('/agendamento-medico')
    this.loadingSaveAndContinueLaterStep0 = false
  }

  cancelOperation() {
    EventBus.$emit('setSnackbar', { show: true, text: 'Operação cancelada com sucesso', icon: 'done', color: '#2E7D32' })

    this.getHemocomponentes = []
    this.getSolicitacaoCirurgiaStore.clearReservaHemocomponentes()
    this.getSolicitacaoCirurgiaStore.clearSolicitacaoCirurgia()
    this.getSolicitacaoStore.clearSolicitacao()
    this.getReservaDeSangueStore.clearReservaDeSangue()
    this.getSolicitacaoCirurgiaStore.setHospitalNome('')
    this.$router.push('/agendamento-medico')
    this.loadingDelete = false
  }

  async saveForLater() {
    if (!this.$refs.firstStepperForm.validate()) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Verifique as informações do paciente', icon: 'warning', color: '#C62828' })
      return
    }

    if (this.$refs.opmeForm && !this.$refs.opmeForm.validate()) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Verifique as informações dos materiais', icon: 'warning', color: '#C62828' })
      return
    }

    if (this.possuiFornecedoresDuplicados()) {
      return
    }

    if ((this.hospitalUtilizaRegraDeMedicoExecutante || this.medicoExecutanteObrigatorioPorRegra) && this.solicitacaoCirurgia.medicoSolicitanteId === '') {
      EventBus.$emit('setSnackbar', { show: true, text: 'Médico Executante é obrigatório', icon: 'warning', color: '#C62828' })
      return
    }

    this.loadingContinueLater = true
    const request = await this.updateSolicitation()

    if (!request.success) {
      this.loadingContinueLater = false
      EventBus.$emit('setSnackbar', { show: true, text: request.message, icon: 'warning', color: '#C62828' })
      this.loadingContinueLater = false
      return
    }

    this.getHemocomponentes = []
    this.getSolicitacaoCirurgiaStore.clearReservaHemocomponentes()

    this.getSolicitacaoCirurgiaStore.clearSolicitacaoCirurgia()
    this.getSolicitacaoStore.clearSolicitacao()
    this.getReservaDeSangueStore.clearReservaDeSangue()
    this.getSolicitacaoCirurgiaStore.setHospitalNome('')
    this.$router.push('/agendamento-medico')
    this.loadingContinueLater = false
  }

  async deleteSolicitacao() {
    this.loadConfirmDelete = true
    await timeout(500)
    this.confirmarExclusao = true
    this.loadConfirmDelete = false
  }

  async apagarSolicitacao() {
    this.loadingDelete = true
    const response = await this.getSolicitacaoCirurgiaStore.deleteSolicitacao(this.solicitacaoCirurgia.id)

    if (!response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Ocorreu um erro na requisição', icon: 'warning', color: '#C62828' })
      this.loadingDelete = false
      return
    }

    EventBus.$emit('setSnackbar', { show: true, text: 'Solicitação apagada com sucesso!', icon: 'done', color: '#2E7D32' })
    this.getHemocomponentes = []
    this.getSolicitacaoCirurgiaStore.clearReservaHemocomponentes()
    this.getSolicitacaoCirurgiaStore.clearSolicitacaoCirurgia()
    this.getSolicitacaoStore.clearSolicitacao()
    this.getReservaDeSangueStore.clearReservaDeSangue()
    this.getSolicitacaoCirurgiaStore.setHospitalNome('')
    this.$router.push('/agendamento-medico')
    this.loadingDelete = false
  }

  async saveModel() {
    if (!this.solicitacaoCirurgia.nomeCirurgia) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Nome favorito é obrigatório', icon: 'warning', color: '#C62828' })
      return
    }

    if (!this.solicitacaoCirurgia.diagnosticoJustificativa) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Indicação clínica / Justificativa é obrigatório', icon: 'warning', color: '#C62828' })
      return
    }

    if (this.getCids.length === 0) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Preencha ao menos um CID', icon: 'warning', color: '#C62828' })
      return
    }

    if (!this.procedimentoPrincipal!.id) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Procedimento principal é obrigatório', icon: 'warning', color: '#C62828' })
      return
    }

    if ((this.hospitalUtilizaRegraDeMedicoExecutante || this.medicoExecutanteObrigatorioPorRegra) && this.solicitacaoCirurgia.medicoSolicitanteId === '') {
      EventBus.$emit('setSnackbar', { show: true, text: 'Médico Executante é obrigatório', icon: 'warning', color: '#C62828' })
      return
    }

    // @ts-ignore
    if (['', null, undefined].includes(this.solicitacaoCirurgia.tempoCirurgia) || Number(this.solicitacaoCirurgia.tempoCirurgia) < 15) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Tempo de cirurgia é obrigatório', icon: 'warning', color: '#C62828' })
      return
    }

    this.loadingContinueLater = true

    const request = await this.updateSolicitation()

    if (request.success) {
      this.getHemocomponentes = []
      this.getSolicitacaoCirurgiaStore.clearReservaHemocomponentes()
      this.getSolicitacaoCirurgiaStore.clearSolicitacaoCirurgia()
      this.getSolicitacaoStore.clearSolicitacao()
      this.getReservaDeSangueStore.clearReservaDeSangue()
      this.getSolicitacaoCirurgiaStore.setHospitalNome('')
      this.$router.push('/agendamento-medico')
    }

    this.loadingContinueLater = false
  }

  async saveBudget() {
    if (this.canShowAdicionaPaciente() && !this.disableAdicionaPaciente) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Necessário adicionar o paciente antes de salvar', icon: 'warning', color: '#C62828' })
      return
    }

    if (!this.solicitacaoCirurgia.paciente.nome) {
      EventBus.$emit('setSnackbar', { show: true, text: 'O campo Nome do paciente é obrigatório', icon: 'warning', color: '#C62828' })
      return
    }

    if (!this.solicitacaoCirurgia.paciente.dataNascimento) {
      EventBus.$emit('setSnackbar', { show: true, text: 'O campo Data de nascimento é obrigatório', icon: 'warning', color: '#C62828' })
      return
    }

    if (!this.solicitacaoCirurgia.paciente.sexo) {
      EventBus.$emit('setSnackbar', { show: true, text: 'O campo Sexo é obrigatório', icon: 'warning', color: '#C62828' })
      return
    }

    if (!this.solicitacaoCirurgia.tipoProcedimento) {
      EventBus.$emit('setSnackbar', { show: true, text: 'O campo Tipo de procedimento é obrigatório', icon: 'warning', color: '#C62828' })
      return
    }

    if (!this.procedimentoPrincipal!.id) {
      EventBus.$emit('setSnackbar', { show: true, text: 'O campo Procedimento principal é obrigatório', icon: 'warning', color: '#C62828' })
      return
    }

    if (this.solicitacaoCirurgia.grupoDeOpme!.opmes.length > 0 && !this.$refs.opmeForm.validate()) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Foram encontrados erros no campo de Materiais', icon: 'warning', color: '#C62828' })
      return
    }

    if (!this.solicitacaoCirurgia.reservaUTI) {
      EventBus.$emit('setSnackbar', { show: true, text: 'O campo Reservar UTI é obrigatório', icon: 'warning', color: '#C62828' })
      return
    }

    if (!['SemReserva', 'ReservaUtiNao'].includes(this.solicitacaoCirurgia.reservaUTI) && !this.solicitacaoCirurgia.diariaUti) {
      EventBus.$emit('setSnackbar', { show: true, text: 'O campo Diárias de UTI é obrigatório', icon: 'warning', color: '#C62828' })
      return
    }

    if (!this.solicitacaoCirurgia.tecnicaDaCirurgia) {
      EventBus.$emit('setSnackbar', { show: true, text: 'O campo Técnica da cirurgia é obrigatório', icon: 'warning', color: '#C62828' })
      return
    }

    if (!this.solicitacaoCirurgia.tipoAcomodacao && !this.solicitacaoCirurgia.hospitalTipoAcomodacaoId) {
      EventBus.$emit('setSnackbar', { show: true, text: 'O campo Tipo de acomodação é obrigatório', icon: 'warning', color: '#C62828' })
      return
    }

    this.loadingContinueLater = true

    const res = await this.createOrcamentoAvulso()

    if (res.success) {
      this.getHemocomponentes = []
      this.getSolicitacaoCirurgiaStore.clearReservaHemocomponentes()
      this.getSolicitacaoCirurgiaStore.clearSolicitacaoCirurgia()
      this.getSolicitacaoStore.clearSolicitacao()
      this.getReservaDeSangueStore.clearReservaDeSangue()
      this.getSolicitacaoCirurgiaStore.setHospitalNome('')
      this.$router.push('/agendamento-medico')
    }

    this.loadingContinueLater = false
  }

  private async createOrcamentoAvulso() {
    const { procedimento, procedimentosAssociados } = this.getSolicitacaoStore.solicitacao
    const request = await this.getSolicitacaoCirurgiaStore.createOrcamentoAvulso({ procedimento, procedimentosAssociados })
    return request
  }

  private async updateSolicitation() {
    const { procedimento, procedimentosAssociados } = this.getSolicitacaoStore.solicitacao
    const request = await this.getSolicitacaoCirurgiaStore.put({ procedimento, procedimentosAssociados })
    return request
  }

  async loadInstrumental() {
    this.loadingInstrumental = true
    const { procedimento } = this.getSolicitacaoStore.solicitacao
    if (procedimento!.id) {
      const ids: any[] = [procedimento!.id]
      this.getSolicitacaoStore.solicitacao.procedimentosAssociados!.map(c => ids.push(c.id))

      await this.getSolicitacaoCirurgiaStore.loadInstrumentos(ids)
      this.instrumentalList = true
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: 'Procedimento principal não foi selecionado.', icon: 'warning', color: '#C62828' })
    }
    this.loadingInstrumental = false
  }

  closeInstrumentalList() {
    this.instrumentalList = false
  }

  async showModalCid() {
    this.loadingCid = true
    await this.getSolicitacaoStore.getCidSearch('')
    this.getErrorMessage.errorCids = ''
    this.getSolicitacaoStore.showModalCid(true)
    this.loadingCid = false
  }

  async deleteCid(cid) {
    EventBus.$emit('setLoadingRequest', {
      status: this.getRequestMessage.status,
      text: this.getRequestMessage.deleteMessage,
    })
    await this.getSolicitacaoStore.deleteCid(cid)
    this.getSolicitacaoStore.removeCid(cid)
    EventBus.$emit('clearLoadingRequest')
  }

  async showModalProcedimentoPrincipal() {
    this.loadingProcedimentoPrincipal = true
    const response = await this.getSolicitacaoStore.getProcedimentoSearch('')

    if (!response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: response.message, icon: 'warning', color: '#C62828' })
      this.loadingProcedimentoPrincipal = false
      return
    }

    this.getErrorMessage.errorProcedimento = ''
    const { lateralidadeEmProcedimento }: any = this.getSolicitacaoCirurgiaStore.currentTemplate.formulario.lateralidade
    this.getSolicitacaoStore.setTemplateLateralidade(lateralidadeEmProcedimento)
    this.getSolicitacaoStore.showModalProcedimentoPrincipal(true)
    this.loadingProcedimentoPrincipal = false
  }

  async showModalTipoDeLesao() {
    this.loadingTipoLesao = true
    await this.getSolicitacaoCirurgiaStore.getTipoLesaoSearch('')
    this.getErrorMessage.errorTipoLesao = ''
    this.getSolicitacaoCirurgiaStore.setModal({ name: 'showTipoDeLesao', value: true })
    this.loadingTipoLesao = false
  }

  removeLesaoSelecionada(lesao: TipoLesaoQuantidade) {
    this.getSolicitacaoCirurgiaStore.removeLesao(lesao)
    this.getSolicitacaoCirurgiaStore.addTipoLesaoApi(lesao)
  }

  async removeProcedimento() {
    this.getSolicitacaoStore.deleteProcedimentoPrincipal()
    this.getSolicitacaoStore.clearTecnicasDisponiveis()
    this.getSolicitacaoCirurgiaStore.checkNeedRejectOrRemoveProtocoloByProcedimentoPrincipalChange()
  }

  async removeDadosGestacionais() {
    this.solicitacaoCirurgia.dadosGestacionais.gemelar = null
    this.solicitacaoCirurgia.dadosGestacionais.idadeGestacional = null
  }

  async removeProcedimentoAssociado(procedimento) {
    this.getSolicitacaoStore.removeProcedimentoAssociado(procedimento)
    this.getSolicitacaoCirurgiaStore.checkNeedRejectOrRemoveProtocoloByProcedimentoAssociadoChange()
  }

  async clearProcedimentosAoTrocarConvenio(hospital: any, procedimentoAssociadoHabilitado: boolean) {
    const currentHospital = useHospitais.hospitaisByCurrentUser.find(h => h.id === hospital.id)
    if (!currentHospital || !currentHospital.hospitalLimpaProcedimentosAoTrocarConvenio) return

    const procedimentoPrincipalEditavel = !this.step0Disabled
    if (!procedimentoPrincipalEditavel) return

    this.getSolicitacaoStore.deleteProcedimentoPrincipal()
    this.getSolicitacaoStore.clearTecnicasDisponiveis()
    this.solicitacaoCirurgia.procedimento = null

    if (procedimentoAssociadoHabilitado) {
      await this.getSolicitacaoStore.clearAllProcedimentosAssociados()
    }
  }

  async showModalProcedimentoAssociados() {
    this.loadingProcedimentoAssociado = true
    const response = await this.getSolicitacaoStore.getProcedimentoSearch('')

    if (!response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: response.message, icon: 'warning', color: '#C62828' })
      this.loadingProcedimentoAssociado = false
      return
    }

    this.getSolicitacaoStore.showModalProcedimentoAssociado(true)
    this.getErrorMessage.errorProcedimentoAssociado = ''
    this.loadingProcedimentoAssociado = false
  }

  async showModalEquipamento() {
    this.loadingEquipamento = true
    await this.getSolicitacaoStore.getAllGrupoEquipamentoParaOMedico('')
    this.getSolicitacaoStore.showModalEquipamento(true)
    this.loadingEquipamento = false
  }

  async showModalTecnicaRobotica() {
    if (this.solicitacaoCirurgia.tecnicaDaCirurgia === 'Robotica' && this.campoHabilitado('tecnicaDaCirurgia.tecnicaEhRobotica')) {
      this.getSuporteSalasRoboticasStore.setHospitalId(this.solicitacaoCirurgia.hospitalId)
      await this.getSuporteSalasRoboticasStore.getSalasRoboticas()
      // Verifica novamente após o await: o usuário pode ter trocado de opção durante a requisição
      if (this.solicitacaoCirurgia.tecnicaDaCirurgia === 'Robotica') {
        this.getSolicitacaoStore.showModalTecnicaRobotica(true)
      }
    } else {
      this.getSolicitacaoCirurgiaStore.setSolicitacaoCirurgiaFields({ field: 'salaRobotica', value: null })
      this.getSolicitacaoStore.showModalTecnicaRobotica(false)
    }
  }

  async editarSalaRobotica() {
    if (this.solicitacaoCirurgia.tecnicaDaCirurgia === 'Robotica' && this.campoHabilitado('tecnicaDaCirurgia.tecnicaEhRobotica')) {
      this.getSuporteSalasRoboticasStore.setHospitalId(this.solicitacaoCirurgia.hospitalId)
      await this.getSuporteSalasRoboticasStore.getSalasRoboticas()
      if (this.solicitacaoCirurgia.tecnicaDaCirurgia === 'Robotica') {
        this.getSolicitacaoStore.showModalTecnicaRobotica(true)
      }
    }
  }

  limparSalaRobotica() {
    this.getSolicitacaoCirurgiaStore.setSolicitacaoCirurgiaFields({ field: 'salaRobotica', value: null })
    this.getSolicitacaoCirurgiaStore.setSolicitacaoCirurgiaFields({ field: 'tecnicaDaCirurgia', value: null })
  }

  showModalDeSugestaoDeProtocolo() {
    this.getSolicitacaoCirurgiaStore.setShowModalSugestaoDeProtocolo(true)
  }

  async removeEquipamento(equipamento: Equipamento) {
    EventBus.$emit('setLoadingRequest', {
      status: this.getRequestMessage.status,
      text: this.getRequestMessage.deleteMessage,
    })
    await this.getSolicitacaoStore.deleteEquipamento(equipamento)
    this.getSolicitacaoStore.removeEquipamento(equipamento)
    EventBus.$emit('clearLoadingRequest')
  }

  async showModalReservaDeSangue() {
    this.loadingReservaDeSangue = true
    await timeoutDefault()
    this.$refs.modalReservaDeSangue.$refs.formReservaDeSangue.resetValidation()
    this.getReservaDeSangueStore.setShowModalReservaDeSangue(true)
    this.getErrorMessage.errorReservaDeSangue = ''
    this.loadingReservaDeSangue = false
  }

  get patientData() {
    return this.solicitacaoCirurgia.paciente
  }

  get patientHasSomeContactInformation() {
    const { celular: cellPhone, telefone: phone, email } = this.patientData

    return cellPhone || phone || email
  }

  get temProcedimentoPrincipal() {
    // @ts-ignore
    return !!this.getSolicitacaoStore.solicitacao.procedimento.id
  }

  get temAlgumProcedimentoAssociados() {
    // @ts-ignore
    return !!(this.getSolicitacaoStore.solicitacao.procedimentosAssociados && this.getSolicitacaoStore.solicitacao.procedimentosAssociados.length)
      // @ts-ignore
      || !!(this.solicitacaoCirurgia.procedimentosAssociados && this.solicitacaoCirurgia.procedimentosAssociados.length)
  }

  get pacienteNaoPossuiCpf() {
    return !!this.solicitacaoCirurgia.paciente.pacienteNaoPossuiCpf
  }

  get naoPossuiCpfItems() {
    return [
      { value: 'MenorDe12', text: 'Menor de 12 anos' },
      { value: 'Estrangeiro', text: 'Estrangeiro' },
      { value: 'RecemNascido', text: 'Recém-nascido' },
    ]
  }

  async escolherKitOpme() {
    if (!this.temProcedimentoPrincipal) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Procedimento principal não foi selecionado.', icon: 'warning', color: '#C62828', timeout: 4500 })
      return
    }

    this.loadingModalOPME = true

    const { procedimento, procedimentosAssociados } = this.getSolicitacaoStore.solicitacao
    if (procedimento && procedimento.id !== '' && !!procedimentosAssociados) {
      const codigoProcedimentos: any[] = []
      if (procedimentosAssociados.length > 0) {
        procedimentosAssociados.forEach((e: Procedimento) => codigoProcedimentos.push(e.codigo))
      }
      codigoProcedimentos.unshift(procedimento.codigo)

      if (this.getSolicitacaoCirurgiaStore.canLoadKitDeMaterialDoMedico) {
        await this.getSolicitacaoCirurgiaStore.getGrupoOpmeByMedico(codigoProcedimentos)
      }

      this.getSolicitacaoCirurgiaStore.setShowModalOPME(true)
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: 'Procedimento principal não foi selecionado.', icon: 'warning', color: '#C62828' })
    }
    this.loadingModalOPME = false
  }

  async adicionarMaterial() {
    this.getSolicitacaoCirurgiaStore.adicionarOpme()
  }

  showModalCadastrarMaterial() {
    this.getSolicitacaoCirurgiaStore.setShowModalCadastrarMaterial(true)
  }

  showModalCadastrarFornecedor() {
    this.getSolicitacaoCirurgiaStore.setShowModalCadastrarFornecedor(true)
  }

  materialChange(data: OpmeMaterial, index: number) {
    this.getSolicitacaoCirurgiaStore.materialChange({ opme: data, index })
  }

  fornecedorChange(fornecedorId: string, fieldName: string) {
    this.getSolicitacaoCirurgiaStore.fornecedorChange({ fornecedorId, fieldName })
  }

  fornecedorV2Change(data: IProtocoloMaterialDoKitV2) {
    this.getSolicitacaoCirurgiaStore.fornecedorV2Change(data)
  }

  opmeV2Change() {
    clearTimeout(this.opmeV2UpdateValidationTimeout)
    this.opmeV2UpdateValidationTimeout = setTimeout(() => {
      this.$refs.opmeForm.validate()
    }, 200)
  }

  gradeCompletaChange(data: GrupoOpmes) {
    // eslint-disable-next-line
    data.observacao = ''
  }

  async deleteOPME(grupoOpme: GrupoOpme) {
    this.loadingDeleteOpme = grupoOpme.id || ''
    const { id } = grupoOpme
    await this.getSolicitacaoCirurgiaStore.deleteDeleteGrupoOpmeDaSolicitacao(id || '')
    this.loadingDeleteOpme = ''
  }

  async convenioChange(convenioId: string, canResetPlano = true) {
    try {
      EventBus.$emit('setLoadingRequest', { status: this.getRequestMessage.status, text: this.getRequestMessage.search })

      const procedimentoAssociadoHabilitado = this.campoHabilitado('procedimentosAssociados')

      this.loadingConvenio = true
      this.finishedLoad = false

      // When change assurance, needs configure template again
      // The template can change based on assurance
      await this.templateConfiguracao()

      const { hospital } = this.solicitacaoCirurgia

      await this.clearProcedimentosAoTrocarConvenio(hospital, procedimentoAssociadoHabilitado)

      const convenio = this.getSolicitacaoCirurgiaStore.convenios.find((e: any) => e.id === convenioId)
      // @ts-ignore
      this.isConvenioParticular = convenio.particular
      const { plano, tipoAcomodacao, carteirinha, categoria } = this.getTemplate

      // planoId cache: A cobertura vigente conflita com a categoria do paciente
      const planoIdCached: string = this.solicitacaoCirurgia.paciente.planoId!
      // categoriaId cache: A cobertura vigente conflita com a categoria do paciente
      const categoriaIdCached: string = this.solicitacaoCirurgia.paciente.categoriaId!

      if (plano.habilitado) {
        this.getSolicitacaoCirurgiaStore.clearPlanos()

        // Limpeza de planos
        this.getSolicitacaoCirurgiaStore.setPlano('')
        if (categoria.habilitado) {
          this.getSolicitacaoCirurgiaStore.setCategoria('')
          if (hospital.hospitalFazConsultaCoberturaVigente && hospital.tipoDeCoberturaVigente === 'Categoria') {
            this.getSolicitacaoCirurgiaStore.setCategoriaCoberturaVigente(undefined)
          }
        }

        await this.getSolicitacaoCirurgiaStore.getAllPlanos()
        if (this.getSolicitacaoCirurgiaStore.planos.length < 1) {
          this.firstStepperRules.plano = []
          this.thirdStepperRules.plano = []
        } else {
          this.firstStepperRules.plano = []
          this.thirdStepperRules.plano = []
          this.firstStepperRules.plano.push((v: any) => !!v || 'Campo obrigatório.')
          this.thirdStepperRules.plano.push((v: any) => !!v || 'Campo obrigatório.')
        }

        if (this.getSolicitacaoCirurgiaStore.planos.some((p: any) => p.id === planoIdCached)) {
          this.getSolicitacaoCirurgiaStore.setPlano(planoIdCached)
        }
      } else {
        this.getSolicitacaoCirurgiaStore.clearPlanos()
      }

      if (categoria.habilitado && planoIdCached) {
        this.getSolicitacaoCirurgiaStore.clearCategorias()
        await this.getSolicitacaoCirurgiaStore.getAllCategoriasByPlano(planoIdCached)
        if (this.getSolicitacaoCirurgiaStore.categorias.length < 1) {
          this.firstStepperRules.categoria = []
          this.thirdStepperRules.categoria = []
        } else {
          this.firstStepperRules.categoria = []
          this.thirdStepperRules.categoria = []
          this.firstStepperRules.categoria.push((v: any) => !!v || 'Campo obrigatório.')
          this.thirdStepperRules.categoria.push((v: any) => !!v || 'Campo obrigatório.')
        }

        if (this.getSolicitacaoCirurgiaStore.categorias.some((c: any) => c.id === categoriaIdCached)) {
          this.getSolicitacaoCirurgiaStore.setCategoria(categoriaIdCached)
        }
      } else {
        this.getSolicitacaoCirurgiaStore.clearCategorias()
      }

      if (canResetPlano) {
        this.getSolicitacaoCirurgiaStore.setPlano('')
        if (plano.habilitado) {
          this.getSolicitacaoCirurgiaStore.setCategoria('')
          if (hospital.hospitalFazConsultaCoberturaVigente && hospital.tipoDeCoberturaVigente === 'Categoria') {
            this.getSolicitacaoCirurgiaStore.setCategoriaCoberturaVigente(undefined)
          }
        }
      }

      this.getSolicitacaoCirurgiaStore.setTipoAcomodacao('')
      this.validatePlanoCategoriaTipoAcomodacao()

      if (this.convenioParticular) {
        this.solicitacaoCirurgia.operadoraSenhaProvisoria = ''
      }

      if ((plano.habilitado && this.getSolicitacaoCirurgiaStore.planos.length === 0) || plano.habilitado === false) {
        this.planoChange()
      }

      if (this.solicitacaoCirurgia.hospital.hospitalIntegraComAutorizadorAntesDaReserva
        && !!this.patientHealthInsuranceData && this.patientHealthInsuranceData.autorizadorTipo === 'Totvs') {
        this.authorizationTab = true
      }

      if (!this.getSolicitacaoCirurgiaStore.firstStep) {
        await this.getSolicitacaoCirurgiaStore.loadDocumentosObrigatorios()
        await this.getSolicitacaoCirurgiaStore.loadProtocoloOptions()
        await this.getSolicitacaoCirurgiaStore.checkSelectedProtocoloExistsForConvenio()
      }

      this.handleSurgerySolicitationEligibilityInfoFetch()
    } finally {
      this.loadingConvenio = false
      this.finishedLoad = true

      EventBus.$emit('clearLoadingRequest')
    }
  }

  async planoChange(planoId = '') {
    const { categoria } = this.getTemplate

    if (!planoId && (!categoria.habilitado && this.solicitacaoCirurgia.paciente.categoriaId)) {
      this.getSolicitacaoCirurgiaStore.setPacienteField({ field: 'categoriaId', value: '' })
    }

    if (planoId && categoria.habilitado) {
      this.getSolicitacaoCirurgiaStore.clearCategorias()
      this.getSolicitacaoCirurgiaStore.setCategoria('')
      this.getSolicitacaoCirurgiaStore.setCategoriaCoberturaVigente(undefined)
      await this.getSolicitacaoCirurgiaStore.getAllCategoriasByPlano(planoId)
      if (this.getSolicitacaoCirurgiaStore.categorias.length < 1) {
        this.firstStepperRules.categoria = []
        this.thirdStepperRules.categoria = []
      } else {
        this.firstStepperRules.categoria = []
        this.thirdStepperRules.categoria = []
        this.firstStepperRules.categoria.push((v: any) => !!v || 'Campo obrigatório.')
        this.thirdStepperRules.categoria.push((v: any) => !!v || 'Campo obrigatório.')
      }
    } else {
      this.getSolicitacaoCirurgiaStore.clearCategorias()
    }

    if (this.getSolicitacaoCirurgiaStore.firstStep) {
      await this.getSolicitacaoCirurgiaStore.getModeloCirurgia()
    }
  }

  async categoriaChange() {
    const { hospital } = this.solicitacaoCirurgia
    if (!hospital.hospitalFazConsultaCoberturaVigente || hospital.tipoDeCoberturaVigente !== 'Categoria') return

    this.loadingCategoria = true

    const request = await this.getSolicitacaoCirurgiaStore.consultaCoberturaVigente()
    if (request.success) this.getSolicitacaoCirurgiaStore.setCategoriaCoberturaVigente(request.data.temCoberturaVigente)

    this.loadingCategoria = false
  }

  get categoriaCoberturaVigente() {
    return this.getSolicitacaoCirurgiaStore.solicitacaoCirurgia.paciente.categoriaCoberturaVigente
  }

  async processFile(file: File): Promise<File | null> {
    let processedFile: File | null = null
    const isImage = file.type.match(/(^image)(\/)[a-zA-Z0-9_]*/gm)
    const isPdf = file.type === 'application/pdf'

    if (this.opcaoHabilitado('processarArquivoAnexo', 'processarImagem') && isImage) {
      processedFile = await processImageFile(file)
    }

    if (this.opcaoHabilitado('processarArquivoAnexo', 'processarPdf') && isPdf) {
      processedFile = await processPdfFile(file)
    }

    const hasAcceptedSize = processedFile ? bytesToMegabytes(processedFile.size) <= this.fileUploadLimitInMegaBytes : false

    return hasAcceptedSize ? processedFile : null
  }

  async inputFile(data: any) {
    const fileType: string = data.type
    const validDocumentType: any = {
      Laudo: {
        uploader: 'uploading',
        model: 'getLaudos',
        error: 'errorAnexo',
        value: 'Laudo',
      },
      DocumentacaoPaciente: {
        uploader: 'uploadingDoc',
        model: 'documentacaoPaciente',
        error: 'errorDocumentacaoPaciente',
        value: 'DocumentacaoPaciente',
      },
      DocumentosDiversos: {
        uploader: 'uploadingDocDiversos',
        model: 'documentosDiversos',
        error: 'errorDocumentosDiversos',
        value: 'DocumentosDiversos',
      },
      TermoDeConsentimento: {
        uploader: 'uploadingTermoDeConsentimento',
        model: 'termoDeConsentimento',
        error: 'errorTermoDeConsentimento',
        value: 'TermoDeConsentimento',
      },
    }

    const tipoDeUpload = validDocumentType[data.data.tipoDocumento]

    if (fileType !== 'application/pdf' && !fileType.match(/(^image)(\/)[a-zA-Z0-9_]*/gm)) {
      this.openFileTypeWarningModal(500)
      return
    }

    // Check file was exceeded the limit
    const fileSizeInMegabytes = bytesToMegabytes(data.file.size)
    if (fileSizeInMegabytes > this.fileUploadLimitInMegaBytes) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Erro ao carregar arquivo. Limite máximo excedido.', icon: 'warning', color: '#C62828' })
      this.openUploadRecommendationModal(500)
      return
    }

    this[tipoDeUpload.uploader].push(tipoDeUpload.value)
    this.getErrorMessage[tipoDeUpload.error] = ''

    if (data.identifier) return
    const form = new FormData()

    if (this.campoHabilitado('processarArquivoAnexo')) {
      const processedFile = await this.processFile(data.file)
      form.append('laudos', processedFile || data.file)
    } else {
      form.append('laudos', data.file)
    }

    const header: any = {
      'Content-Type': 'multipart/form-data',
    }

    const request = await this.getSolicitacaoCirurgiaStore.uploadSolicitacaoDocumentos({ form, header, tipo: tipoDeUpload.value })

    if ((request.data && request.data.length === 0) || !request.data) {
      const message = request.error || 'Erro ao carregar arquivo. Tente novamente.'
      EventBus.$emit('setSnackbar', { show: true, text: message, icon: 'warning', color: '#C62828' })
      this[tipoDeUpload.uploader].shift()
      return
    }

    // eslint-disable-next-line no-param-reassign
    data.identifier = request.data[0].id
    // eslint-disable-next-line no-param-reassign
    data.url = request.data[0].url
    // eslint-disable-next-line no-param-reassign
    data.tipoDocumento = tipoDeUpload.value
    // eslint-disable-next-line no-param-reassign
    data.name = request.data[0].nomeOriginalArquivo
    this[tipoDeUpload.model].push(data)
    this[tipoDeUpload.uploader].shift()
  }

  async deleteLaudo(value) {
    this.loadingAnexoDelete = value.identifier
    const request = await this.getSolicitacaoStore.deleteLaudo({
      hospitalId: this.getSolicitacaoCirurgiaStore.hospitalId,
      id: value.identifier,
    })

    if (request.success) {
      const removeArray: any[] = []

      for (let i = 0; i < this.getLaudos.length; i++) {
        if (this.getLaudos[i].identifier === value.identifier) {
          removeArray.push(i)
        }
      }

      for (let i = 0; i < removeArray.length; i++) {
        this.getLaudos.splice(removeArray[i], 1)
      }
    }

    this.loadingAnexoDelete = ''
  }

  async deleteDocumentacao(value) {
    this.loadingDocDelete = value.identifier
    const request = await this.getSolicitacaoStore.deleteLaudo({
      hospitalId: this.getSolicitacaoCirurgiaStore.hospitalId,
      id: value.identifier,
    })

    if (request.success) {
      const removeArray: any[] = []

      for (let i = 0; i < this.documentacaoPaciente.length; i++) {
        if (this.documentacaoPaciente[i].identifier === value.identifier) {
          removeArray.push(i)
        }
      }

      for (let i = 0; i < removeArray.length; i++) {
        this.documentacaoPaciente.splice(removeArray[i], 1)
      }
    }

    this.loadingDocDelete = ''
  }

  async deleteDocumentosDiversos(value) {
    this.loadingDocDiversosDelete = value.identifier
    const request = await this.getSolicitacaoStore.deleteLaudo({
      hospitalId: this.getSolicitacaoCirurgiaStore.hospitalId,
      id: value.identifier,
    })

    if (request.success) {
      const removeArray: any[] = []

      for (let i = 0; i < this.documentosDiversos.length; i++) {
        if (this.documentosDiversos[i].identifier === value.identifier) {
          removeArray.push(i)
        }
      }

      for (let i = 0; i < removeArray.length; i++) {
        this.documentosDiversos.splice(removeArray[i], 1)
      }
    }

    this.loadingDocDiversosDelete = ''
  }

  async deleteTermoDeConsentimento(value) {
    this.loadingTermoDeConsentimentoDelete = value.identifier
    const request = await this.getSolicitacaoStore.deleteLaudo({
      hospitalId: this.getSolicitacaoCirurgiaStore.hospitalId,
      id: value.identifier,
    })

    if (request.success) {
      const removeArray: any[] = []

      for (let i = 0; i < this.termoDeConsentimento.length; i++) {
        if (this.termoDeConsentimento[i].identifier === value.identifier) {
          removeArray.push(i)
        }
      }

      for (let i = 0; i < removeArray.length; i++) {
        this.termoDeConsentimento.splice(removeArray[i], 1)
      }
    }

    this.loadingTermoDeConsentimentoDelete = ''
  }

  validateDate(date1, date2): Boolean {
    if ([null, undefined, ''].includes(date1) || [null, undefined, ''].includes(date2)) {
      return false
    }
    if (new Date(date1).toISOString() === new Date(date2).toISOString()) {
      return true
    }


    return false
  }

  validateHours(date1, date2): Boolean {
    const diff = Math.abs(new Date(date1).getTime() - new Date(date2).getTime())
    const hours = diff / (1000 * 3600)
    return hours < 1
  }

  resevaDeSangueChanges() {
    this.getErrorMessage.errorReservaDeSangue = ''
  }

  pacienteNaoPossuiCpfChange(canResetPaciente = true) {
    const isDetails = this.$route.path.includes('/solicitacao-cirurgia-details')
    if (!isDetails) {
      if (this.solicitacaoCirurgia.paciente.pacienteNaoPossuiCpf) {
        this.firstStepperRules.cpf.splice(0, this.firstStepperRules.cpf.length)
        this.secondStepperRules.cpf.splice(0, this.secondStepperRules.cpf.length)
        this.thirdStepperRules.cpf.splice(0, this.thirdStepperRules.cpf.length)

        this.getSolicitacaoCirurgiaStore.clearCpf()
        this.$refs.firstStepperForm.resetValidation()
        this.$refs.secondStepperForm.resetValidation()
        this.$refs.thirdStepperForm.resetValidation()

        if (canResetPaciente) {
          this.getSolicitacaoCirurgiaStore.resetPaciente()
          // Mantém valor inicial do pacienteNaoPossuiCpf
          this.solicitacaoCirurgia.paciente.pacienteNaoPossuiCpf = true
        }

        if (this.documentacaoObrigatoriaDoPaciente && !this.solicitacaoCirurgia.paciente.tipoPaciente) {
          this.solicitacaoCirurgia.paciente.tipoPaciente = TipoPacienteEnum.MenorDe12
        }
      } else {
        if (this.documentacaoObrigatoriaDoPaciente) {
          this.getSolicitacaoCirurgiaStore.resetPacienteDocumentacaoObrigatoria()
          this.solicitacaoCirurgia.paciente.tipoPaciente = null
        }
        this.templateConfiguracao()
      }

      this.createOrRemoveRneFormRules()
    }
  }

  canShowAdicionaPaciente() {
    if (!this.budgetMode) {
      return false
    }

    return this.campoHabilitado('cpf')
  }

  get disableAdicionaPaciente() {
    if (this.enableAuthorizationTab) {
      return true
    }

    if (this.solicitacaoCirurgia.paciente.hisId) {
      return true
    }

    return !this.solicitacaoCirurgia.paciente.nome
      || !this.solicitacaoCirurgia.paciente.sexo
      || !this.solicitacaoCirurgia.paciente.dataNascimento
  }

  async adicionaPaciente() {
    this.loadingAdicionaPaciente = true
    const response = await this.getSolicitacaoCirurgiaStore.adicionaPaciente({ paciente: this.solicitacaoCirurgia.paciente, hospitalId: this.solicitacaoCirurgia.hospitalId })
    if (!response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Ocorreu um erro na requisição.', icon: 'warning', color: '#C62828' })
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: 'Paciente adicionado com sucesso!', icon: 'done', color: '#2E7D32' })
    }

    this.loadingAdicionaPaciente = false
  }

  onChangeClinicaAnestesista() {
    if (this.solicitacaoCirurgia.anestesista !== 'Outros') this.outroAnestesista = ''
  }

  anestesiaDoHospitalChange() {
    if (this.solicitacaoCirurgia.anestesiaDoHospital === 'Nao') {
      if (!this.opcaoHabilitado('anestesiaHospital', 'anestesistaLista')) {
        this.secondStepperRules.anestesistaCrm.push(v => !!v || 'Campo obrigatório.')
        this.secondStepperRules.nomeAnestesista.push(v => !!v || 'Campo obrigatório.')
      }

      if (this.opcaoHabilitado('anestesiaHospital', 'anestesistaLista')) {
        this.getSolicitacaoCirurgiaStore.setSolicitacaoAnestesista(null)
        this.secondStepperRules.anestesistaLista.push(v => !!v || 'Campo obrigatório.')
      }
    } else {
      this.getSolicitacaoCirurgiaStore.clearAnestesiaDoHospital()
      this.secondStepperRules.anestesistaCrm.splice(0, this.secondStepperRules.anestesistaCrm.length)
      this.secondStepperRules.nomeAnestesista.splice(0, this.secondStepperRules.nomeAnestesista.length)
      this.secondStepperRules.anestesistaLista.splice(0, this.secondStepperRules.anestesistaLista.length)
      this.getErrorMessage.errorAnestesistaLista = ''
    }
  }

  medicoConvidadoChange() {
    if (this.solicitacaoCirurgia.solicitacaoMedicoConvidado.medicoConvidado === MedicoSolicitanteEnum.Sim) {
      this.secondStepperRules.medicoConvidadoNome.push(v => !!v || 'Campo obrigatório.')
      this.secondStepperRules.medicoConvidadoCrm.push(v => !!v || 'Campo obrigatório.')
    } else {
      this.getSolicitacaoCirurgiaStore.clearMedicoConvidado()
      this.secondStepperRules.medicoConvidadoNome.splice(0, this.secondStepperRules.medicoConvidadoNome.length)
      this.secondStepperRules.medicoConvidadoCrm.splice(0, this.secondStepperRules.medicoConvidadoCrm.length)
    }
  }

  honorarioMedicoChange() {
    if (this.solicitacaoCirurgia.honorarioMedico !== HonorarioMedicoEnum.Consultorio) {
      this.getSolicitacaoCirurgiaStore.clearCodigoPrestador()
      this.secondStepperRules.codigoPrestador.splice(0, this.secondStepperRules.codigoPrestador.length)
    } else {
      this.secondStepperRules.codigoPrestador.push(v => !!v || 'Campo obrigatório.')
    }

    if (this.opcaoHabilitado('honorarioMedico', 'honorarioMedicoDocumento')) {
      if (this.solicitacaoCirurgia.honorarioMedico !== HonorarioMedicoEnum.Particular) {
        this.getSolicitacaoCirurgiaStore.clearHonorarioMedicoDocumento()
        this.secondStepperRules.honorarioMedicoDocumento.splice(0, this.secondStepperRules.honorarioMedicoDocumento.length)
      } else {
        this.secondStepperRules.honorarioMedicoDocumento.push(v => this.validateCPFCNPJUtil(v))
      }
    }
  }

  honorarioAnestesistaChange() {
    if (this.opcaoHabilitado('honorarioAnestesista', 'honorarioAnestesistaDocumento')) {
      if (this.solicitacaoCirurgia.honorarioAnestesista !== HonorarioAnestesistaEnum.AssociacaoMedica) {
        this.getSolicitacaoCirurgiaStore.clearHonorarioAnestesistaDocumento()
        this.secondStepperRules.honorarioAnestesistaDocumento.splice(0, this.secondStepperRules.honorarioAnestesistaDocumento.length)
      } else {
        this.secondStepperRules.honorarioAnestesistaDocumento.push(v => this.validateCPFCNPJUtil(v))
      }
    }
  }

  validateCPFCNPJUtil(value) {
    if (['', null, undefined].includes(value)) return 'Campo obrigatório.'
    const cleanedValue = value.replace(/\./g, '').replace(/-/g, '').replace(/\//g, '')
    if (cleanedValue.length < 11) return 'CPF inválido'
    if (cleanedValue.length === 11) return validateCPFCNPJ(cleanedValue) || 'CPF inválido.'
    if (cleanedValue.length > 11 && cleanedValue.length < 14) return 'CNPJ inválido.'
    if (cleanedValue.length === 14) return validateCPFCNPJ(cleanedValue) || 'CNPJ inválido.'
    return false
  }

  validateInstrumentadorExterno(value: any) {
    if (['', null, undefined].includes(value) || !String(value).trim()) return 'Campo obrigatório.'
    return false
  }

  precaucoesChange(precaucoes: string) {
    if (precaucoes === PrecaucoesEnum.Sim || precaucoes === PrecaucoesEnum.Outro) {
      this.secondStepperRules.especificarPrecaucoes.push(v => !!v || 'Campo obrigatório.')
    } else {
      this.secondStepperRules.especificarPrecaucoes.splice(0, this.secondStepperRules.especificarPrecaucoes.length)
      this.getSolicitacaoCirurgiaStore.clearEspecificarPrecaucoes()
    }
  }

  medicamentosEspeciaisChange(medicamentosEspeciais: boolean) {
    if (medicamentosEspeciais) {
      this.secondStepperRules.medicamentosEspeciaisEspecificar.push(v => !!v || 'Campo obrigatório.')
    } else {
      this.secondStepperRules.medicamentosEspeciaisEspecificar.splice(0, this.secondStepperRules.medicamentosEspeciaisEspecificar.length)
      this.getSolicitacaoCirurgiaStore.clearMedicamentoEspeciaisEspecificar()
    }
  }

  instrumentadorExternoChange(instrumentadorExterno: boolean) {
    if (instrumentadorExterno) {
      this.secondStepperRules.instrumentadorExternoEspecificar.push(v => this.validateInstrumentadorExterno(v))
    } else {
      this.secondStepperRules.instrumentadorExternoEspecificar.splice(0, this.secondStepperRules.instrumentadorExternoEspecificar.length)
      this.getSolicitacaoCirurgiaStore.clearInstrumentadorExternoEspecificar()
    }
  }

  equipeMedicaChange(equipeMedica) {
    this.secondStepperRules.equipeMedica.splice(0, this.secondStepperRules.equipeMedica.length)

    if (equipeMedica === 1 || equipeMedica === '1') {
      this.solicitacaoCirurgia.temEquipeMedica = true

      this.secondStepperRules.equipeMedicaEspecificar.push(v => !!v || 'Campo obrigatório.')

      if (this.doctorsSurgeryTeam!.length === 0) {
        this.doctorsSurgeryTeam!.push({ conselhoTipo: '', conselhoUf: '', conselhoNumero: '', medicoNome: '' })
      }
    } else {
      this.solicitacaoCirurgia.temEquipeMedica = false

      this.secondStepperRules.equipeMedicaEspecificar.splice(0, this.secondStepperRules.equipeMedicaEspecificar.length)
      this.getSolicitacaoCirurgiaStore.clearEquipeMedicaEspecificar()

      this.doctorsSurgeryTeam = []
    }
  }

  opmeDoConsultorioChange(opmeDoConsultorio: boolean) {
    if (opmeDoConsultorio) {
      this.secondStepperRules.opmeDoConsultorioEspecificar.push(v => !!v || 'Campo obrigatório.')
    } else {
      this.secondStepperRules.opmeDoConsultorioEspecificar.splice(0, this.secondStepperRules.opmeDoConsultorioEspecificar.length)
      this.getSolicitacaoCirurgiaStore.clearOpmeDoConsultorioEspecificar()
    }
  }

  internacaoDeVesperaChange(internacaoDeVespera: boolean) {
    if (internacaoDeVespera) {
      this.secondStepperRules.internacaoDeVesperaEspecificar.push(v => !!v || 'Campo obrigatório.')
    } else {
      this.secondStepperRules.internacaoDeVesperaEspecificar.splice(0, this.secondStepperRules.internacaoDeVesperaEspecificar.length)
      this.getSolicitacaoCirurgiaStore.clearInternacaoDeVesperaEspecificar()
    }
  }

  medicacaoContinuaChange(medicacaoContinua: boolean) {
    if (medicacaoContinua) {
      this.secondStepperRules.medicacaoContinuaEspecificar.push(v => !!v || 'Campo obrigatório.')
    } else {
      this.secondStepperRules.medicacaoContinuaEspecificar.splice(0, this.secondStepperRules.medicacaoContinuaEspecificar.length)
      this.getSolicitacaoCirurgiaStore.clearMedicacaoContinuaEspecificar()
    }
  }

  previsaoUsoQuimioterapicoChange(previsaoUsoQuimioterapico: boolean) {
    if (previsaoUsoQuimioterapico) {
      this.secondStepperRules.previsaoUsoQuimioterapicoEspecificar.push(v => !!v || 'Campo obrigatório.')
    } else {
      this.secondStepperRules.previsaoUsoQuimioterapicoEspecificar.splice(0, this.secondStepperRules.previsaoUsoQuimioterapico.length)
      this.getSolicitacaoCirurgiaStore.clearPrevisaoUsoQuimioterapico()
    }
  }

  anatomiaPatologicaChange(checkbox: string) {
    if (this.getExamesIntraOperatorios.includes(checkbox)) {
      this.secondStepperRules[checkbox].push(v => !!v || 'Campo obrigatório.')
    } else {
      this.secondStepperRules[checkbox].splice(0, this.secondStepperRules[checkbox].length)
      this.getSolicitacaoCirurgiaStore.clearAnatomiaPatologicaHospitalOuParticular()
    }
    this.removerSemExameIntraOperatorios()
  }

  anatomiaPatologicaHospitalOuParticularChange(checkbox: string) {
    if (this.getExamesIntraOperatorios.includes(checkbox) && checkbox === 'anatomiaPatologica') {
      this.secondStepperRules.anatomiaPatologicaHospitalOuParticular.push(v => !!v || 'Campo obrigatório.')
    } else {
      const { anatomiaPatologicaHospitalOuParticular, anatomiaPatologicaParticularLocal } = this.secondStepperRules
      anatomiaPatologicaHospitalOuParticular.splice(0, anatomiaPatologicaHospitalOuParticular.length)
      anatomiaPatologicaParticularLocal.splice(0, anatomiaPatologicaParticularLocal.length)
      this.getSolicitacaoCirurgiaStore.clearAnatomiaPatologicaHospitalOuParticular()
      this.getSolicitacaoCirurgiaStore.clearAnatomiaPatologicaParticularLocal()
    }
    this.removerSemExameIntraOperatorios()
  }

  biopsiaChange(checkbox: string) {
    if (this.getExamesIntraOperatorios.includes(checkbox)) {
      this.secondStepperRules[checkbox].push(v => !!v || 'Campo obrigatório.')
    } else {
      this.secondStepperRules[checkbox].splice(0, this.secondStepperRules[checkbox].length)
      this.getSolicitacaoCirurgiaStore.clearBiopsiaHospitalOuParticular()
    }
    this.removerSemExameIntraOperatorios()
  }

  biopsiaHospitalOuParticularChange(checkbox: string) {
    if (this.getExamesIntraOperatorios.includes(checkbox) && checkbox === 'biopsia') {
      this.secondStepperRules.biopsiaHospitalOuParticular.push(v => !!v || 'Campo obrigatório.')
    } else {
      const { biopsiaHospitalOuParticular, biopsiaParticularLocal } = this.secondStepperRules
      biopsiaHospitalOuParticular.splice(0, biopsiaHospitalOuParticular.length)
      biopsiaParticularLocal.splice(0, biopsiaParticularLocal.length)
      this.getSolicitacaoCirurgiaStore.clearBiopsiaHospitalOuParticular()
      this.getSolicitacaoCirurgiaStore.clearBiopsiaParticularLocal()
    }
    this.removerSemExameIntraOperatorios()
  }

  ultrassonografiaIntraoperatorioChange(checkbox: string) {
    if (this.getExamesIntraOperatorios.includes(checkbox)) {
      this.secondStepperRules[checkbox].push(v => v === true || v === false || 'Campo obrigatório.')
    } else {
      this.secondStepperRules[checkbox].splice(0, this.secondStepperRules[checkbox].length)
      this.getSolicitacaoCirurgiaStore.clearPrecisaEquipeHospital()
    }
    this.removerSemExameIntraOperatorios()
  }

  outrosChange(checkbox: string) {
    if (this.getExamesIntraOperatorios.includes(checkbox)) {
      this.secondStepperRules[checkbox].push(v => !!v || 'Campo obrigatório.')
    } else {
      this.secondStepperRules[checkbox].splice(0, this.secondStepperRules[checkbox].length)
      this.getSolicitacaoCirurgiaStore.clearOutrosExamesIntraOperatoriosEspecificar()
    }
    this.removerSemExameIntraOperatorios()
  }

  semExameIntraOperatorio() {
    const index = this.getExamesIntraOperatorios.indexOf('semExameIntraoperatorio')
    if (index > -1) {
      this.getExamesIntraOperatorios.splice(0, this.getExamesIntraOperatorios.length)
      this.getExamesIntraOperatorios.push('semExameIntraoperatorio')
    } else {
      this.getExamesIntraOperatorios.splice(0, this.getExamesIntraOperatorios.length)
    }

    this.getSolicitacaoCirurgiaStore.verificarIntraOperatorioValue()
    this.getSolicitacaoCirurgiaStore.clearPrecisaEquipeHospital()
    this.getSolicitacaoCirurgiaStore.clearOutrosExamesIntraOperatoriosEspecificar()
    this.getSolicitacaoCirurgiaStore.clearAnatomiaPatologicaHospitalOuParticular()
    this.getSolicitacaoCirurgiaStore.clearAnatomiaPatologicaParticularLocal()
    this.getSolicitacaoCirurgiaStore.clearBiopsiaHospitalOuParticular()
    this.getSolicitacaoCirurgiaStore.clearBiopsiaParticularLocal()
  }

  removerSemExameIntraOperatorios() {
    const index = this.getExamesIntraOperatorios.indexOf('semExameIntraoperatorio')
    if (index >= 0) {
      this.getExamesIntraOperatorios.splice(index, 1)
    }

    this.getSolicitacaoCirurgiaStore.verificarIntraOperatorioValue()
  }

  semReservaHemocomponentes() {
    const { concentradoHemacias, concentradoPlaquetas, crioprecipitado, plasmaFrescoCongelado, tipagemSanguineaABORHPAI } = this.solicitacaoCirurgia.reservaHemocomponentes

    if (concentradoHemacias.quantidade && concentradoHemacias.quantidade > 0) {
      this.getSolicitacaoCirurgiaStore.deleteReservaHemocomponente('concentradoHemacias')
      this.getSolicitacaoCirurgiaStore.clearHemocomponenteField('concentradoHemacias')
    }

    if (concentradoPlaquetas.quantidade && concentradoPlaquetas.quantidade > 0) {
      this.getSolicitacaoCirurgiaStore.deleteReservaHemocomponente('concentradoPlaquetas')
      this.getSolicitacaoCirurgiaStore.clearHemocomponenteField('concentradoPlaquetas')
    }

    if (crioprecipitado.quantidade && crioprecipitado.quantidade > 0) {
      this.getSolicitacaoCirurgiaStore.deleteReservaHemocomponente('crioprecipitado')
      this.getSolicitacaoCirurgiaStore.clearHemocomponenteField('crioprecipitado')
    }

    if (plasmaFrescoCongelado.quantidade && plasmaFrescoCongelado.quantidade > 0) {
      this.getSolicitacaoCirurgiaStore.deleteReservaHemocomponente('plasmaFrescoCongelado')
      this.getSolicitacaoCirurgiaStore.clearHemocomponenteField('plasmaFrescoCongelado')
    }

    if (this.getHemocomponentes.includes('tipagemSanguinea')) {
      this.getSolicitacaoCirurgiaStore.deleteReservaHemocomponente('tipagemSanguinea')
      this.getSolicitacaoCirurgiaStore.clearHemocomponenteField('tipagemSanguinea')
    }

    if (tipagemSanguineaABORHPAI.quantidade && tipagemSanguineaABORHPAI.quantidade > 0) {
      this.getSolicitacaoCirurgiaStore.deleteReservaHemocomponente('tipagemSanguineaABORHPAI')
      this.getSolicitacaoCirurgiaStore.clearHemocomponenteField('tipagemSanguineaABORHPAI')
    }

    const index = this.getHemocomponentes.indexOf('semReserva')
    if (index > -1) {
      this.getHemocomponentes.splice(0, this.getHemocomponentes.length)
      this.getHemocomponentes.push('semReserva')
      const hemocomponente: Hemocomponente = { quantidade: 0, tipo: 'semReserva', solicitacaoId: this.solicitacaoCirurgia.id }
      this.getSolicitacaoCirurgiaStore.postReservaHemocomponente(hemocomponente)
    } else {
      this.getHemocomponentes.splice(0, this.getHemocomponentes.length)
      this.getSolicitacaoCirurgiaStore.deleteReservaHemocomponente('semReserva')
    }
  }

  async postHemocomponente(tipo) {
    if (this.solicitacaoCirurgia.reservaHemocomponentes) {
      const { quantidade } = this.solicitacaoCirurgia.reservaHemocomponentes[tipo]

      switch (tipo) {
        case 'tipagemSanguinea':
          this.getSolicitacaoCirurgiaStore
            .deleteReservaHemocomponente(tipo)
            .then(() => {
              if (this.getHemocomponentes.includes('tipagemSanguinea')) {
                this.removerSemReservaHemocomponentes()
                const hemocomponente: Hemocomponente = { quantidade: 1, tipo, solicitacaoId: this.solicitacaoCirurgia.id }
                this.getSolicitacaoCirurgiaStore.postReservaHemocomponente(hemocomponente)
              }
            })
          break
        default:
          if (quantidade > 0) {
            this.getSolicitacaoCirurgiaStore
              .deleteReservaHemocomponente(tipo)
              .then(() => {
                const hemocomponente: Hemocomponente = { quantidade, tipo, solicitacaoId: this.solicitacaoCirurgia.id }
                this.getSolicitacaoCirurgiaStore.postReservaHemocomponente(hemocomponente)
              })
          }
          break
      }
    }
  }

  reservaHemocomponenteChange(checkbox: string) {
    if (this.getHemocomponentes.includes(checkbox)) {
      this.secondStepperRules[checkbox].push(v => !!v || 'Campo obrigatório.')
    } else {
      if (this.solicitacaoCirurgia.reservaHemocomponentes[checkbox].quantidade > 0) {
        this.getSolicitacaoCirurgiaStore.deleteReservaHemocomponente(checkbox)
      }

      this.secondStepperRules[checkbox].splice(0, this.secondStepperRules[checkbox].length)
      this.getSolicitacaoCirurgiaStore.clearHemocomponenteField(checkbox)
      this.deleteReservaHemocomponente(checkbox)
    }

    this.removerSemReservaHemocomponentes()
  }

  async deleteReservaHemocomponente(tipo) {
    const { quantidade } = this.solicitacaoCirurgia.reservaHemocomponentes[tipo]
    if (quantidade > 0 || tipo === 'semReserva') {
      const request = await this.getSolicitacaoCirurgiaStore.deleteReservaHemocomponente(tipo)
    }
  }

  removerSemReservaHemocomponentes() {
    const index = this.getHemocomponentes.indexOf('semReserva')
    if (index >= 0) {
      this.getHemocomponentes.splice(index, 1)
      this.getSolicitacaoCirurgiaStore.deleteReservaHemocomponente('semReserva')
    }
  }

  campoObrigatorioLabel(label: string, campo: string) {
    if (this.campoObrigatorio(campo)) return `${label} *`
    return label
  }

  campoObrigatorioLabelGuiaCirurgia(label: string, campo: string) {
    if (this.campoObrigatorioGuiaCirurgia(campo)) return `${label} *`
    return label
  }

  campoObrigatorio(campo: string) {
    const formulario = this.getSolicitacaoCirurgiaStore.currentTemplate
    if (formulario.formulario
      && formulario.formulario[campo]
      && (formulario.formulario[campo].obrigatorio
        || formulario.formulario[campo].obrigatorioParaTodosOsConvenios
        || formulario.formulario[campo].obrigatorioParaConvenioParticular)
    ) {
      if (campo === 'tipoAcomodacao') {
        return this.tipoAcomodacaoObrigatorio
      }
      return true
    }
    return false
  }

  campoObrigatorioGuiaCirurgia(campo: string) {
    if (this.guiaMedicaFields.includes(campo)
        && (!this.getSolicitacaoCirurgiaStore.currentTemplate.formulario
            || !this.getSolicitacaoCirurgiaStore.currentTemplate.formulario[campo])) {
      return true
    }

    return this.campoObrigatorio(campo)
  }

  get surgeryTeamDoctorDataFieldRule() {
    const rule: any = []

    if (this.campoObrigatorio('equipeMedica')) {
      rule.push(v => !!v || 'Campo obrigatório.')
    }

    return rule
  }

  getTemplateFieldDetails(field: string) {
    const formTemplate = this.getSolicitacaoCirurgiaStore.currentTemplate

    if (formTemplate.formulario && formTemplate.formulario[field]) {
      return formTemplate.formulario[field]
    }

    return null
  }

  subCampoObrigatorioLabel(label: string, field: string, prop: string) {
    const { formulario } = this.getSolicitacaoCirurgiaStore.currentTemplate
    if (formulario[field] && formulario[field].campos && formulario[field].campos[prop]) return `${label} *`
    return label
  }

  campoHabilitado(prop: string) {
    if (!this.finishedLoad) {
      return false
    }

    const normalizedProp = prop.split('.')[0]
    const getByPath = (obj: any, path: string) => path.split('.').reduce((acc: any, current: string) => acc && acc[current], obj)

    // Check editModelMode is enabled
    // If is enabled need enable just few fields
    if (this.editModelMode) {
      return this.canEnableFieldForEditModelMode(normalizedProp)
    }

    // eslint-disable-next-line
    const { formulario } = this.getSolicitacaoCirurgiaStore.currentTemplate

    if (this.budgetMode) {
      const responseBudgetMode = formulario ? getByPath(formulario, prop) : null

      if (responseBudgetMode && responseBudgetMode.habilitadoOrcamentoParticularAvulso !== undefined) {
        return !!responseBudgetMode.habilitadoOrcamentoParticularAvulso
      }

      return this.canEnableFieldForBudgetMode(normalizedProp)
    }

    const response = formulario ? getByPath(formulario, prop) : null
    if (response) return !!response.habilitado

    return false
  }

  campoHabilitadoGuiaCirurgia(prop: string) {
    if (this.guiaMedicaFields.includes(prop)
        && (!this.getSolicitacaoCirurgiaStore.currentTemplate.formulario
            || !this.getSolicitacaoCirurgiaStore.currentTemplate.formulario[prop])) {
      return true
    }

    return this.campoHabilitado(prop)
  }

  canEnableFieldForEditModelMode(fieldName: string) {
    const fields: string[] = [
      'justificativa',
      'cids',
      'procedimentosAssociados',
      'opmes',
      'tempoCirurgia',
      'nomeCirurgia',
      'equipamentos',
    ]

    return fields.includes(fieldName)
  }

  canEnableFieldForBudgetMode(fieldName: string) {
    const fields: string[] = [
      'nomePaciente',
      'dataNascimento',
      'sexoBudget',
      'tipoProcedimento',
      'procedimentosAssociados',
      'opmes',
      'reservaUti',
      'diariaUti',
      'tecnicaDaCirurgia',
      'tipoAcomodacaoBudgetMode',
    ]

    return fields.includes(fieldName)
  }

  get tipoAcomodacaoHis() {
    return !!this.getSolicitacaoCirurgiaStore.solicitacaoCirurgia.hospital.utilizaTipoAcomodacaoHospital
  }

  gradeMedica(prop) {
    if (this.getSolicitacaoCirurgiaStore.currentTemplate.formulario) {
      const response = this.getSolicitacaoCirurgiaStore.currentTemplate.formulario[prop]
      // eslint-disable-next-line
      if (response) return response['gradeMedica']
    }

    return false
  }

  lateralidadeHabilitado() {
    // Check editModelMode is enabled
    // If is enabled need enable just few fields
    if (this.editModelMode) {
      return this.canEnableFieldForEditModelMode('lateralidadeEmSolicitacao')
    }

    if (this.budgetMode) {
      return this.canEnableFieldForBudgetMode('lateralidadeEmSolicitacao')
    }

    if (this.getSolicitacaoCirurgiaStore.currentTemplate.formulario) {
      const response = this.getSolicitacaoCirurgiaStore.currentTemplate.formulario.lateralidade
      // eslint-disable-next-line
      if (response) return response['lateralidadeEmSolicitacao']
    }

    return false
  }

  opcaoHabilitado(prop1: string, prop2: string) {
    if (this.getSolicitacaoCirurgiaStore.currentTemplate.formulario) {
      const response = this.getSolicitacaoCirurgiaStore.currentTemplate.formulario[prop1]
        && this.getSolicitacaoCirurgiaStore.currentTemplate.formulario[prop1].campos
        && this.getSolicitacaoCirurgiaStore.currentTemplate.formulario[prop1].campos[prop2]
      return response
    }

    return false
  }

  showModalSair() {
    this.loadingClosePage = true
    this.getSolicitacaoCirurgiaStore.clearReservaHemocomponentes()
    this.getSolicitacaoCirurgiaStore.clearSolicitacaoCirurgia()
    this.getSolicitacaoStore.clearSolicitacao()
    this.getReservaDeSangueStore.clearReservaDeSangue()
    this.getSolicitacaoCirurgiaStore.setHospitalNome('')
    this.getSolicitacaoCirurgiaStore.clearConsultaPacienteCpf()
    this.getSolicitacaoCirurgiaStore.clearConsultaPacienteNome()
    this.getSolicitacaoStore.clearSolicitacao()
    this.loadingClosePage = false
    this.$router.push('/agendamento-medico')
  }

  async showModalBuscarPaciente() {
    this.loadingBuscarPaciente = true
    await timeout(1000)
    this.getSolicitacaoCirurgiaStore.setShowModalBuscarPaciente(true)
    this.loadingBuscarPaciente = false
  }

  get getIdade() {
    const nascimento = this.getSolicitacaoCirurgiaStore.solicitacaoCirurgia.paciente
      .dataNascimento
    if (nascimento) {
      const diff = Date.now() - new Date(`${nascimento}`).getTime()
      const ageDate = new Date(diff)
      const age = Math.abs(ageDate.getUTCFullYear() - 1970)
      this.getSolicitacaoCirurgiaStore.setIdade(age)
    } else {
      this.getSolicitacaoCirurgiaStore.solicitacaoCirurgia.paciente.idade = null
    }

    return this.getSolicitacaoCirurgiaStore.solicitacaoCirurgia.paciente.idade
  }

  calculateAge() {
    const nascimento = this.getSolicitacaoCirurgiaStore.solicitacaoCirurgia.paciente
      .dataNascimento
    if (nascimento) {
      const diff = Date.now() - new Date(`${nascimento}`).getTime()
      const ageDate = new Date(diff)
      const age = Math.abs(ageDate.getUTCFullYear() - 1970)
      this.getSolicitacaoCirurgiaStore.setIdade(age)
    } else {
      this.getSolicitacaoCirurgiaStore.solicitacaoCirurgia.paciente.idade = null
    }
  }

  async fetchSurgerySolicitationEligibilityInfo() {
    try {
      this.loadingHealthInsuranceCardId = true

      const eligibilityApiResponse = await ApiRequestWithRetry(
        () => this.getSolicitacaoCirurgiaStore.getSurgerySolicitationEligibilityInfo({
          surgerySolicitationId: this.solicitacaoCirurgia.id,
          healthInsuranceCardId: this.solicitacaoCirurgia.paciente.carteirinha,
          healthInsuranceId: this.solicitacaoCirurgia.paciente.convenioId,
          procedureType: this.solicitacaoCirurgia.tipoProcedimento,
        }),
        1,
        0,
      )

      if (eligibilityApiResponse.success) {
        if (eligibilityApiResponse.data && eligibilityApiResponse.data.elegivel) {
          this.procedureEligibilityData = eligibilityApiResponse.data.procedimentoInternacao.map(item => ({
            id: item.id,
            description: `${item.tipo} - ${item.codigo} - ${item.descricao}`,
          }))

          if (this.procedureEligibilityData.length === 1) {
            const [firstProcedure] = this.procedureEligibilityData
            this.solicitacaoCirurgia.solicitacaoProcedimentoInternacao!.procedimentoInternacaoId = firstProcedure.id
          } else if (!this.procedureEligibilityData || this.procedureEligibilityData.length === 0 || eligibilityApiResponse.data) {
            this.solicitacaoCirurgia.solicitacaoProcedimentoInternacao!.procedimentoInternacaoId = ''
          }
        } else {
          this.solicitacaoCirurgia.solicitacaoProcedimentoInternacao!.procedimentoInternacaoId = ''
        }
      } else {
        this.solicitacaoCirurgia.solicitacaoProcedimentoInternacao!.procedimentoInternacaoId = ''
      }
    } finally {
      this.disableSignAndSendSurgerySolicitationButton = false
      this.loadingHealthInsuranceCardId = false
    }
  }


  procedureEligibilityData: {
    id: string,
    description: string,
  }[] = []

  loadingHealthInsuranceCardId: boolean = false

  async handleSurgerySolicitationEligibilityInfoFetch() {
    if (this.hasAuthorizationFlowEnabled) {
      this.disableSignAndSendSurgerySolicitationButton = true
      await this.debouncedFetchSurgerySolicitationEligibilityInfo()
    }
  }

  get hasAuthorizationFlowEnabled(): boolean {
    return !!(
      this.solicitacaoCirurgia.id
      && this.solicitacaoCirurgia.paciente.carteirinha
      && this.solicitacaoCirurgia.tipoProcedimento
      && this.solicitacaoCirurgia.paciente.convenioId
      && (
        this.patientHealthInsuranceData
        && this.patientHealthInsuranceData.autorizadorTipo
        && this.patientHealthInsuranceData.autorizadorTipo === 'SisAmil'
      )
    )
  }

  async healthInsuranceCardIdInput() {
    await this.handleSurgerySolicitationEligibilityInfoFetch()
  }

  async healthInsuranceCardIdPaste(event: ClipboardEvent) {
    this.pasteAlphaNumeric(event)

    await this.handleSurgerySolicitationEligibilityInfoFetch()
  }

  onlyAlphaNumericUtil(e: KeyboardEvent) {
    return onlyAlphaNumeric(e)
  }

  isAnonymized(value: string | null | undefined): boolean {
    return typeof value === 'string' && (value.includes('#') || value.includes('*'))
  }

  clearIfAnonymized(obj: any, key: string): void {
    if (this.isAnonymized(obj[key])) {
      this.$nextTick(() => {
        obj[key] = ''
      })
    }
  }

  handleHospitalDaily(event) {
    return allowOnlyNumbersThatDoNotStartWithZero(event, this.solicitacaoCirurgia.diaria)
  }

  onPhoneInput(value: string) {
    if (this.isAnonymized(value)) {
      this.$nextTick(() => {
        this.patientData.telefone = ''
      })
      return
    }
    const raw = value.replace(/[^0-9#]/g, '')
    if (raw.length > 11) {
      return
    }
    this.patientData.telefone = formatAnonymizedPhoneNumber(raw)
  }

  onCellphoneInput(value: string) {
    if (this.isAnonymized(value)) {
      this.$nextTick(() => {
        this.patientData.celular = ''
      })
      return
    }
    const raw = value.replace(/[^0-9#]/g, '')
    if (raw.length > 11) {
      return
    }
    this.patientData.celular = formatAnonymizedPhoneNumber(raw)
  }

  pasteAlphaNumeric(event: ClipboardEvent) {
    event.preventDefault()

    const alphaNumericPattern = /[^A-Z0-9-]+/ig
    const maxLength = this.getTemplate.carteirinha.tamanhoMaximoDeCaracteres || 30

    const input = event.target as HTMLInputElement
    const clipboardText = (event.clipboardData || (window as any).clipboardData).getData('text')

    let newValue = clipboardText.replace(alphaNumericPattern, '')
    newValue = newValue.substring(0, maxLength)

    input.value = newValue

    const nativeInputEvent = new Event('input', { bubbles: true })
    input.dispatchEvent(nativeInputEvent)
  }

  onlyNumberUtil(num: string) {
    return onlyNumber(num)
  }

  limitarIdadeGestacional(value: number) {
    limitarIdadeGestacionalCommon(value, (max) => {
      this.solicitacaoCirurgia.dadosGestacionais.idadeGestacional = max
    })
  }

  habilitaCamposGestacionais() {
    const procedimentoPrincipalHabilitaCamposGestacionais = !!(this.procedimentoPrincipal && this.procedimentoPrincipal.habilitaCamposGestacionais)
    const existeProcedimentoAssociadoComCamposGestacionaisHabilitados = !!(
      this.getProcedimentoAssociados
      && this.getProcedimentoAssociados.some(procedimentoAssociado => !!procedimentoAssociado.habilitaCamposGestacionais)
    )

    const habilita = procedimentoPrincipalHabilitaCamposGestacionais || existeProcedimentoAssociadoComCamposGestacionaisHabilitados

    if (!habilita) {
      this.removeDadosGestacionais()
    }

    return habilita
  }

  minutesToHoursUtil(value) {
    return minutesToHours(value)
  }

  onlyFloatUtil(value) {
    return onlyFloat(value)
  }

  async setConvenio(convenioId: string) {
    this.getSolicitacaoCirurgiaStore.setConvenio(convenioId)
    await this.convenioChange(convenioId)
  }

  validarCPF(cpf: string) {
    if (cpf) return validateCPF(cpf)
    return true
  }

  validarTelefoneForm(telefone: string) {
    if (this.isAnonymized(telefone)) {
      return true
    }
    return validateTelefoneForm(telefone)
  }

  validarCelular(celular: string = '') {
    if (this.isAnonymized(celular)) {
      return true
    }
    const masks = this.currentCountry ? this.currentCountry.mask : ['(##) ####-####', '(##) #####-####']
    const cellphoneLengths: number[] = []
    masks.forEach((mask: any) => {
      if (!mask) return true
      cellphoneLengths.push((mask as string).replaceAll(/[()-\s]/ig, '').length)
      return mask
    })
    return cellphoneLengths.includes(celular.replaceAll(/[()-\s]/ig, '').length)
  }

  validarTelefone(telefone: string) {
    return validateTelefone(telefone)
  }

  validarEmail(email: string) {
    return validateEmail(email)
  }

  validarEmailForm(email: string) {
    return validateEmailForm(email)
  }

  possuiOMesmoFornecedor(id1: string | undefined, id2: string | undefined, id3: string | undefined) {
    // eslint-disable-next-line
    id1 = id1 || 'id1'
    // eslint-disable-next-line
    id2 = id2 || 'id2'
    // eslint-disable-next-line
    id3 = id3 || 'id3'

    if (id1 === id2 || id1 === id3 || id2 === id3) {
      return true
    }

    return false
  }

  possuiFornecedoresDuplicados() {
    const exists = !this.grupoDeOpme!.opmes.every((opme) => {
      const { fornecedor1Id, fornecedor2Id, fornecedor3Id } = opme
      return !this.possuiOMesmoFornecedor(fornecedor1Id, fornecedor2Id, fornecedor3Id)
    })

    if (exists) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Existem materiais com fornecedores duplicados, revise a lista de materiais.', icon: 'warning', color: '#C62828', timeout: 5500 })
    }

    return exists
  }

  returnNumber(value: any) {
    return ['', null, undefined].includes(value) ? 0 : parseInt(value, 10)
  }

  async addAnestesista() {
    this.loadingAddAnestesista = true
    this.getSolicitacaoCirurgiaStore.setModal({ name: 'listaDeAnestesistas', value: true })
    this.loadingAddAnestesista = false
  }

  origemPacienteAtivoNasInformacoesAssistenciais: boolean = false

  async templateConfiguracao() {
    const isDetails = this.$route.path.includes('/solicitacao-cirurgia-details')
    const { formulario } = this.getSolicitacaoCirurgiaStore.currentTemplate
    if (!isDetails) {
      // eslint-disable-next-line
      ;(window['validarCPF'] = (cpf) => this.isCpfAnonymized ? true : this.validarCPF(cpf) || 'Informe um CPF válido.'),
      // eslint-disable-next-line
      (window['validarTelefoneForm'] = (telefone) => this.validarTelefoneForm(telefone) || 'Informe um número válido.'),
      // eslint-disable-next-line
      (window['validarTelefone'] = (telefone) => this.validarCelular(telefone) || 'Informe um número válido.'),
      // eslint-disable-next-line
      (window['validarEmail'] = (email) => this.validarEmail(email) || 'Informe um e-mail válido.'),
      // eslint-disable-next-line
      (window['validarEmailForm'] = (email) => this.validarEmailForm(email) || 'Informe um e-mail válido.')

      const origemPacienteAtivoNasInformacoesAssistenciais = Boolean(formulario.origemPaciente.ativoNasInformacoesAssistenciais)
      this.origemPacienteAtivoNasInformacoesAssistenciais = origemPacienteAtivoNasInformacoesAssistenciais

      const stepperOneKey: string[] = [
        'nomePaciente',
        'cpf',
        'rgh',
        'cpfResponsavel',
        'rne',
        'livro',
        'folha',
        'termo',
        'dataNascimento',
        'convenio',
        'plano',
        'categoria',
        'sexo',
        'peso',
        'altura',
        'nacionalidade',
      ]

      if (origemPacienteAtivoNasInformacoesAssistenciais) stepperOneKey.push('origemPaciente')

      const secondOneKey: string[] = [
        'cpf',
        'cpfResponsavel',
        'rne',
        'livro',
        'folha',
        'termo',
        'nacionalidade',
        'numeroDoAtendimentoAoPacienteNoHospital',
        'carater',
        'justificativa',
        'justificativaDePrazo',
        'internacaoDeVespera',
        'reservaHemocomponentesSimples',
        'tipoProcedimento',
        'anestesiaHospital',
        'examesIntraOperatorios',
        'medicoExecutante',
        'alergiaLatex',
        'necessidadesEspeciais',
        'restricaoReligiosa',
        'necessidadesPsicologicas',
        'necessidadesMedicasEspeciais',
        'exameFisicoEResultadoDeExames',
        'necessidadesEconomicas',
        'necessidadesSociais',
        'pacienteB24Positivo',
        'pacienteEhTestemunhaDeJeova',
        'pacienteEhDiabetico',
        'alergiaContraste',
        'testeCovid',
        'marcapasso',
        'reoperacao',
        'precaucoes',
        'medicamentosEspeciais',
        'medicacaoContinua',
        'equipeMedica',
        'opmeDoConsultorio',
        'instrumentadorExterno',
        'previsaoUsoQuimioterapico',
        'reservaHemocomponentes',
        'reservaUti',
        'tempoCirurgia',
        'diaria',
        'diariaUti',
        'orientacaoPreparoPaciente',
        'opcaoDataPrevisto1',
        'opcaoDataPrevisto2',
        'opcaoDataPrevisto3',
        'dataAgendamentoVirtual',
        'instrucaoDataPrevista',
        'honorarioMedico',
        'medicoConvidado',
        'reservaDeSangue',
        'instrumentalAdicional',
        'lateralidade',
        'tecnicaDaCirurgia',
        'pesoDoPaciente',
        'tempoDeDoenca',
        'idadeGestacional',
        'gemelar',
        'classificacaoPacienteOncologico',
        'farmacia',
        'centroCirurgico',
        'regiaoDaCirurgia',
        'comorbidade',
        'medicacaoDapt',
        'funcaoRenal',
        'complexidade',
        'classificacaoCirurgia',
        'tipoAnestesia',
        'horasDeAntecedenciaDeInternacao',
        'tipoCentroCirurgico',
      ]

      const thirdOneKey: string[] = [
        'cpf',
        'cpfResponsavel',
        'rne',
        'livro',
        'folha',
        'termo',
        'nacionalidade',
        'nomePaciente',
        'dataNascimento',
        'recemNascido',
        'sexo',
        'telefone',
        'celular',
        'email',
        'convenio',
        'plano',
        'categoria',
        'tipoAcomodacao',
        'carteirinha',
        'diferencaDeAcomodacao',
        'operadoraSenhaProvisoria',
        'diariaProcedimentoInternacao',
      ]

      if (!origemPacienteAtivoNasInformacoesAssistenciais) thirdOneKey.push('origemPaciente')

      this.stepperRules(stepperOneKey, 'firstStepperRules')
      this.stepperRules(secondOneKey, 'secondStepperRules')
      this.stepperRules(thirdOneKey, 'thirdStepperRules')

      const {
        examesIntraOperatorios,
        reservaHemocomponentes,
        convenio,
        plano,
        categoria,
        sexo,
        origemPaciente,
        opmes,
        opcaoDataPrevisto1,
        hospitalInformaPacienteInternado,
      } = this.getSolicitacaoCirurgiaStore.currentTemplate.formulario

      // Regra para verificar os exames intra-operatorios
      if (examesIntraOperatorios && examesIntraOperatorios.obrigatorio) {
        this.secondStepperRules.examesIntraOperatorios.push(v => (v && v.length > 0) || 'Campo obrigatório')
      }

      // Regra para verificar paciente internado
      if (hospitalInformaPacienteInternado && hospitalInformaPacienteInternado.obrigatorio && this.surgerySolicitationActions.doctorCanEditHospitalizedPatientData) {
        this.secondStepperRules.pacienteEstaInternado.push(v => typeof v === 'boolean' || 'Campo obrigatório')
      }

      // Regra para verificar os reserva hemocomponentes
      if (reservaHemocomponentes && reservaHemocomponentes.obrigatorio) {
        this.secondStepperRules.reservaHemocomponentes.push(v => (v && v.length > 0) || 'Campo obrigatório')
      }

      if (convenio && convenio.obrigatorio) {
        this.firstStepperRules.convenio.push(v => (v && v.length > 0) || 'Campo obrigatório')
        this.thirdStepperRules.convenio.push(v => (v && v.length > 0) || 'Campo obrigatório')
      }

      if (origemPaciente && origemPaciente.obrigatorio) {
        if (origemPacienteAtivoNasInformacoesAssistenciais) {
          this.firstStepperRules.origemPaciente.push((v: any) => (v && v.length > 0 && v !== '00000000-0000-0000-0000-000000000000') || 'Campo obrigatório')
        } else {
          this.thirdStepperRules.origemPaciente.push((v: any) => (v && v.length > 0 && v !== '00000000-0000-0000-0000-000000000000') || 'Campo obrigatório')
        }
      }

      if (opmes && opmes.habilitarGrade) {
        this.getSolicitacaoCirurgiaStore.setHabilitarGrade(opmes.habilitarGrade)
      }

      if (opcaoDataPrevisto1 && opcaoDataPrevisto1.obrigatorio && this.secondStepperRules.opcaoDataPrevisto1) {
        this.secondStepperRules.opcaoDataPrevisto1.push(v => !!v || 'Campo obrigatório')
      }

      // Aplica obrigatoriedade do CPF conforme template (formulario.cpf.obrigatorio).
      // Quando marcar que o paciente não possui CPF as validações são removidas.
      const cpfObrigatorioPeloTemplate = formulario.cpf && formulario.cpf.habilitado && formulario.cpf.obrigatorio
      if (cpfObrigatorioPeloTemplate && !this.solicitacaoCirurgia.paciente.pacienteNaoPossuiCpf) {
        this.firstStepperRules.cpf.push(v => !!v || 'Campo obrigatório.')
        this.secondStepperRules.cpf.push(v => !!v || 'Campo obrigatório.')
        this.thirdStepperRules.cpf.push(v => !!v || 'Campo obrigatório.')
      } else if (this.solicitacaoCirurgia.paciente.pacienteNaoPossuiCpf || !(formulario.cpf && formulario.cpf.habilitado)) {
        // Só limpa todas as regras quando o paciente não possui CPF ou o campo não está habilitado (mantém validarCPF quando opcional)
        this.firstStepperRules.cpf.splice(0, this.firstStepperRules.cpf.length)
        this.secondStepperRules.cpf.splice(0, this.secondStepperRules.cpf.length)
        this.thirdStepperRules.cpf.splice(0, this.thirdStepperRules.cpf.length)

        this.$refs.firstStepperForm.resetValidation()
        this.$refs.secondStepperForm.resetValidation()
        this.$refs.thirdStepperForm.resetValidation()
      }

      // Cria ou remove as regras do formulario para os campos de RNE
      this.createOrRemoveRneFormRules()

      // Configura regras do CPF na aba de autorização baseado no template
      this.configureAuthorizationTabCpfRules()

      // Deixa a lateralidade sempre como obrigatória caso não seja edit model mode
      // Implementado porque alguns procedimentos carregados na base não informavam necessidade de lateralidade
      // Então para evitar erros, foi colocado como obrigatório
      if (!this.editModelMode) {
        this.secondStepperRules.lateralidade.push(v => !!v || 'Campo obrigatório')
      }
    }
  }

  createOrRemoveRneFormRules() {
    // Limpa as validações dos campos de RNE
    this.firstStepperRules.dataNascimento.splice(0, this.firstStepperRules.dataNascimento.length)
    this.thirdStepperRules.dataNascimento.splice(0, this.firstStepperRules.dataNascimento.length)

    const formulario = this.getSolicitacaoCirurgiaStore.currentTemplate
    if (formulario.formulario
      && formulario.formulario.dataNascimento
      && formulario.formulario.dataNascimento.obrigatorio) {
      this.firstStepperRules.dataNascimento.push(v => !!v || 'Campo obrigatório.')
      this.thirdStepperRules.dataNascimento.push(v => !!v || 'Campo obrigatório.')
    }

    this.firstStepperRules.cpfResponsavel.splice(0, this.firstStepperRules.cpfResponsavel.length)
    this.secondStepperRules.cpfResponsavel.splice(0, this.secondStepperRules.cpfResponsavel.length)
    this.thirdStepperRules.cpfResponsavel.splice(0, this.thirdStepperRules.cpfResponsavel.length)

    this.firstStepperRules.livro.splice(0, this.firstStepperRules.livro.length)
    this.secondStepperRules.livro.splice(0, this.secondStepperRules.livro.length)
    this.thirdStepperRules.livro.splice(0, this.thirdStepperRules.livro.length)

    this.firstStepperRules.folha.splice(0, this.firstStepperRules.folha.length)
    this.secondStepperRules.folha.splice(0, this.secondStepperRules.folha.length)
    this.thirdStepperRules.folha.splice(0, this.thirdStepperRules.folha.length)

    this.firstStepperRules.termo.splice(0, this.firstStepperRules.termo.length)
    this.secondStepperRules.termo.splice(0, this.secondStepperRules.termo.length)
    this.thirdStepperRules.termo.splice(0, this.thirdStepperRules.termo.length)

    this.firstStepperRules.nacionalidade.splice(0, this.firstStepperRules.nacionalidade.length)
    this.secondStepperRules.nacionalidade.splice(0, this.secondStepperRules.nacionalidade.length)
    this.thirdStepperRules.nacionalidade.splice(0, this.thirdStepperRules.nacionalidade.length)

    // Limpa as validações dos campos de RNE

    // Seta as validações do campo de RNE caso necessário
    if (this.campoHabilitado('documentacaoObrigatoriaDoPaciente') && this.solicitacaoCirurgia.paciente.pacienteNaoPossuiCpf) {
      if (this.solicitacaoCirurgia.paciente.tipoPaciente === TipoPacienteEnum.MenorDe12) {
        this.firstStepperRules.dataNascimento.push(v => this.getIdade! < 12 || 'Paciente maior de 12 anos')
        this.thirdStepperRules.dataNascimento.push(v => this.getIdade! < 12 || 'Paciente maior de 12 anos')

        if (this.getTemplate.documentacaoObrigatoriaDoPaciente && this.getTemplate.documentacaoObrigatoriaDoPaciente.obrigatorio) {
          this.firstStepperRules.cpfResponsavel.push(v => !!v || 'Campo obrigatório.')
          this.firstStepperRules.livro.push(v => !!v || 'Campo obrigatório.')
          this.firstStepperRules.folha.push(v => !!v || 'Campo obrigatório.')
          this.firstStepperRules.termo.push(v => !!v || 'Campo obrigatório.')
          this.secondStepperRules.cpfResponsavel.push(v => !!v || 'Campo obrigatório.')
          this.secondStepperRules.livro.push(v => !!v || 'Campo obrigatório.')
          this.secondStepperRules.folha.push(v => !!v || 'Campo obrigatório.')
          this.secondStepperRules.termo.push(v => !!v || 'Campo obrigatório.')
          this.thirdStepperRules.cpfResponsavel.push(v => !!v || 'Campo obrigatório.')
          this.thirdStepperRules.livro.push(v => !!v || 'Campo obrigatório.')
          this.thirdStepperRules.folha.push(v => !!v || 'Campo obrigatório.')
          this.thirdStepperRules.termo.push(v => !!v || 'Campo obrigatório.')
        }
      }

      if (this.solicitacaoCirurgia.paciente.tipoPaciente === TipoPacienteEnum.RecemNascido) {
        this.firstStepperRules.dataNascimento.push(v => this.isPacienteRecemNascido || 'Paciente tem mais de 28 dias')
        this.thirdStepperRules.dataNascimento.push(v => this.isPacienteRecemNascido || 'Paciente tem mais de 28 dias')

        if (this.getTemplate.documentacaoObrigatoriaDoPaciente && this.getTemplate.documentacaoObrigatoriaDoPaciente.obrigatorio) {
          this.firstStepperRules.cpfResponsavel.push(v => !!v || 'Campo obrigatório.')
          this.secondStepperRules.cpfResponsavel.push(v => !!v || 'Campo obrigatório.')
          this.thirdStepperRules.cpfResponsavel.push(v => !!v || 'Campo obrigatório.')
        }
      }

      if (this.solicitacaoCirurgia.paciente.tipoPaciente === TipoPacienteEnum.Estrangeiro) {
        if (this.getTemplate.nacionalidade && this.getTemplate.nacionalidade.obrigatorio) {
          this.firstStepperRules.nacionalidade.push(v => !!v || 'Campo obrigatório.')
          this.secondStepperRules.nacionalidade.push(v => !!v || 'Campo obrigatório.')
          this.thirdStepperRules.nacionalidade.push(v => !!v || 'Campo obrigatório.')
        }
      }
    } else {
      if (this.$refs.firstStepperForm) {
        this.$refs.firstStepperForm.resetValidation()
      }

      if (this.$refs.secondStepperForm) {
        this.$refs.secondStepperForm.resetValidation()
      }

      if (this.$refs.thirdStepperForm) {
        this.$refs.thirdStepperForm.resetValidation()
      }
    }
  }

  get isPacienteRecemNascido() {
    if (!this.solicitacaoCirurgia.paciente.dataNascimento) {
      return false
    }

    const limitDate = moment().subtract(28, 'days')
    const birthDate = moment(this.solicitacaoCirurgia.paciente.dataNascimento)

    return !birthDate.isBefore(limitDate)
  }

  get tipoPaciente() {
    return this.solicitacaoCirurgia.paciente.tipoPaciente
  }

  set tipoPaciente(value) {
    this.solicitacaoCirurgia.paciente.tipoPaciente = value
  }

  onNecessidadesEspeciaisChange(value: string | null) {
    if (!this.finishedLoad) {
      return
    }

    if (value !== 'Outras') {
      this.solicitacaoCirurgia.detalhamentoNecessidadesEspeciais = ''
    }
  }

  onRestricaoReligiosaChange(value: string | null) {
    if (!this.finishedLoad) {
      return
    }

    if (value === 'Nenhuma') {
      this.solicitacaoCirurgia.detalhamentoRestricaoReligiosa = ''
    }
  }

  @Watch('getSolicitacaoCirurgiaStore.solicitacaoCirurgia.paciente.idade')
  onIdadeChange() {
    if (this.comorbidadesDoPacienteHabilitado()) {
      this.fetchComorbidades()
    }
  }

  @Watch('solicitacaoCirurgia.paciente.convenioId')
  async onHealthInsuranceChange(healthInsuranceId) {
    const { hospitalId } = this.solicitacaoCirurgia

    const healthInsuranceData = await this.getSolicitacaoCirurgiaStore.getHealthInsuranceById({ hospitalId, healthInsuranceId })
    const {
      prazoEmDiasParaSolicitarCirurgiaComOpme: suggestedSurgeryDateDaysWithOPME,
      prazoEmDiasParaSolicitarCirurgiaSemOpme: suggestedSurgeryDateDaysWithoutOPME,
    } = healthInsuranceData

    if (this.solicitacaoCirurgia.hospital.hospitalConfiguraDataSugeridaEmDiasUteis) {
      this.suggestedSurgeryDateWithOPME = suggestedSurgeryDateDaysWithOPME ? new Intl.DateTimeFormat('pt-BR').format(adicionarDiasUteisComFeriados(suggestedSurgeryDateDaysWithOPME)) : null
      this.suggestedSurgeryDateWithoutOPME = suggestedSurgeryDateDaysWithoutOPME ? new Intl.DateTimeFormat('pt-BR').format(adicionarDiasUteisComFeriados(suggestedSurgeryDateDaysWithoutOPME)) : null
    } else {
      this.suggestedSurgeryDateWithOPME = suggestedSurgeryDateDaysWithOPME ? moment().add(suggestedSurgeryDateDaysWithOPME, 'days').format('DD/MM/YYYY') : null
      this.suggestedSurgeryDateWithoutOPME = suggestedSurgeryDateDaysWithoutOPME ? moment().add(suggestedSurgeryDateDaysWithoutOPME, 'days').format('DD/MM/YYYY') : null
    }

    await this.getSolicitacaoCirurgiaStore.getAllPlanos()
  }

  onFirstSurgeryDateOptionFieldChange() {
    this.solicitacaoCirurgia.justificativaDePrazo = ''
  }

  onSecondSurgeryDateOptionFieldChange() {
  }

  onThirdSurgeryDateOptionFieldChange(date) {
  }

  async onComplexityChange(complexity: 'Baixa' | 'Media' | 'Alta') {
    await this.refreshInvalidSchedulingDatesForCurrentSelection(complexity)
  }

  async onSurgeryCenterChange() {
    await this.refreshInvalidSchedulingDatesForCurrentSelection()
  }

  buildCurrentSurgerySchedulingLimitParams(complexity = this.solicitacaoCirurgia.complexidade as 'Baixa' | 'Media' | 'Alta') {
    return buildSurgerySchedulingLimitParams({
      shouldCheck: this.surgerySolicitationActions.checkSurgeryLimiter,
      hospitalId: this.solicitacaoCirurgia.hospitalId,
      complexity,
      surgeryCenterId: this.solicitacaoCirurgia.centroCirurgicoId,
    })
  }

  async refreshInvalidSchedulingDatesForCurrentSelection(complexity?: 'Baixa' | 'Media' | 'Alta') {
    const params = this.buildCurrentSurgerySchedulingLimitParams(complexity)

    if (params) {
      await this.refreshInvalidSchedulingDates(params)
    }
  }

  getInvalidSelectedSchedulingDateFields() {
    const schedulingDateFields = [
      'opcaoDataPrevisto1',
      'opcaoDataPrevisto2',
      'opcaoDataPrevisto3',
    ] as const

    return schedulingDateFields.filter(field => isInvalidSchedulingDate(
      this.invalidSchedulingDates,
      this.solicitacaoCirurgia[field],
    ))
  }

  clearSchedulingDateOptions(fields: Array<'opcaoDataPrevisto1' | 'opcaoDataPrevisto2' | 'opcaoDataPrevisto3'>) {
    fields.forEach((field) => {
      this.solicitacaoCirurgia[field] = ''
    })
  }

  async refreshInvalidSchedulingDates(params: SurgerySchedulingLimitParams) {
    this.invalidSchedulingDates = await getInvalidSchedulingDates(params)

    const invalidSelectedSchedulingDateFields = this.getInvalidSelectedSchedulingDateFields()
    const hasInvalidSelectedSchedulingDates = invalidSelectedSchedulingDateFields.length > 0

    if (hasInvalidSelectedSchedulingDates) {
      this.clearSchedulingDateOptions(invalidSelectedSchedulingDateFields)
      this.notifyError('A data selecionada não é válida para o agendamento dessa cirurgia. Por favor, escolha outra data.')
    }
  }

  @Watch('tipoPaciente')
  onChangeTipoPaciente(newValue) {
    const { paciente } = this.solicitacaoCirurgia

    this.$refs.firstStepperForm.resetValidation()

    switch (newValue) {
      case TipoPacienteEnum.MenorDe12:
        // @ts-ignore
        if (this.solicitacaoCirurgia.id !== 'new') paciente.recemNascido = false
        paciente.rne = ''
        paciente.passaporte = ''
        paciente.paisId = null
        break
      case TipoPacienteEnum.RecemNascido:
        // @ts-ignore
        if (this.solicitacaoCirurgia.id !== 'new') paciente.recemNascido = true
        paciente.rne = ''
        paciente.passaporte = ''
        paciente.passaporte = null
        paciente.certidaoNascimentoLivro = ''
        paciente.certidaoNascimentoFolha = ''
        paciente.certidaoNascimentoTermo = ''
        break
      case TipoPacienteEnum.Estrangeiro:
        // @ts-ignore
        if (this.solicitacaoCirurgia.id !== 'new') paciente.recemNascido = false
        paciente.cpfResponsavel = ''
        paciente.certidaoNascimentoLivro = ''
        paciente.certidaoNascimentoFolha = ''
        paciente.certidaoNascimentoTermo = ''
        break
      default:
        paciente.rne = ''
        paciente.passaporte = ''
        paciente.paisId = null
        paciente.cpfResponsavel = ''
        paciente.certidaoNascimentoLivro = ''
        paciente.certidaoNascimentoFolha = ''
        paciente.certidaoNascimentoTermo = ''
    }
  }

  tempoCirurgicoModificado: boolean = false

  validateTempoCirurgicoMinimoEmMitunos(value: any) {
    const tempoCirurgia: number = Number.isNaN(value) ? 0 : Number(value)
    if (this.procedimentoPrincipal && this.procedimentoPrincipal.tempoCirurgicoMinimoEmMinutos) {
      return tempoCirurgia >= this.procedimentoPrincipal.tempoCirurgicoMinimoEmMinutos
        ? false
        : `Tempo mínimo: ${this.procedimentoPrincipal.tempoCirurgicoMinimoEmMinutos} minutos.`
    }
    return false
  }

  @Watch('solicitacaoCirurgia.tempoCirurgia')
  onChangeSolicitacaoCirurgiaTempoCirurgia(value: any) {
    if (
      this.procedimentoPrincipal
      && this.procedimentoPrincipal.tempoCirurgicoMinimoEmMinutos
      && this.procedimentoPrincipal.tempoCirurgicoMinimoEmMinutos > 0
    ) {
      const tempoCirurgia: number = Number.isNaN(value) ? 0 : Number(value)
      this.tempoCirurgicoModificado = tempoCirurgia < this.procedimentoPrincipal.tempoCirurgicoMinimoEmMinutos
    }
  }

  @Watch('procedimentoPrincipal')
  onChangeProcedimentoPrincipal(value: any, old: any) {
    if (
      !value.tempoCirurgicoMinimoEmMinutos
      && this.secondStepperRules.tempoCirurgia
      && this.secondStepperRules.tempoCirurgia.length > 0
    ) {
      this.solicitacaoCirurgia.tempoCirurgia = !('quantidade' in old) ? this.solicitacaoCirurgia.tempoCirurgia : 0
      this.tempoCirurgicoModificado = false
      this.secondStepperRules.tempoCirurgia.splice(0, this.secondStepperRules.tempoCirurgia.length)
      if (this.campoObrigatorio('tempoCirurgia')) this.secondStepperRules.tempoCirurgia.push(((v: any) => +v >= 15 || 'Campo obrigatório'))

      if (this.$refs.tempoCirurgia) {
        this.$refs.tempoCirurgia.resetValidation()
      }
    }

    if (value.tempoCirurgicoMinimoEmMinutos && value.tempoCirurgicoMinimoEmMinutos > 0) {
      this.secondStepperRules.tempoCirurgia.splice(0, this.secondStepperRules.tempoCirurgia.length)
      if (this.campoObrigatorio('tempoCirurgia')) this.secondStepperRules.tempoCirurgia.push(((v: any) => +v >= 15 || 'Campo obrigatório'))
      this.secondStepperRules.tempoCirurgia.push((v: any) => this.validateTempoCirurgicoMinimoEmMitunos(v))
    }
  }

  validarTempoDeDoenca(v) {
    const value = +v
    if (!Number.isNaN(value) && value > 0) {
      this.$refs.tempoDeDoencaAnos.errorBucket = []
      this.$refs.tempoDeDoencaMeses.errorBucket = []
      this.$refs.tempoDeDoencaDias.errorBucket = []
    }

    const anos = +this.$refs.tempoDeDoencaAnos.$refs.input.value || 0
    const meses = +this.$refs.tempoDeDoencaMeses.$refs.input.value || 0
    const dias = +this.$refs.tempoDeDoencaDias.$refs.input.value || 0

    if (anos > 50) return false
    if (meses > 11) return false
    if (dias > 30) return false

    const response = anos !== 0 || meses !== 0 || dias !== 0
    return response
  }

  isGreaterThanZero(v: any) {
    const num: any = parseInt(v, 10)
    return Number.isNaN(num) || num < 1 ? 'Campo obrigatório.' : false
  }

  configureAuthorizationTabCpfRules() {
    const { formulario } = this.getSolicitacaoCirurgiaStore.currentTemplate

    // Limpa as regras existentes
    this.firstStepAuthorizationTabFormRules.cpf = []

    // SEMPRE valida o formato do CPF se o campo tiver valor
    this.firstStepAuthorizationTabFormRules.cpf.push(
      v => !v || this.isCpfAnonymized ? true : this.validarCPF(v) || 'Informe um CPF válido',
    )

    // Se o campo está em guiaMedicaFields e não tem configuração no template,
    // aplica comportamento padrão (obrigatório)
    if (this.guiaMedicaFields.includes('cpfGuiaAutorizacao')
        && (!formulario || !formulario.cpfGuiaAutorizacao)) {
      this.firstStepAuthorizationTabFormRules.cpf.push(
        (v: any) => !!v || 'Campo obrigatório',
      )
      return
    }

    // Se tem configuração no template, adiciona obrigatoriedade se necessário
    if (formulario && formulario.cpfGuiaAutorizacao) {
      if (formulario.cpfGuiaAutorizacao.obrigatorio
          || formulario.cpfGuiaAutorizacao.obrigatorioParaTodosOsConvenios
          || formulario.cpfGuiaAutorizacao.obrigatorioParaConvenioParticular) {
        this.firstStepAuthorizationTabFormRules.cpf.push(
          (v: any) => !!v || 'Campo obrigatório',
        )
      }
    }
  }

  stepperRules(fields: string[], stepperRuleName: string) {
    if (this.getSolicitacaoCirurgiaStore.currentTemplate.formulario) {
      Object.entries(fields).forEach(([key, value]) => {
        this[stepperRuleName][value] = []
        const { rules } = this.getSolicitacaoCirurgiaStore.currentTemplate.formulario[value] || []
        if (this.getSolicitacaoCirurgiaStore.currentTemplate.formulario[value] && rules && rules.length > 0) {
          rules.forEach((e: any, index: number): void => {
            if (e.includes('obrigatorio')) {
              if (value === 'tempoDeDoenca') {
                this[stepperRuleName][value].push(v => this.validarTempoDeDoenca(v) || 'Digite um período válido.')
              } else if (['diaria', 'diariaUti'].includes(value)) {
                this[stepperRuleName][value].push(v => this.isGreaterThanZero(v))
              } else if (value === 'peso') {
                this[stepperRuleName][value].push((v: any) => this.validatePesoObrigatorio(v))
              } else if (value === 'altura') {
                this[stepperRuleName][value].push((v: any) => this.validateAlturaObrigatorio(v))
              } else if (value === 'tipoAnestesia') {
                this[stepperRuleName][value].push(v => !this.validateTipoAnestesia(v) || 'Campo obrigatório.')
              } else if (value === 'tempoCirurgia') {
                this[stepperRuleName][value].push(v => +v >= 15 || 'Campo obrigatório')
              } else if (value === 'horasDeAntecedenciaDeInternacao') {
                this[stepperRuleName][value].push(v => this.isGreaterThanZero(v))
              } else if (['marcapasso', 'testeCovid', 'reoperacao', 'alergiaContraste', 'pacienteB24Positivo', 'pacienteEhTestemunhaDeJeova', 'pacienteEhDiabetico', 'classificacaoPacienteOncologico', 'gemelar'].includes(value)) {
                this[stepperRuleName][value].push(v => ![null, undefined].includes(v) || 'Campo obrigatório')
              } else if (value === 'idadeGestacional') {
                this[stepperRuleName][value].push(v => (typeof v === 'number') || 'Campo obrigatório.')
              } else {
                this[stepperRuleName][value].push(v => !!v || 'Campo obrigatório.')
              }
            } else if (e.includes('minimo')) {
              const required = rules.includes('obrigatorio')
              const params: any[] = e.split(':')

              if (required) {
                this[stepperRuleName][value].push(v => (v && v.length >= params[1]) || `O campo deve conter no minímo ${params[1]} caracteres.`)
              } else {
                this[stepperRuleName][value].push(v => (!v || (v && v.length >= params[1])) || `O campo deve conter no minímo ${params[1]} caracteres.`)
              }
            } else if (e.includes('maximo')) {
              const required = rules.includes('obrigatorio')
              const params: any[] = e.split(':')

              if (required) {
                this[stepperRuleName][value].push(v => (v && v.length <= params[1]) || `O campo deve conter no máximo ${params[1]} caracteres.`)
              } else {
                this[stepperRuleName][value].push(v => (!v || (v && v.length <= params[1])) || `O campo deve conter no máximo ${params[1]} caracteres.`)
              }
            } else if (e.includes('radio')) {
              this[stepperRuleName][value].push(v => v === true || v === false || 'Campo obrigatório.')
            } else {
              // eval() removido (CSP sem 'unsafe-eval'). Para argumento não-string,
              // eval(x) retornava o próprio x — a regra global já é a função em si.
              // eslint-disable-next-line
              this[stepperRuleName][value].push((window as any)[`${e}`])
            }
          })
        }
      })
    }

    if (this.documentacaoObrigatoriaDoPaciente) {
      ['cpfResponsavel', 'rne', 'livro', 'folha', 'termo'].map((f) => {
        this[stepperRuleName][f] = []
        this[stepperRuleName][f].push(v => !!v || 'Campo obrigatório')
        if (f === 'cpfResponsavel') this[stepperRuleName][f].push(v => this.isCpfAnonymized ? true : this.validarCPF(v) || 'Informe um CPF válido')
        return f
      })
    }

    if (this[stepperRuleName].marcapasso
      && this[stepperRuleName].marcapasso.length > 0
        && typeof this.solicitacaoCirurgia.marcapasso === 'boolean') {
      this.secondStepperRules.marcapasso.splice(0, this.secondStepperRules.marcapasso.length)
    }

    if (this[stepperRuleName].testeCovid
      && this[stepperRuleName].testeCovid.length > 0
        && typeof this.solicitacaoCirurgia.testeCovid === 'boolean') {
      this.secondStepperRules.testeCovid.splice(0, this.secondStepperRules.testeCovid.length)
    }

    if (this[stepperRuleName].pacienteB24Positivo
      && this[stepperRuleName].pacienteB24Positivo.length > 0
        && typeof this.solicitacaoCirurgia.pacienteB24Positivo === 'boolean') {
      this.secondStepperRules.pacienteB24Positivo.splice(0, this.secondStepperRules.pacienteB24Positivo.length)
    }

    if (this[stepperRuleName].pacienteEhTestemunhaDeJeova
      && this[stepperRuleName].pacienteEhTestemunhaDeJeova.length > 0
        && typeof this.solicitacaoCirurgia.pacienteEhTestemunhaDeJeova === 'boolean') {
      this.secondStepperRules.pacienteEhTestemunhaDeJeova.splice(0, this.secondStepperRules.pacienteEhTestemunhaDeJeova.length)
    }

    if (this[stepperRuleName].pacienteEhDiabetico
      && this[stepperRuleName].pacienteEhDiabetico.length > 0
        && typeof this.solicitacaoCirurgia.pacienteEhDiabetico === 'boolean') {
      this.secondStepperRules.pacienteEhDiabetico.splice(0, this.secondStepperRules.pacienteEhDiabetico.length)
    }

    if (this[stepperRuleName].reoperacao
      && this[stepperRuleName].reoperacao.length > 0
        && typeof this.solicitacaoCirurgia.reoperacao === 'boolean') {
      this.secondStepperRules.reoperacao.splice(0, this.secondStepperRules.reoperacao.length)
    }

    if (this[stepperRuleName].equipeMedica
      && this[stepperRuleName].equipeMedica.length > 0
        && typeof this.solicitacaoCirurgia.temEquipeMedica === 'boolean') {
      this.secondStepperRules.equipeMedica.splice(0, this.secondStepperRules.equipeMedica.length)
    }
  }

  rotaConfiguracao() {
    EventBus.$emit('setLoadingRequest', { status: this.getRequestMessage.status, text: this.getRequestMessage.init.text })

    if (this.$route.params.medicoId) {
      this.getSolicitacaoCirurgiaStore.setMedicoSolicitanteId(this.$route.params.medicoId)
    }

    if (this.$route.params.medico) {
      this.solicitacaoCirurgia.medicoSolicitante.id = this.$route.params.medicoId
      this.solicitacaoCirurgia.medicoSolicitante.nome = this.$route.params.medico
    }

    if (this.$route.params.hospitalId) {
      this.getSolicitacaoCirurgiaStore.setHospitalId(this.$route.params.hospitalId)
    }

    if (this.$route.params.solicitacaoId) {
      this.getSolicitacaoCirurgiaStore.setSolicitacaoId(this.$route.params.solicitacaoId)
    }

    if (this.$route.query.editModelMode) {
      this.editModelMode = true
    }

    if (this.$route.query.budgetMode) {
      this.budgetMode = true
    }
  }

  rghNaoFoiAlterado(value: string | null) {
    if (this.tipoDocumentoBuscaPaciente === TipoDocumentoBuscaPacienteEnum.RGH) {
      return value === this.rghNaoAlterado
    }

    return true
  }

  async searchPatient(value, field) {
    try {
      if (!value || (field === TipoDocumentoBuscaPacienteEnum.CPF && !validateCPF(value))) return

      if ((field === TipoDocumentoBuscaPacienteEnum.NOME
          || field === TipoDocumentoBuscaPacienteEnum.CPF
          || field === TipoDocumentoBuscaPacienteEnum.CARTEIRINHA) && value) {
        EventBus.$emit('setLoadingRequest', { status: this.getRequestMessage.status, text: this.getRequestMessage.search })

        this.loadingSearchPatient = true

        const getPatientInfoAPIResponse = await this.getSolicitacaoCirurgiaStore.getPacienteInfo({ documento: value, tipoDocumentoBuscaPaciente: field, convenioId: this.patientData.convenioId })

        if (getPatientInfoAPIResponse.success) {
          // Controla desabilitação baseada no autopreenchimento
          if (this.patientHasSomeContactInformation) {
            this.disabledPatientContactInformationFields = true
          } else {
            this.disabledPatientContactInformationFields = false
          }

          const { paciente } = getPatientInfoAPIResponse.data
          this.disabledPatientCpfField = ('carteirinha' in paciente && !!paciente.carteirinha) && ('cpf' in paciente && !!paciente.cpf)
          this.disabledPatientCarteirinhaField = ('cpf' in paciente && !!paciente.cpf) && ('carteirinha' in paciente && !!paciente.carteirinha)
          this.$nextTick(() => {
            this.$forceUpdate()
          })
        } else {
          if (getPatientInfoAPIResponse.data && getPatientInfoAPIResponse.data === 'DO_NOTHING') {
            this.loadingSearchPatient = false
            EventBus.$emit('clearLoadingRequest')
            return
          }

          if (getPatientInfoAPIResponse.data && getPatientInfoAPIResponse.data === 'CLEAR_CPF') {
            this.getSolicitacaoCirurgiaStore.setPacienteField({ field: 'cpf', value: '' })
          }

          EventBus.$emit('setSnackbar', { show: true, text: getPatientInfoAPIResponse.message || 'Não foi posível buscar dados do paciente', icon: 'warning', color: '#C62828' })
        }
      }
    } catch (error) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Erro ao buscar paciente', icon: 'warning', color: '#C62828' })
    } finally {
      this.loadingSearchPatient = false
      EventBus.$emit('clearLoadingRequest')
    }
  }

  async getInfoFromDocumento(event: any) {
    if (this.documentacaoObrigatoriaDoPaciente && this.solicitacaoCirurgia.paciente.id && this.rghNaoFoiAlterado(event.target.value)) {
      return
    }

    if ((this.tipoDocumentoBuscaPaciente === TipoDocumentoBuscaPacienteEnum.CPF && event.target.value.length === 14)
      || (this.tipoDocumentoBuscaPaciente === TipoDocumentoBuscaPacienteEnum.RGH && event.target.value.length)) {
      EventBus.$emit('setLoadingRequest', { status: this.getRequestMessage.status, text: this.getRequestMessage.search })
      this.loadingCPF = true
      const result = await this.getSolicitacaoCirurgiaStore.getPacienteInfo({ documento: event.target.value, tipoDocumentoBuscaPaciente: this.tipoDocumentoBuscaPaciente })

      if (this.tipoDocumentoBuscaPaciente === TipoDocumentoBuscaPacienteEnum.RGH && event.target.value.length && !result.data.paciente) {
        this.loadingCPF = false
        EventBus.$emit('clearLoadingRequest')
        this.dialogMsgRghNaoEncontrado = 'RGH informado não encontrado. Favor informar um CPF válido, ou realizar a busca do paciente informando CPF ou nome / data de nascimento.'
        this.dialogRghNaoEncontrado = true
        return
      }

      this.rghNaoAlterado = result.data.paciente ? result.data.paciente.rgh : null

      this.loadingCPF = false


      EventBus.$emit('clearLoadingRequest')
    }
  }

  get getReservaSalaStore() {
    return getModule(ReservaSalaStore, this.$store)
  }

  async getTemplateFormulario() {
    const { hospitalId } = this.solicitacaoCirurgia
    const response = await this.getSolicitacaoCirurgiaStore.getTemplateHospital(hospitalId)
    if (response.success) this.getSolicitacaoStore.setTemplateFormulario(JSON.parse(response.data.template))
  }

  async getHospital() {
    const { hospitalId } = this.solicitacaoCirurgia
    const response = await this.getSolicitacaoCirurgiaStore.getHospitalById(hospitalId)
    return response
  }

  async getNecessidadesEspeciais(hospitalId: string) {
    const { formulario } = this.getSolicitacaoCirurgiaStore.currentTemplate
    if (formulario && formulario.necessidadesEspeciais && formulario.necessidadesEspeciais.habilitado) {
      const response = await this.getSolicitacaoCirurgiaStore.getNecessidadesEspeciaisHospital(hospitalId)
      return response
    }
    return undefined
  }

  async getRestricoesReligiosas(hospitalId: string) {
    const { formulario } = this.getSolicitacaoCirurgiaStore.currentTemplate
    if (formulario && formulario.restricaoReligiosa && formulario.restricaoReligiosa.habilitado) {
      const response = await this.getSolicitacaoCirurgiaStore.getRestricaoReligiosaHospital(hospitalId)
      return response
    }
    return undefined
  }

  async fetchCentroCirurgico() {
    const params = {
      solicitacaoId: this.getSolicitacaoCirurgiaStore.solicitacaoCirurgia.id,
      data: moment().format('YYYY-MM-DD'),
      tempoCirurgia:
        this.getSolicitacaoCirurgiaStore.solicitacaoCirurgia.tempoCirurgia,
      isDoctor: false,
    }
    await this.getReservaSalaStore.getReservaSalas(params)
  }

  openUploadRecommendationModal(delay = 0) {
    setTimeout(() => {
      this.isUploadRecommendationModalOpen = true
    }, delay)
  }

  closeUploadRecommendationModal() {
    this.isUploadRecommendationModalOpen = false
  }

  showAvaliacaoPreOperatoriaModal() {
    if ((this.getRecursosHospitalaresStore.ResourceAccess || this.solicitacaoCirurgia.apa) && this.solicitacaoCirurgia.carater === 'EletivoAutorizacao' && this.validarCelular(this.solicitacaoCirurgia.paciente.celular || '')) {
      return true
    }
    return false
  }

  openFileTypeWarningModal(delay = 0) {
    setTimeout(() => {
      this.isFileTypeWarningModalOpen = true
    }, delay)
  }

  closeFileTypeWarningModal() {
    this.isFileTypeWarningModalOpen = false
  }

  openSurgeryGridModal(delay = 0) {
    setTimeout(() => {
      this.isSurgeryGridModalOpen = true
    }, delay)
  }

  openRoomSchedulingModal(delay = 0) {
    setTimeout(() => {
      this.isRoomSchedulingModalOpen = true
      this.fetchCentroCirurgico()
    }, delay)
  }

  closeSurgeryGridModal() {
    this.isSurgeryGridModalOpen = false
  }

  closeRoomSchedulingModal() {
    this.isRoomSchedulingModalOpen = false
  }

  checkConvenioIsParticular() {
    const convenioId = this.solicitacaoCirurgia.paciente && this.solicitacaoCirurgia.paciente.convenioId

    if (convenioId) {
      const convenio = this.getSolicitacaoCirurgiaStore.convenios.find((e: any) => e.id === convenioId)
      if (convenio) {
        this.isConvenioParticular = convenio.particular
        return convenio!.particular
      }
    }

    return false
  }

  async addCaixaCirurgica() {
    this.loadingAddCaixaCirurgica = true
    const response = await this.getSolicitacaoCirurgiaStore.getAllCaixasCirurgicasByHospitalId()
    if (response.success) {
      this.getSolicitacaoCirurgiaStore.setModal({ name: 'caixaCirurgica', value: true })
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message, icon: 'warning', color: '#C62828' })
    }
    this.loadingAddCaixaCirurgica = false
  }

  async removeCaixaCirurgica(item: any) {
    this.loadingDeleteCaixaCirurgica = item.id
    const response = await this.getSolicitacaoCirurgiaStore.deleteCaixaCirurgicaBySolicitacaoId(item.id)
    if (!response.success) EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Ocorreu um erro ao apagar a caixa cirúrgica.', icon: 'warning', color: '#C62828' })
    this.loadingDeleteCaixaCirurgica = ''
  }

  get isSurgeryDetailsPage() {
    return this.$route.path.includes('/solicitacao-cirurgia-details')
  }

  setComorbidadesDoPacienteInformacao(informacao: string, comorbidadeDescricao: string) {
    const comorbidadeIndex = this.getSolicitacaoCirurgiaStore.solicitacaoCirurgia.comorbidadesDoPaciente.findIndex(item => item.descricao === comorbidadeDescricao)
    if (comorbidadeIndex === -1) return
    this.getSolicitacaoCirurgiaStore.solicitacaoCirurgia.comorbidadesDoPaciente[comorbidadeIndex].informacao = informacao
  }

  comorbidadesDoPacienteChange(comorbidade) {
    const comorbidadeIndex = this.getSolicitacaoCirurgiaStore.solicitacaoCirurgia.comorbidadesDoPaciente.findIndex(item => item.descricao === comorbidade.descricao)
    if (comorbidadeIndex !== -1) {
      this.getSolicitacaoCirurgiaStore.solicitacaoCirurgia.comorbidadesDoPaciente.splice(comorbidadeIndex, 1)
    } else {
      this.getSolicitacaoCirurgiaStore.solicitacaoCirurgia.comorbidadesDoPaciente.push({ comorbidadeId: comorbidade.id, descricao: comorbidade.descricao, informacao: '' })
    }
    this.$forceUpdate()
  }

  onChangeNomeAnestesista() {
    if (this.solicitacaoCirurgia.nomeAnestesista) {
      this.outroAnestesista = this.solicitacaoCirurgia.nomeAnestesista
      this.solicitacaoCirurgia.anestesista = 'Outros'
    }
  }

  async loadAnestesista() {
    const loadAnestesistaPayload = {
      qtdPorPagina: 5,
      searchText: '',
      tipo: 'clinica',
      hospitalId: this.solicitacaoCirurgia.hospitalId,
    }
    try {
      this.onChangeNomeAnestesista()
      const request = await Apis.Agendamento.SolicitacaoCirurgiaApi.getAllAnestesistas(loadAnestesistaPayload)
      const data = request.data || []
      if (data.anestesistas && data.anestesistas.length > 0) {
        this.getSolicitacaoCirurgiaStore.setAnestesistasHospital(data.anestesistas)
        data.anestesistas.forEach((anestesista: AnestesistaHospital) => {
          this.anestesistasOptions.push({ ...anestesista } as AnestesistaHospital)
          if (this.solicitacaoCirurgia.anestesista && typeof this.solicitacaoCirurgia.anestesista !== 'string') {
            const anestesistaId = this.solicitacaoCirurgia.anestesista.id
            if (anestesista.id === anestesistaId) {
              this.solicitacaoCirurgia.anestesista = { ...anestesista } as AnestesistaHospital
            }
          }
        })
      }
    } catch (error) {
      console.log(error)
    }
  }

  async init() {
    // Template do formulário...
    const { formulario } = this.getSolicitacaoCirurgiaStore.currentTemplate

    // Injeta a solicitacaoStore na solicitacaoCirurgiaStoreMiddleware
    solicitacaoStoreMiddleware.solicitacaoStore = this.getSolicitacaoStore

    if (this.isSurgeryDetailsPage || this.budgetMode || this.editModelMode) {
      this.getSolicitacaoCirurgiaStore.setCanSuggestProtocol(false)
    }

    await this.getSolicitacaoCirurgiaStore.getAllConvenio({ somenteParticulares: !!this.budgetMode })

    await this.getSolicitacaoCirurgiaStore.getCentroCirurgico()

    if (formulario.nacionalidade && formulario.nacionalidade.habilitado) await this.getSolicitacaoCirurgiaStore.getPaisAllWithHisId()

    // Set ids para funcionar as modais da solicitacao store
    this.getSolicitacaoStore.setHospitalId(this.solicitacaoCirurgia.hospitalId)
    this.getSolicitacaoStore.setMedicoId(this.solicitacaoCirurgia.medicoSolicitanteId)
    this.getSolicitacaoStore.setSolicitacaoId(this.solicitacaoCirurgia.id)

    await this.setTipoDocumentoBuscaPacienteByTemplate()
    await this.getSolicitacaoCirurgiaStore.getAllPlanos()

    if (this.getSolicitacaoCirurgiaStore.solicitacaoCirurgia.hospital.utilizaTipoAcomodacaoHospital
      && ((formulario.tipoAcomodacao && formulario.tipoAcomodacao.habilitado) || (formulario.tipoAcomodacaoBudgetMode && formulario.tipoAcomodacaoBudgetMode.habilitado))
    ) {
      await this.getSolicitacaoCirurgiaStore.getAllTipoAcomodacao()
    }

    const isNew = this.getSolicitacaoCirurgiaStore.solicitacaoCirurgia.id.includes('new')

    if (!isNew) {
      const response = await this.getSolicitacaoCirurgiaStore.getSolicitacaoById(this.solicitacaoCirurgia.id)

      if (response.success) {
        if (this.surgerySolicitationActions.canSuggestProtocolOnSurgeryInitialization
          && this.getSolicitacaoCirurgiaStore.canSuggestProtocol) {
          // Verifica se a cirurgia tem protocolo e não foi respondido nada
          // Trata exatamente dos casos em que uma cirurgia foi criada a partir de um modelo de cirurgia
          this.getSolicitacaoCirurgiaStore.checkExistProtocoloParaOProcedimentoAoCarregarSolicitacao()
        }

        if (this.getSolicitacaoCirurgiaStore.selectedProtocolo) {
          kitOpmeStore.processarKitsProtocolo(this.getSolicitacaoCirurgiaStore.selectedProtocolo)
        }
        this.getSolicitacaoStore.setProcedimentoPrincipal(response.data.procedimento)
        this.getSolicitacaoStore.setProcedimentoAssociados(response.data.procedimentosAssociados)
        const { paciente } = this.getSolicitacaoCirurgiaStore.solicitacaoCirurgia

        this.getSolicitacaoStore.setPaciente(paciente)


        const promises = [
          this.getSolicitacaoCirurgiaStore.setFirstStep(false),
          this.getSolicitacaoCirurgiaStore.clearCategorias(),
          this.getSolicitacaoStore.loadEquipamentos(),
          this.getSolicitacaoCirurgiaStore.loadDocumentosObrigatorios(),
          this.getSolicitacaoStore.loadAllCidBySolicitacaoId(),
          this.getSolicitacaoCirurgiaStore.getReservaHemocomponente(),
          this.getSolicitacaoCirurgiaStore.loadFornecedores(),
          this.getSolicitacaoCirurgiaStore.getMedicoOpme(),
        ]

        if (paciente && paciente.planoId) {
          promises.push(this.getSolicitacaoCirurgiaStore.getAllCategoriasByPlano(paciente.planoId))
          this.rghNaoAlterado = paciente.rgh
        }

        if (formulario.anestesiaHospital.habilitado && this.opcaoHabilitado('anestesiaHospital', 'hospitalUtilizaClinicasDeAnestesia')) {
          this.loadAnestesista()
        }

        await Promise.all(promises)

        // Lógica do Médico Executante
        if (!this.isSurgeryDetailsPage && this.hospitalUtilizaRegraDeMedicoExecutante) {
          if (this.medicoPrescritorEhConfiguradoParaExecutarCirurgias && this.solicitacaoCirurgia.medicoPrescritor) {
            this.solicitacaoCirurgia.medicoSolicitanteId = this.solicitacaoCirurgia.medicoPrescritor.id
            this.solicitacaoCirurgia.medicoSolicitante.id = this.solicitacaoCirurgia.medicoPrescritor.id
            this.solicitacaoCirurgia.medicoSolicitante.nome = this.solicitacaoCirurgia.medicoPrescritor.nome
          } else {
            this.solicitacaoCirurgia.medicoSolicitanteId = ''
            this.solicitacaoCirurgia.medicoSolicitante.id = ''
            this.solicitacaoCirurgia.medicoSolicitante.nome = ''
          }
        }

        await Promise.all(promises)

        // if (!this.isSurgeryDetailsPage && this.campoHabilitado('medicoExecutante')) {
        //   await this.fetchDoctors()
        //   const medico = this.doctors.find(d => d.id === this.solicitacaoCirurgia.medicoSolicitanteId)
        //   if (!medico) {
        //     this.medicoSolicitanteObrigatorio = true
        //     this.solicitacaoCirurgia.medicoSolicitanteId = ''
        //     this.solicitacaoCirurgia.medicoSolicitante.id = ''
        //     this.solicitacaoCirurgia.medicoSolicitante.nome = ''
        //   } else {
        //     this.medicoSolicitanteObrigatorio = false
        //   }
        // }

        if (this.getSolicitacaoCirurgiaStore.currentTemplate.formulario.reservaDeSangue.obrigatorio) {
          this.getReservaDeSangueStore.getReservaDeSangue(this.solicitacaoCirurgia.id)
        }

        /*
         *****************************************************************
         * Busca todos os anexos por tipo habilitado
         */
        const tipoDocumento: any = {
          anexos: false,
          documentacaoPaciente: false,
          documentosDiversos: false,
          termoDeConsentimento: false,
          orcamentoDeCirurgiaParticularAprovado: this.checkConvenioIsParticular(),
        }

        Object.entries(tipoDocumento).forEach(([key, value]) => {
          if (formulario[key] && formulario[key].habilitado) tipoDocumento[key] = true
        })

        await this.getSolicitacaoCirurgiaStore.loadAllDocumentsByType(tipoDocumento)

        /*
         *****************************************************************
         */

        this.pacienteNaoPossuiCpfChange(false)
        this.validatePlanoCategoriaTipoAcomodacao()

        this.suggestedEquipments = this.getSolicitacaoStore.equipamentosSugeridos

        this.checkConvenioIsParticular()

        // Listen changes in changeProcedimento
        EventBus.$on('changeProcedimento', (value: 'procedimentoPrincipal' | 'procedimentoAssociado') => {
          this.resetSuggestedEquipments()
          this.getSolicitacaoCirurgiaStore.loadDocumentosObrigatorios()
          if (value === 'procedimentoPrincipal') this.handleTecnicaDoProcedimento()
        })

        await this.refreshInvalidSchedulingDatesForCurrentSelection()
      }

      if (typeof this.solicitacaoCirurgia.temEquipeMedica === 'boolean') {
        if (this.solicitacaoCirurgia.temEquipeMedica) {
          this.hasSurgeryTeam = '1'
        } else {
          this.hasSurgeryTeam = '0'
        }
      }
    } else if (this.budgetMode) {
      if (this.getSolicitacaoCirurgiaStore.solicitacaoCirurgia.hospital.utilizaTipoAcomodacaoHospital && this.campoHabilitado('tipoAcomodacaoBudgetMode')) {
        await this.getSolicitacaoCirurgiaStore.getAllTipoAcomodacao()
      }

      this.getSolicitacaoCirurgiaStore.setFirstStep(false)
      this.getSolicitacaoCirurgiaStore.loadFornecedores()
    }

    EventBus.$emit('clearLoadingRequest')
  }

  handleTecnicaDoProcedimento() {
    if (
      !!this.tecnicasDisponiveis.length
      && !this.getSolicitacaoCirurgiaStore.canShowProtocoloDeCirurgiaFields
      && this.solicitacaoCirurgia.procedimento
      // && !!this.solicitacaoCirurgia.procedimento.exigeTecnica
      && this.secondStepperRules.tecnicaDoProcedimento.length < 1
    ) {
      this.secondStepperRules.tecnicaDoProcedimento.push((v: any) => !!v || 'Campo obrigatório')
    } else {
      this.secondStepperRules.tecnicaDoProcedimento.splice(0, this.secondStepperRules.tecnicaDoProcedimento.length)
    }
  }

  async created() {
    this.finishedLoad = false

    const { medicoId, hospitalId } = this.$route.params

    this.rotaConfiguracao()

    await useHospitais.loadHospitaisByCurrentUser()
    await this.getTemplateFormulario()
    await this.getHospital()
    await this.templateConfiguracao()
    await this.getSolicitacaoCirurgiaStore.getAllLocalAtendimento({ medicoSolicitanteId: medicoId, hospitalId })
    await this.fetchMedicosExecutantes()
    await this.getNecessidadesEspeciais(hospitalId)
    await this.getRestricoesReligiosas(hospitalId)
    await this.init()

    if (this.solicitacaoCirurgia.hospital.hospitalIntegraComAutorizadorAntesDaReserva
      && !!this.patientHealthInsuranceData && this.patientHealthInsuranceData.autorizadorTipo === 'Totvs') {
      this.authorizationTab = true
      this.step = 0
      this.disabledPatientContactInformationFields = true
    }

    // Call templateConfiguracao again after Init to check for convenio changes
    // Needs call because the template can change based in selected convenio
    await this.templateConfiguracao()

    if (this.campoHabilitado('equipeMedica')
      && this.opcaoHabilitado('equipeMedica', 'dadosDoConselho')
      && this.solicitacaoCirurgia.temEquipeMedica) {
      if (!this.doctorsSurgeryTeam || this.doctorsSurgeryTeam.length === 0) {
        this.addDoctorToSurgeryTeam()
      }
    }

    this.finishedLoad = true
  }

  async mounted() {
    EventBus.$on('saveOrUpdateSecondStep', this.saveOrUpdateSecondStep)
    EventBus.$on('updateTecnicasDisponiveis', (value: any[]) => this.getSolicitacaoStore.setTecnicasDisponiveis(value))
  }

  beforeDestroy() {
    this.getHemocomponentes = []
    this.getSolicitacaoCirurgiaStore.clearReservaHemocomponentes()
    this.getSolicitacaoCirurgiaStore.clearSolicitacaoCirurgia()
    this.getReservaDeSangueStore.clearReservaDeSangue()
    this.getSolicitacaoCirurgiaStore.clearLaudos()
    this.getSolicitacaoCirurgiaStore.clearLaudosPaciente()
    this.getSolicitacaoCirurgiaStore.clearLaudosDiversos()
    this.getSolicitacaoCirurgiaStore.clearLaudosTermoDeConsentimento()
    this.getSolicitacaoCirurgiaStore.setHospitalNome('')
    this.getSolicitacaoStore.clearSolicitacao()
    this.getSolicitacaoCirurgiaStore.clearCaixasCirurgicasApi()
    this.getSolicitacaoStore.clearTemplateFormulario()
    this.getSolicitacaoCirurgiaStore.clearDoctors()
    this.getSolicitacaoCirurgiaStore.clearTipoAcomodacaoItems()
    this.getSolicitacaoCirurgiaStore.setCanSuggestProtocol(true)
    this.getSolicitacaoCirurgiaStore.clearConvenios()
    this.getSolicitacaoCirurgiaStore.clearPlanos()
    this.getSolicitacaoCirurgiaStore.clearCategorias()
    this.getSolicitacaoCirurgiaStore.clearConveniosAssociados()
    this.getSolicitacaoCirurgiaStore.clearPlanosAssociados()
    this.getSolicitacaoCirurgiaStore.clearCategoriasAssociadas()
    this.getComorbidadesDoPaciente = []
    this.getRecursosHospitalaresStore.clearResourceAccess()

    EventBus.$off('changeProcedimento')

    // Limpa os campos de quantidades das reservas de hemocomponentes...
    if (this.$refs.concentradoHemaciasQtde) this.$refs.concentradoHemaciasQtde.lazyValue = 0
    if (this.$refs.concentradoPlaquetasQtde) this.$refs.concentradoPlaquetasQtde.lazyValue = 0
    if (this.$refs.crioprecipitadoQtde) this.$refs.crioprecipitadoQtde.lazyValue = 0
    if (this.$refs.plasmaFrescoCongeladoQtde) this.$refs.plasmaFrescoCongeladoQtde.lazyValue = 0
    if (this.$refs.tipagemSanguineaABORHPAIQtde) this.$refs.tipagemSanguineaABORHPAIQtde.lazyValue = 0
  }

  @Watch('menu')
  onMenuChange(val: any) {
    // eslint-disable-next-line
    val && setTimeout(() => (this.$refs.picker['activePicker'] = 'YEAR'))
  }

  @Watch('menu2')
  onMenu2Change(val: any) {
    // eslint-disable-next-line
    val && setTimeout(() => (this.$refs.picker2['activePicker'] = 'YEAR'))
  }

  @Watch('birthDateFieldAuthorizationTabMenu')
  onBirthDateFieldAuthorizationTabMenuChange(val: any) {
    // eslint-disable-next-line
    val && setTimeout(() => (this.$refs.picker2['activePicker'] = 'YEAR'))
  }

  @Watch('step')
  async onStepChange(Step: string) {
    const cods = this.getValidationCodTuss()
    if (Number(Step) === 2 && !this.step1Disabled && cods !== this.lastValidationCodTuss) {
      this.lastValidationCodTuss = cods
      await this.canShowResourceApa()
    }
  }

  private getValidationCodTuss() {
    const { procedimento: principal, procedimentosAssociados } = this.getSolicitacaoCirurgiaStore.solicitacaoCirurgia
    const associados = procedimentosAssociados || []
    const cods: string[] = []

    if (principal && principal.codigo) {
      cods.push(principal.codigo)
    }
    associados.forEach((e: Procedimento) => {
      if (e.codigo) {
        cods.push(e.codigo)
      }
    })
    return cods.sort().join(',')
  }

  get pageTitle() {
    if (this.editModelMode) {
      return 'Cirurgia Favorita'
    }

    if (this.budgetMode) {
      return 'Orçamento particular'
    }

    return 'Solicitação de Cirurgia'
  }

  get exigeLateralidadeEmTodosOsProcedimentos() {
    if (!this.editModelMode) {
      // Deixa a lateralidade sempre como obrigatória caso não seja edit model mode
      // Implementado porque alguns procedimentos carregados na base não informavam necessidade de lateralidade
      // Então para evitar erros, foi colocado como obrigatório
      return true
    }

    return false

    // Regra antiga
    // return this.getTemplate
    //   && this.getTemplate.lateralidade
    //   && this.getTemplate.lateralidade.exigeLateralidadeEmTodosOsProcedimentos
  }

  get tecnicasDisponiveis() {
    return this.getSolicitacaoStore.tecnicasDisponiveis
  }

  get patientHasHisId() {
    return !!this.patientData.hisId
  }

  get doctorsSurgeryTeam() {
    return this.solicitacaoCirurgia.equipeCirurgica
  }

  set doctorsSurgeryTeam(doctorData) {
    this.solicitacaoCirurgia.equipeCirurgica = doctorData
  }

  addDoctorToSurgeryTeam() {
    this.doctorsSurgeryTeam!.push({ conselhoTipo: '', conselhoUf: '', conselhoNumero: '', medicoNome: '' })
  }

  deleteDoctorFromSurgeryTeam(index) {
    this.doctorsSurgeryTeam!.splice(index, 1)
  }

  pacienteCpfChange() {
    if (this.solicitacaoCirurgia.paciente.id && this.solicitacaoCirurgia.paciente.cpf!.length < 11) {
      this.getSolicitacaoCirurgiaStore.resetPaciente()
    }
  }

  pacienteRghChange() {
    if (this.solicitacaoCirurgia.paciente.id && !this.rghNaoFoiAlterado(this.solicitacaoCirurgia.paciente.rgh)) {
      this.getSolicitacaoCirurgiaStore.resetPacienteMantendoRGH()
    }
  }

  tipoAnestesiaChange(value: string) {
    if (!this.getSolicitacaoCirurgiaStore.currentTemplate.formulario.tipoAnestesia.multiSelecao) {
      if (!this.getSolicitacaoCirurgiaStore.tipoAnestesiaCheckbox.includes(value)) {
        this.getSolicitacaoCirurgiaStore.clearTipoAnestesia()
      } else {
        this.getSolicitacaoCirurgiaStore.clearTipoAnestesia()
        this.getSolicitacaoCirurgiaStore.tipoAnestesiaCheckbox.push(value)
      }
      this.clearOutrosTipoAnestesia()
    } else if (value === 'Outros' && !this.getSolicitacaoCirurgiaStore.tipoAnestesiaCheckbox.includes(value)) {
      this.clearOutrosTipoAnestesia()
    }
  }

  async onAttendancePlaceChange() {
    await this.getSolicitacaoCirurgiaStore.getModeloCirurgia()
    await this.getSolicitacaoCirurgiaStore.loadProtocoloOptions()
  }

  clearOutrosTipoAnestesia() {
    this.getSolicitacaoCirurgiaStore.outrosTipoAnestesia = null
  }

  capitalizeFirstLetter(string: string) {
    return string.charAt(0).toUpperCase() + string.slice(1)
  }

  isAcCamargo(value: string = '') {
    return acCamargoNetwork(`${value}`)
  }
}

